<template>
  <div class="page">
    <div class="top">
      <van-search
        v-model="keyword"
        placeholder="搜索学员姓名/家长姓名/手机号/备注"
        shape="round"
        style="padding-bottom: 0"
        @search="onSearch"
      />

      <div class="date-filter">
        <div class="date-row">
          <span class="date-label date-label-select" @click="openTimeFilterPicker">
            {{ timeFilterLabel }}<van-icon name="arrow-down" class="date-label-select-icon" />
          </span>
          <span class="date-value" @click="openDateRangePicker">{{ dateRange.startDate || "开始日期" }}</span>
          <span class="date-sep">-</span>
          <span class="date-value" @click="openDateRangePicker">{{ dateRange.endDate || "结束日期" }}</span>
          <span
            v-if="dateRange.startDate || dateRange.endDate"
            class="date-clear"
            @click="clearDateRange"
          >
            清空
          </span>
        </div>
        <div class="date-row">
          <span class="date-label">中心</span>
          <span class="date-value" @click="openTopDepartmentPicker">{{ topDepartmentLabel || "全部中心" }}</span>
          <span v-if="topDepartmentId" class="date-clear" @click="clearTopDepartment">
            清空
          </span>
        </div>
        <div class="date-row">
          <span class="date-label">到店结果</span>
          <span class="date-value" @click="openListCheckInResultFilterPicker">{{ listCheckInResultFilterLabel }}</span>
          <span
            v-if="listCheckInResultFilter !== null && listCheckInResultFilter !== undefined && listCheckInResultFilter !== ''"
            class="date-clear"
            @click="clearListCheckInResultFilter"
          >
            清空
          </span>
        </div>
        <div class="date-row">
          <span class="date-label">开课状态</span>
          <span class="date-value" @click="openListCourseStatusFilterPicker">{{ listCourseStatusFilterLabel }}</span>
          <span
            v-if="listCourseStatusFilter !== null && listCourseStatusFilter !== undefined && listCourseStatusFilter !== ''"
            class="date-clear"
            @click="clearListCourseStatusFilter"
          >
            清空
          </span>
        </div>
      </div>

      <div class="list-total-bar">
        <span class="list-total-text">共 <span class="list-total-num">{{ listTotalRecords }}</span> 条</span>
      </div>
      <van-tabs v-model="statusTab" swipeable @change="onStatusChange">
        <van-tab title="全部" name="all" />
        <van-tab title="待邀约" name="0" />
        <van-tab title="已预约" name="1" />
        <van-tab title="预约未到店" name="expired" />
        <van-tab title="已到店" name="2" />
        <van-tab title="到店结果" name="3" />
        <van-tab title="已成交" name="4" />
        <van-tab title="已开课" name="confirmClass" />
        <van-tab title="已作废" name="5" />
      </van-tabs>
    </div>

    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="loadError"
          error-text="加载失败，点击重试"
          @load="onLoad"
        >
          <div class="records-wrap">
            <van-empty
              v-if="items.length === 0 && !loading && !loadError"
              image="search"
              description="暂无数据"
              class="empty"
            />
            <van-swipe-cell
              v-for="it in items"
              :key="it.id"
              class="student-swipe-cell"
              :disabled="!canSwipeDeleteCancelledStudent(it)"
            >
              <div
                :class="['card', 'booking-card', statusClass(it)]"
                @click="openDetail(it)"
              >
                <div class="booking-card-top">
                  <div class="booking-student">
                    <span class="booking-student-name">{{ it.stuName || "-" }}</span>
                    <span class="booking-student-age" v-if="it.age !== undefined && it.age !== null && it.age !== ''">
                      {{ it.age }}岁
                    </span>
                    <span class="booking-student-gender" v-if="it.genderName">
                      {{ it.genderName }}
                    </span>
                    <span class="booking-student-gender" v-if="it.departmentName">
                      （{{ it.departmentName }}）
                    </span>
                    <span class="booking-student-channel" v-if="it.channelTypeName">
                      {{ it.channelTypeName }}
                    </span>
                  </div>
                  <van-tag type="default" :class="['status-tag', statusClass(it)]">
                    {{ statusText(it) }}
                  </van-tag>
                </div>

                <div class="booking-parent">
                  <span class="booking-parent-label">家长：</span>
                  <span class="booking-parent-name">{{ it.name || "-" }}</span>
                  <span class="booking-parent-sep"> </span>
                  <span class="booking-parent-mobile">{{ it.mobile || "-" }}</span>
                </div>
                <div class="booking-remark" v-if="it.remark">
                  {{ it.remark }}
                </div>
                <div class="booking-remark">
                  试听课程：{{ it.trialCourseName || "-" }}
                </div>
                <div v-if="isFlowStepActive(it, 'arrive')" class="booking-remark">
                  测试CC：{{ formatListHostStaffDisplay(it) }}
                </div>

                <div class="flow-actions" @click.stop>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(it, 'booking') }"
                    @click="openInvite(it)"
                  >
                    邀约
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(it, 'arrive') }"
                    @click="openCheckIn(it)"
                  >
                    到店
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(it, 'deposit') }"
                    @click="openCheckInResult(it)"
                  >
                    到店结果
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(it, 'complete') }"
                    @click="openComplete(it)"
                  >
                    成单
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(it, 'confirmClass') }"
                    @click="openConfirmClass(it)"
                  >
                    开课
                  </button>
                </div>

                <div
                  v-for="(exp, expIdx) in normalizeExpansionList(it)"
                  :key="exp.id || `list-expansion-${it.id}-${expIdx}`"
                  class="list-expansion-block"
                  @click.stop
                >
                  <div class="list-expansion-head">
                    <div class="booking-remark list-expansion-name">
                      拓科：{{ expansionDisplayName(exp, expIdx) }}
                    </div>
                    <van-tag type="default" :class="['status-tag', 'list-expansion-status', statusClass(exp)]">
                      {{ statusText(exp) }}
                    </van-tag>
                  </div>
                  <div v-if="isFlowStepActive(exp, 'arrive')" class="booking-remark">
                    测试CC：{{ formatListHostStaffDisplay(exp) }}
                  </div>
                  <div class="flow-actions list-expansion-flow">
                    <button
                      type="button"
                      class="flow-step"
                      :class="{ active: isFlowStepActive(exp, 'booking') }"
                      @click="openExpansionInvite(it, exp)"
                    >
                      邀约
                    </button>
                    <button
                      type="button"
                      class="flow-step"
                      :class="{ active: isFlowStepActive(exp, 'arrive') }"
                      @click="openExpansionCheckIn(it, exp)"
                    >
                      到店
                    </button>
                    <button
                      type="button"
                      class="flow-step"
                      :class="{ active: isFlowStepActive(exp, 'deposit') }"
                      @click="openExpansionCheckInResult(it, exp)"
                    >
                      到店结果
                    </button>
                    <button
                      type="button"
                      class="flow-step"
                      :class="{ active: isFlowStepActive(exp, 'complete') }"
                      @click="openExpansionComplete(it, exp)"
                    >
                      成单
                    </button>
                    <button
                      type="button"
                      class="flow-step"
                      :class="{ active: isFlowStepActive(exp, 'confirmClass') }"
                      @click="openExpansionConfirmClass(it, exp)"
                    >
                      开课
                    </button>
                  </div>
                </div>
              </div>
              <template v-if="canSwipeDeleteCancelledStudent(it)" #right>
                <van-button
                  square
                  type="danger"
                  text="删除"
                  class="student-delete-swipe-btn"
                  @click.stop="onDeleteCancelledStudent(it)"
                />
              </template>
            </van-swipe-cell>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="bottom-bar">
      <van-button type="primary" block round @click="openBooking">
        新增学员
      </van-button>
    </div>

    <van-popup v-model="checkInResultDialog.show" position="bottom" round :z-index="FLOW_POPUP_Z_INDEX" :style="{ height: '58vh', maxHeight: '85vh' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">到店结果</div>
          <van-icon name="cross" class="popup-close" @click="checkInResultDialog.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitCheckInResult">
            <van-field
              readonly
              clickable
              label="测试CC"
              :value="checkInResultHostStaffLabel"
              placeholder="请选择测试CC"
              @click="openCheckInResultHostPicker"
            />
            <van-field
              readonly
              clickable
              label="到店结果"
              :value="checkInResultLabel"
              placeholder="请选择到店结果"
              @click="openCheckInResultPicker"
              required
              :rules="[{ required: true, message: '请选择到店结果' }]"
            />
            <van-field
              v-model.trim="checkInResultDialog.checkInRemark"
              label="备注"
              type="textarea"
              rows="2"
              autosize
              placeholder="选填"
            />
            <template v-if="Number(checkInResultDialog.checkInResult) === 5">
              <van-field
                v-model="checkInResultDialog.depositAmount"
                label="定金金额"
                placeholder="请输入定金金额"
                type="number"
                required
                :readonly="checkInResultDepositReadonly"
                :class="{ 'field-locked': checkInResultDepositReadonly }"
                :rules="[{ required: true, message: '请输入定金金额' }]"
              >
                <template v-if="checkInResultDepositReadonly" #right-icon>
                  <van-icon name="lock" class="field-lock-icon" />
                </template>
              </van-field>
              <van-field
                readonly
                :clickable="!checkInResultDepositReadonly"
                label="支付方式"
                :value="getPaymentMethodLabel(checkInResultDialog.depositPaymentMethod)"
                placeholder="请选择支付方式"
                required
                :rules="[{ required: true, message: '请选择支付方式' }]"
                @click="onOpenPaymentMethodPicker('checkInResult')"
              />
              <van-field
                readonly
                clickable
                label="项目"
                :value="getProjectLabel(checkInResultDialog.depositProjectId)"
                placeholder="请选择项目（选填）"
                @click="openProjectPicker('checkInResultDeposit')"
              />
              <van-field
                readonly
                clickable
                label="支付时间"
                :value="checkInResultDialog.paidTime"
                placeholder="请选择支付时间"
                required
                :rules="[{ required: true, message: '请选择支付时间' }]"
                @click="paidTimePicker.show = true"
              />
              <van-field class="personal-performance-field" label="成单前是否算个人业绩">
                <template #input>
                  <van-switch
                    v-model="checkInResultDialog.isPersonalPerformance"
                    size="20"
                    active-color="rgb(242, 124, 52)"
                    inactive-color="#dcdee0"
                  />
                </template>
              </van-field>
            </template>
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="checkInResultSubmitting" @click="submitCheckInResult">
            提交
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="detailDialog.show"
      position="bottom"
      round
      :z-index="DETAIL_DIALOG_Z_INDEX"
      class="detail-dialog-popup"
      :style="{ height: '100%' }"
    >
      <div class="detail-popup">
        <div class="detail-popup-head">
          <div class="detail-popup-title">学员详情</div>
          <van-icon name="cross" class="detail-popup-close" @click="detailDialog.show = false" />
        </div>

        <div class="detail-popup-scroll">
          <div class="detail-main-card">
            <van-tag type="default" :class="['status-tag', 'detail-main-status', statusClass(detailItem)]">
              {{ statusText(detailItem) }}
            </van-tag>
            <div class="detail-student">
              <div class="detail-avatar">{{ detailAvatarText }}</div>
              <div class="detail-student-meta">
                <div class="detail-student-name">{{ detailItem.stuName || "-" }}</div>
                <div class="detail-student-age-birth">
                  <span class="detail-student-age">{{ detailItem.age ? `${detailItem.age}岁` : "-" }}</span>
                  <span class="detail-student-birth">{{ detailItem.birthDate || "-" }}</span>
                </div>
                <div class="detail-student-gender">{{ detailItem.genderName || "-" }}</div>
              </div>
            </div>

            <div class="detail-kv">
              <span class="detail-kv-label">家长姓名</span>
              <span class="detail-kv-value">{{ detailItem.name || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">联系电话</span>
              <span class="detail-kv-value">{{ detailItem.mobile || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">渠道</span>
              <span class="detail-kv-value">{{ detailItem.channelTypeName || detailItem.channelType || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">渠道获得者</span>
              <span class="detail-kv-value">{{ detailItem.channelStaffName || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">中心</span>
              <span class="detail-kv-value">{{ detailItem.departmentName || "-" }}</span>
            </div>
          </div>

          <div class="detail-section-title">业务信息</div>
          <div class="detail-info-list">
            <div class="detail-kv">
              <span class="detail-kv-label">创建员工</span>
              <span class="detail-kv-value">{{ detailItem.statffName || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">创建时间</span>
              <span class="detail-kv-value">{{ detailItem.createTime || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">预约时间</span>
              <span class="detail-kv-value">{{ detailItem.bookingTime || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">试听课程</span>
              <span class="detail-kv-value">{{ detailItem.trialCourseName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">测试时间</span>
              <span class="detail-kv-value">{{ detailItem.checkInTime || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">测试员工</span>
              <span class="detail-kv-value">{{ detailItem.hostStaffName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">试听老师</span>
              <span class="detail-kv-value">{{ detailItem.trialTeacherName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">到店备注</span>
              <span class="detail-kv-value">{{ detailItem.signRemark || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">到店结果</span>
              <span class="detail-kv-value">{{ detailItem.checkInResultName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">到店结果备注</span>
              <span class="detail-kv-value">
                {{ detailItem.checkInRemark || detailItem.checkinRemark || detailItem.checkInResultRemark || "-" }}
              </span>
            </div>
            <div class="detail-kv" v-if="showDepositStepFields">
              <span class="detail-kv-label">定金金额</span>
              <span class="detail-kv-value">{{ formatAmountDisplay(detailItem.depositAmount) }}</span>
            </div>
            <div class="detail-kv" v-if="showDepositStepFields">
              <span class="detail-kv-label">支付方式</span>
              <span class="detail-kv-value">{{ formatDepositPaymentMethodDisplay(detailItem) }}</span>
            </div>
            <div class="detail-kv" v-if="showDepositStepFields">
              <span class="detail-kv-label">支付时间</span>
              <span class="detail-kv-value">{{ detailItem.paidTime || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showDepositStepFields">
              <span class="detail-kv-label">成单前是否算个人业绩</span>
              <span class="detail-kv-value">{{ detailPersonalPerformanceLabel }}</span>
            </div>
            <div class="detail-kv" v-if="showDepositStepFields">
              <span class="detail-kv-label">定金项目</span>
              <span class="detail-kv-value">{{ formatDepositProjectDisplay(detailItem) }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">成单金额</span>
              <span class="detail-kv-value">{{ formatAmountDisplay(detailItem.amount) }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields && detailPerformanceAmountDisplay">
              <span class="detail-kv-label">业绩金额</span>
              <span class="detail-kv-value">{{ detailPerformanceAmountDisplay }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">人头</span>
              <span class="detail-kv-value">{{ formatHeadcountDisplay(detailItem.headcount) }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">成单项目</span>
              <span class="detail-kv-value">{{ formatProjectNameDisplay(detailItem) }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">支付方式</span>
              <span class="detail-kv-value">{{ formatPaymentMethodDisplay(detailItem) }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">成单时间</span>
              <span class="detail-kv-value">{{ detailItem.completeTime || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">课程名称</span>
              <span class="detail-kv-value">{{ detailItem.courseName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">主课老师</span>
              <span class="detail-kv-value">{{ detailItem.leadTeacherName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">副课老师</span>
              <span class="detail-kv-value">{{ detailAssistantTeacherNames }}</span>
            </div>
            <template v-if="showConfirmClassStepFields">
              <div class="detail-kv">
                <span class="detail-kv-label">搭班同学</span>
                <span class="detail-kv-value">{{ detailClassmateNamesDisplay }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">确认开课日期</span>
                <span class="detail-kv-value">{{ detailItem.confirmStartDate || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">第一次上课</span>
                <span class="detail-kv-value">{{ detailItem.firstClassDate || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">开课状态</span>
                <span class="detail-kv-value">{{ detailConfirmClassCourseStatusLabel }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">开始单元</span>
                <span class="detail-kv-value">{{ detailItem.startUnit || "-" }}</span>
              </div>
              <div v-if="hasCoursePackages(detailItem)" class="detail-course-packages-block">
                <div class="detail-section-subtitle">课包配置</div>
                <div
                  v-for="(pkg, pkgIdx) in normalizeCoursePackagesList(detailItem)"
                  :key="`detail-confirm-pkg-${pkgIdx}`"
                  class="detail-course-package-item"
                >
                  <span class="detail-course-package-text">{{ formatCoursePackageItem(pkg) }}</span>
                  <van-icon
                    name="setting-o"
                    class="detail-course-package-edit"
                    @click.stop="openSetRemainDialog(pkg)"
                  />
                </div>
              </div>
            </template>
            <div v-if="showDetailPurchasedBooks" class="purchased-books-block purchased-books-block--detail" @click.stop>
              <div class="purchased-books-head" @click="togglePurchasedBooks(purchasedBooksKey('detail', detailItem))">
                <span class="purchased-books-title">已购教材</span>
                <span class="purchased-books-summary">{{ purchasedBooksSummary(detailItem) }}</span>
                <van-icon
                  :name="isPurchasedBooksExpanded(purchasedBooksKey('detail', detailItem)) ? 'arrow-up' : 'arrow-down'"
                  class="purchased-books-arrow"
                />
              </div>
              <div
                v-show="isPurchasedBooksExpanded(purchasedBooksKey('detail', detailItem))"
                class="purchased-books-body"
              >
                <span v-if="!parseRecordBookIds(detailItem).length" class="purchased-books-empty">-</span>
                <span
                  v-for="book in parseRecordBookIds(detailItem)"
                  :key="`detail-book-${detailItem.id}-${book.id}`"
                  class="record-book-chip"
                >
                  {{ book.name }}
                </span>
              </div>
            </div>
          </div>

          <div class="detail-section-title">备注</div>
          <div class="detail-remark-block">{{ detailItem.remark || "暂无备注" }}</div>

          <div v-if="detailRecordList.length" class="detail-section-title">历史记录</div>
          <div v-if="detailRecordList.length" class="detail-record-list">
            <div v-for="(row, idx) in detailRecordList" :key="`record-${idx}`" class="detail-record-card">
              <div class="detail-record-title">记录 {{ idx + 1 }}</div>
              <div class="detail-kv">
                <span class="detail-kv-label">创建时间</span>
                <span class="detail-kv-value">{{ row.createTime || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">预约时间</span>
                <span class="detail-kv-value">{{ row.bookingTime || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">渠道</span>
                <span class="detail-kv-value">{{ row.channelTypeName || row.channelType || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">渠道获得者</span>
                <span class="detail-kv-value">{{ row.channelStaffName || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">试听课程</span>
                <span class="detail-kv-value">{{ row.trialCourseName || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">到店时间</span>
                <span class="detail-kv-value">{{ row.checkInTime || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">测试员工</span>
                <span class="detail-kv-value">{{ row.hostStaffName || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">试听老师</span>
                <span class="detail-kv-value">{{ row.trialTeacherName || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">到店结果</span>
                <span class="detail-kv-value">{{ row.checkInResultName || "-" }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv-label">备注</span>
                <span class="detail-kv-value">{{ row.checkInRemark || row.checkinRemark || row.checkInResultRemark || "-" }}</span>
              </div>
            </div>
          </div>

          <div class="detail-section-title">拓科记录</div>
          <div v-if="!detailExpansionList.length" class="detail-renew-state detail-renew-empty">暂无拓科记录</div>
          <div v-else class="detail-expansion-list">
            <div
              v-for="(row, idx) in detailExpansionList"
              :key="row.id || `expansion-${idx}`"
              class="detail-expansion-card"
            >
              <div class="detail-expansion-card-head">
                <span class="detail-expansion-type">{{ expansionDisplayName(row, idx) }}</span>
                <van-tag type="default" :class="['status-tag', statusClass(row)]">
                  {{ statusText(row) }}
                </van-tag>
              </div>
              <div class="detail-expansion-body">
                <div class="detail-kv">
                  <span class="detail-kv-label">试听课程</span>
                  <span class="detail-kv-value">{{ row.trialCourseName || "-" }}</span>
                </div>
                <div class="detail-kv">
                  <span class="detail-kv-label">预约时间</span>
                  <span class="detail-kv-value">{{ row.bookingTime || "-" }}</span>
                </div>
                <div v-if="showExpansionArriveFields(row)" class="detail-kv">
                  <span class="detail-kv-label">测试时间</span>
                  <span class="detail-kv-value">{{ row.checkInTime || "-" }}</span>
                </div>
                <div v-if="showExpansionArriveFields(row)" class="detail-kv">
                  <span class="detail-kv-label">测试员工</span>
                  <span class="detail-kv-value">{{ row.hostStaffName || "-" }}</span>
                </div>
                <div v-if="showExpansionArriveFields(row)" class="detail-kv">
                  <span class="detail-kv-label">试听老师</span>
                  <span class="detail-kv-value">{{ row.trialTeacherName || "-" }}</span>
                </div>
                <div v-if="showExpansionArriveFields(row)" class="detail-kv">
                  <span class="detail-kv-label">到店备注</span>
                  <span class="detail-kv-value">{{ row.signRemark || "-" }}</span>
                </div>
                <div v-if="showExpansionArriveFields(row)" class="detail-kv">
                  <span class="detail-kv-label">到店结果</span>
                  <span class="detail-kv-value">{{ row.checkInResultName || "-" }}</span>
                </div>
                <div v-if="showExpansionArriveFields(row)" class="detail-kv">
                  <span class="detail-kv-label">到店结果备注</span>
                  <span class="detail-kv-value">
                    {{ row.checkInRemark || row.checkinRemark || row.checkInResultRemark || "-" }}
                  </span>
                </div>
                <div v-if="showExpansionDepositFields(row)" class="detail-kv">
                  <span class="detail-kv-label">定金金额</span>
                  <span class="detail-kv-value">{{ formatAmountDisplay(row.depositAmount) }}</span>
                </div>
                <div v-if="showExpansionDepositFields(row)" class="detail-kv">
                  <span class="detail-kv-label">支付方式</span>
                  <span class="detail-kv-value">{{ formatDepositPaymentMethodDisplay(row) }}</span>
                </div>
                <div v-if="showExpansionDepositFields(row)" class="detail-kv">
                  <span class="detail-kv-label">支付时间</span>
                  <span class="detail-kv-value">{{ row.paidTime || "-" }}</span>
                </div>
                <div v-if="showExpansionDepositFields(row)" class="detail-kv">
                  <span class="detail-kv-label">成单前是否算个人业绩</span>
                  <span class="detail-kv-value">{{ formatPersonalPerformanceLabel(row) }}</span>
                </div>
                <div v-if="showExpansionDepositFields(row)" class="detail-kv">
                  <span class="detail-kv-label">定金项目</span>
                  <span class="detail-kv-value">{{ formatDepositProjectDisplay(row) }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">成单金额</span>
                  <span class="detail-kv-value">{{ formatAmountDisplay(row.amount) }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">人头</span>
                  <span class="detail-kv-value">{{ formatHeadcountDisplay(row.headcount) }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">成单项目</span>
                  <span class="detail-kv-value">{{ formatProjectNameDisplay(row) }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">支付方式</span>
                  <span class="detail-kv-value">{{ formatPaymentMethodDisplay(row) }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">成单时间</span>
                  <span class="detail-kv-value">{{ row.completeTime || "-" }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">课程名称</span>
                  <span class="detail-kv-value">{{ row.courseName || "-" }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">主课老师</span>
                  <span class="detail-kv-value">{{ row.leadTeacherName || "-" }}</span>
                </div>
                <div v-if="showExpansionCompleteFields(row)" class="detail-kv">
                  <span class="detail-kv-label">副课老师</span>
                  <span class="detail-kv-value">{{ renewAssistantTeacherNames(row) }}</span>
                </div>
                <template v-if="showExpansionConfirmClassFields(row)">
                  <div class="detail-kv">
                    <span class="detail-kv-label">搭班同学</span>
                    <span class="detail-kv-value">{{ formatClassmateNamesDisplay(row) }}</span>
                  </div>
                  <div class="detail-kv">
                    <span class="detail-kv-label">确认开课日期</span>
                    <span class="detail-kv-value">{{ row.confirmStartDate || "-" }}</span>
                  </div>
                  <div class="detail-kv">
                    <span class="detail-kv-label">第一次上课</span>
                    <span class="detail-kv-value">{{ row.firstClassDate || "-" }}</span>
                  </div>
                  <div class="detail-kv">
                    <span class="detail-kv-label">开课状态</span>
                    <span class="detail-kv-value">{{ getCourseStatusLabel(row) }}</span>
                  </div>
                  <div class="detail-kv">
                    <span class="detail-kv-label">开始单元</span>
                    <span class="detail-kv-value">{{ row.startUnit || "-" }}</span>
                  </div>
                  <div v-if="hasCoursePackages(row)" class="detail-course-packages-block">
                    <div class="detail-section-subtitle">课包配置</div>
                    <div
                      v-for="(pkg, pkgIdx) in normalizeCoursePackagesList(row)"
                      :key="`expansion-pkg-${row.id || idx}-${pkgIdx}`"
                      class="detail-course-package-item"
                    >
                      <span class="detail-course-package-text">{{ formatCoursePackageItem(pkg) }}</span>
                      <van-icon
                        name="setting-o"
                        class="detail-course-package-edit"
                        @click.stop="openSetRemainDialog(pkg)"
                      />
                    </div>
                  </div>
                </template>
                <div v-if="(row.remark || '').trim()" class="detail-kv detail-kv-remark">
                  <span class="detail-kv-label">备注</span>
                  <span class="detail-kv-value">{{ row.remark }}</span>
                </div>
                <div class="flow-actions" @click.stop>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(row, 'booking') }"
                    @click="openExpansionInvite(detailItem, row)"
                  >
                    邀约
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(row, 'arrive') }"
                    @click="openExpansionCheckIn(detailItem, row)"
                  >
                    到店
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(row, 'deposit') }"
                    @click="openExpansionCheckInResult(detailItem, row)"
                  >
                    到店结果
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(row, 'complete') }"
                    @click="openExpansionComplete(detailItem, row)"
                  >
                    成单
                  </button>
                  <button
                    type="button"
                    class="flow-step"
                    :class="{ active: isFlowStepActive(row, 'confirmClass') }"
                    @click="openExpansionConfirmClass(detailItem, row)"
                  >
                    开课
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-section-title">续费详情</div>
          <div v-if="detailRenewLoading" class="detail-renew-state">
            <van-loading size="22px" vertical>加载中...</van-loading>
          </div>
          <div v-else-if="!detailRenewList.length" class="detail-renew-state detail-renew-empty">暂无续费记录</div>
          <div v-else class="detail-renew-list">
            <div
              v-for="(row, idx) in detailRenewList"
              :key="row.id || `renew-${idx}`"
              :class="['detail-renew-card', { 'detail-renew-card--confirmed': isOrderIncomeConfirmed(row) }]"
            >
              <div class="detail-renew-card-head">
                <div class="detail-renew-card-head-left">
                  <span class="detail-renew-type">{{ renewRecordTypeLabel(row) }}</span>
                  <van-tag v-if="isOrderIncomeConfirmed(row)" class="detail-renew-status-tag detail-renew-status-tag--confirmed">
                    已确认
                  </van-tag>
                </div>
                <span class="detail-renew-amount">{{ formatAmountDisplay(row.amount) }}</span>
              </div>
              <div class="detail-renew-body">
                <div class="detail-kv">
                  <span class="detail-kv-label">支付时间</span>
                  <span class="detail-kv-value">{{ row.completeTime || row.paidTime || "-" }}</span>
                </div>
                <div class="detail-kv">
                  <span class="detail-kv-label">支付方式</span>
                  <span class="detail-kv-value">{{ formatPaymentMethodDisplay(row) }}</span>
                </div>
                <div class="detail-kv">
                  <span class="detail-kv-label">项目</span>
                  <span class="detail-kv-value">{{ formatProjectNameDisplay(row) }}</span>
                </div>
                <template v-if="isOrderIncomeConfirmed(row)">
                  <div class="detail-kv">
                    <span class="detail-kv-label">确认人</span>
                    <span class="detail-kv-value">{{ row.confirmPeopleName || "-" }}</span>
                  </div>
                  <div class="detail-kv">
                    <span class="detail-kv-label">确认时间</span>
                    <span class="detail-kv-value">{{ row.confirmTime || "-" }}</span>
                  </div>
                </template>
                <div v-if="showRenewCourseField(row)" class="detail-kv">
                  <span class="detail-kv-label">课程</span>
                  <span class="detail-kv-value">{{ row.courseName || "-" }}</span>
                </div>
                <div v-if="showRenewCoursePackagesField(row) && hasCoursePackages(row)" class="detail-course-packages-block detail-course-packages-block--renew">
                  <div class="detail-section-subtitle">课包配置</div>
                  <div
                    v-for="(pkg, pkgIdx) in normalizeCoursePackagesList(row)"
                    :key="`renew-pkg-${row.id || idx}-${pkgIdx}`"
                    class="detail-course-package-item"
                  >
                    <span class="detail-course-package-text">{{ formatCoursePackageItem(pkg) }}</span>
                    <van-icon
                      name="setting-o"
                      class="detail-course-package-edit"
                      @click.stop="openSetRemainDialog(pkg)"
                    />
                  </div>
                </div>
                <div v-if="showRenewTeacherField(row)" class="detail-kv">
                  <span class="detail-kv-label">主课老师</span>
                  <span class="detail-kv-value">{{ row.leadTeacherName || "-" }}</span>
                </div>
                <div v-if="showRenewTeacherField(row)" class="detail-kv">
                  <span class="detail-kv-label">副课老师</span>
                  <span class="detail-kv-value">{{ renewAssistantTeacherNames(row) }}</span>
                </div>
                <div v-if="showRenewOtherTypeField(row)" class="detail-kv">
                  <span class="detail-kv-label">杂费类型</span>
                  <span class="detail-kv-value">{{ otherFeeTypeLabel(row.abrsmType) }}</span>
                </div>
                <div v-if="showRenewStaffField(row)" class="detail-kv">
                  <span class="detail-kv-label">业绩归属人</span>
                  <span class="detail-kv-value">{{ renewRecordStaffName(row) || "-" }}</span>
                </div>
                <div v-if="showRenewPerformanceAmountField(row)" class="detail-kv">
                  <span class="detail-kv-label">业绩金额</span>
                  <span class="detail-kv-value">{{ formatAmountDisplay(row.performanceAmount) }}</span>
                </div>
                <div v-if="showRenewPurchasedBooks(row)" class="purchased-books-block purchased-books-block--renew" @click.stop>
                  <div class="purchased-books-head" @click="togglePurchasedBooks(purchasedBooksKey('renew', row, idx))">
                    <span class="purchased-books-title">已购教材</span>
                    <span class="purchased-books-summary">{{ purchasedBooksSummary(row) }}</span>
                    <van-icon
                      :name="isPurchasedBooksExpanded(purchasedBooksKey('renew', row, idx)) ? 'arrow-up' : 'arrow-down'"
                      class="purchased-books-arrow"
                    />
                  </div>
                  <div
                    v-show="isPurchasedBooksExpanded(purchasedBooksKey('renew', row, idx))"
                    class="purchased-books-body"
                  >
                    <span v-if="!parseRecordBookIds(row).length" class="purchased-books-empty">-</span>
                    <span
                      v-for="book in parseRecordBookIds(row)"
                      :key="`renew-book-${row.id || idx}-${book.id}`"
                      class="record-book-chip"
                    >
                      {{ book.name }}
                    </span>
                  </div>
                </div>
                <div v-if="(row.remark || '').trim()" class="detail-kv detail-kv-remark">
                  <span class="detail-kv-label">备注</span>
                  <span class="detail-kv-value">{{ row.remark }}</span>
                </div>
              </div>
              <div
                v-if="isRenewFeeRecord(row) && isRenewRecordActive(row) && !isOrderIncomeConfirmed(row)"
                class="detail-renew-card-actions"
              >
                <van-button
                  size="small"
                  round
                  plain
                  class="detail-renew-btn-edit"
                  @click.stop="openRenewRecordEdit(row)"
                >
                  修改
                </van-button>
                <van-button
                  v-if="canShowVoidButton"
                  size="small"
                  round
                  plain
                  type="danger"
                  class="detail-renew-btn-delete"
                  @click.stop="doCancelRenewRecord(row)"
                >
                  作废
                </van-button>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-actions-bar">
          <div class="detail-actions-grid">
            <van-button round block class="detail-grid-btn detail-btn-again" @click="openAgainInviteFromDetail">
              再邀约
            </van-button>
            <van-button
              v-if="Number(detailItem.status) !== 5"
              round
              block
              class="detail-grid-btn detail-btn-expansion"
              @click="openExpansionFromDetail"
            >
              拓科
            </van-button>
            <van-button round block class="detail-grid-btn detail-btn-biz" @click="detailBizSheetShow = true">
              录收入
            </van-button>
            <van-button round block class="detail-grid-btn detail-btn-edit" @click="openUpdateFromDetail">
              修改
            </van-button>
            <van-button
              v-if="Number(detailItem.status) !== 5"
              round
              block
              class="detail-grid-btn detail-btn-activate"
              @click="openActivateFromDetail"
            >
              激活
            </van-button>
            <van-button
              v-if="Number(detailItem.status) !== 5"
              round
              block
              class="detail-grid-btn detail-btn-not-studying"
              @click="openNotStudyingFromDetail"
            >
              不在学
            </van-button>
            <van-button
              v-if="canShowVoidButton"
              round
              block
              class="detail-grid-btn detail-btn-void"
              @click="doCancelFromDetail"
            >
              作废
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="updateDialog.show" position="bottom" round :z-index="4220" :style="{ height: '82vh' }">
      <div class="update-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">修改学员</div>
          <van-icon name="cross" class="popup-close" @click="updateDialog.show = false" />
        </div>
        <div class="update-popup-scroll">
        <van-field
          v-model.trim="updateDialog.form.stuName"
          label="学员名"
          placeholder="请输入学员名"
          required
          :rules="[{ required: true, message: '请输入学员名' }]"
        />
        <van-field
          readonly
          clickable
          label="出生日"
          :value="updateDialog.form.birthDate"
          placeholder="请选择出生日"
          @click="openUpdateTimePicker('birthDate', '选择出生日', 'date')"
        />
        <van-field :value="updateAgeDisplay" label="年龄" readonly class="field-locked">
          <template #right-icon>
            <van-icon name="lock" class="field-lock-icon" />
          </template>
        </van-field>
        <van-field name="gender" label="性别">
          <template #input>
            <van-radio-group v-model="updateDialog.form.gender" direction="horizontal">
              <van-radio :name="1">男</van-radio>
              <van-radio :name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model.trim="updateDialog.form.name"
          label="家长名"
          placeholder="选填"
        />
        <van-field
          v-model.trim="updateDialog.form.mobile"
          label="手机号"
          placeholder="请输入手机号"
          required
          :rules="[{ required: true, message: '请输入手机号' }]"
        />
        <van-field
          readonly
          clickable
          label="渠道"
          :value="updateChannelTypeLabel"
          placeholder="请选择渠道"
          @click="openUpdateChannelPicker"
          required
          :rules="[{ required: true, message: '请选择渠道' }]"
        />
        <van-field
          readonly
          clickable
          label="渠道获得者"
          :value="updateChannelStaffLabel"
          placeholder="选填"
          @click="openUpdateStaffPicker('channelStaffId', '选择渠道获得者')"
        >
          <template v-if="updateChannelStaffLabel" #button>
            <span class="field-clear-btn" @click.stop="clearUpdateChannelStaff">清除</span>
          </template>
        </van-field>
        <van-field
          v-model.trim="updateDialog.form.remark"
          label="备注"
          type="textarea"
          rows="2"
          autosize
          placeholder="选填"
        />
        <van-field
          v-if="updateCanBooking"
          readonly
          clickable
          label="预约时间"
          :value="updateDialog.form.bookingTime"
          placeholder="请选择预约时间"
          @click="openUpdateTimePicker('bookingTime', '选择预约时间')"
        />
        <van-field
          v-if="updateCanArrive"
          readonly
          clickable
          label="测试CC"
          :value="updateHostStaffLabel"
          placeholder="请选择测试CC"
          @click="openUpdateStaffPicker('hostStaffId', '选择测试CC')"
        />
        <van-field
          v-if="updateCanArrive"
          readonly
          clickable
          label="试听老师"
          :value="updateTrialTeacherLabel"
          placeholder="请选择试听老师"
          @click="openUpdateStaffPicker('trialTeacherId', '选择试听老师')"
        />
        <van-field
          v-if="updateCanArrive"
          readonly
          clickable
          label="测试时间"
          :value="updateDialog.form.checkInTime"
          placeholder="请选择测试时间"
          @click="openUpdateTimePicker('checkInTime', '选择测试时间')"
        />
        <van-field
          v-if="updateCanArrive"
          v-model.trim="updateDialog.form.signRemark"
          label="到店备注"
          type="textarea"
          rows="2"
          autosize
          placeholder="选填"
        />
        <van-field
          v-if="updateCanDeposit"
          readonly
          clickable
          label="到店结果"
          :value="updateCheckInResultLabel"
          placeholder="请选择到店结果"
          @click="openUpdateCheckInResultPicker"
        />
        <van-field
          v-if="updateCanDeposit"
          v-model.trim="updateDialog.form.checkInRemark"
          label="到店备注"
          type="textarea"
          rows="2"
          autosize
          placeholder="选填"
        />
        <van-field
          v-if="updateCanEditDepositFields"
          v-model="updateDialog.form.depositAmount"
          label="定金金额"
          placeholder="选填"
          type="number"
          :readonly="updateDepositAmountReadonly"
          :class="{ 'field-locked': updateDepositAmountReadonly }"
        >
          <template v-if="updateDepositAmountReadonly" #right-icon>
            <van-icon name="lock" class="field-lock-icon" />
          </template>
        </van-field>
        <van-field
          v-if="updateCanEditDepositFields"
          readonly
          :clickable="!updateDepositAmountReadonly"
          label="支付方式"
          :value="getPaymentMethodLabel(updateDialog.form.depositPaymentMethod)"
          placeholder="请选择支付方式"
          required
          :rules="[{ required: true, message: '请选择支付方式' }]"
          @click="onOpenPaymentMethodPicker('updateDeposit')"
        />
        <van-field
          v-if="updateCanEditDepositFields"
          readonly
          clickable
          label="支付时间"
          :value="updateDialog.form.paidTime"
          placeholder="请选择支付时间"
          @click="openUpdateTimePicker('paidTime', '选择支付时间')"
        />
        <van-field
          v-if="updateCanEditDepositFields"
          readonly
          clickable
          label="定金项目"
          :value="getProjectLabel(updateDialog.form.depositProjectId)"
          placeholder="请选择项目（选填）"
          @click="openProjectPicker('updateDeposit')"
        />
        <van-field v-if="updateCanEditDepositFields" class="personal-performance-field" label="成单前是否算个人业绩">
          <template #input>
            <van-switch
              v-model="updateDialog.form.isPersonalPerformance"
              size="20"
              active-color="rgb(242, 124, 52)"
              inactive-color="#dcdee0"
            />
          </template>
        </van-field>
        <van-field
          v-if="updateCanComplete"
          v-model="updateDialog.form.amount"
          label="成单金额"
          placeholder="选填"
          type="number"
          :readonly="updateOrderAmountReadonly"
          :class="{ 'field-locked': updateOrderAmountReadonly }"
        >
          <template v-if="updateOrderAmountReadonly" #right-icon>
            <van-icon name="lock" class="field-lock-icon" />
          </template>
        </van-field>
        <van-field
          v-if="updateCanComplete"
          v-model="updateDialog.form.performanceAmount"
          label="业绩金额"
          placeholder="业绩金额若与支付金额相等不用填"
          type="number"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="人头"
          :value="getHeadcountLabel(updateDialog.form.headcount)"
          placeholder="请选择人头"
          @click="openHeadcountPicker('update')"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          :clickable="!updateOrderAmountReadonly"
          label="支付方式"
          :value="getPaymentMethodLabel(updateDialog.form.paymentMethod)"
          placeholder="请选择支付方式"
          required
          :rules="[{ required: true, message: '请选择支付方式' }]"
          @click="onOpenPaymentMethodPicker('updateComplete')"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="成单项目"
          :value="getProjectLabel(updateDialog.form.projectId)"
          placeholder="请选择项目（选填）"
          @click="openProjectPicker('updateComplete')"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="成单时间"
          :value="updateDialog.form.completeTime"
          placeholder="请选择成单时间"
          @click="openUpdateTimePicker('completeTime', '选择成单时间')"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="课程"
          :value="updateCourseLabel"
          placeholder="请选择课程"
          @click="openUpdateCoursePicker"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="主课老师"
          :value="updateLeadTeacherLabel"
          placeholder="请选择主课老师"
          @click="openUpdateStaffPicker('leadTeacherId', '选择主课老师')"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="副课老师"
          :value="updateAssistantTeacherLabels"
          placeholder="请选择副课老师"
          @click="openUpdateAssistantPopup"
        >
          <template v-if="updateAssistantTeacherLabels" #button>
            <span class="field-clear-btn" @click.stop="clearUpdateAssistantTeachers">清除</span>
          </template>
        </van-field>
        </div>
        <div class="update-popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="updateSubmitting" @click="submitUpdate">
            保存
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="updateChannelPicker.show" position="bottom">
      <van-picker
        show-toolbar
        title="选择渠道"
        :columns="channelOptions"
        @confirm="onConfirmUpdateChannel"
        @cancel="updateChannelPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="updateStaffPicker.show" position="bottom">
      <van-search v-model.trim="updateStaffSearch.single" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        :title="updateStaffPicker.title || '选择员工'"
        :columns="filteredUpdateStaffOptions"
        @confirm="onConfirmUpdateStaff"
        @cancel="updateStaffPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="updateAssistantPopup.show" position="bottom" round :style="{ height: '60%' }">
      <div class="assign-assistant-popup">
        <div class="popup-head">
          <div class="popup-title">选择副课老师</div>
          <van-icon name="cross" class="popup-close" @click="updateAssistantPopup.show = false" />
        </div>
        <van-search v-model.trim="updateStaffSearch.assistant" placeholder="搜索员工姓名" />
        <div class="assign-assistant-body">
          <van-checkbox-group v-model="updateDialog.form.assistantTeacherIds">
            <van-cell-group inset>
              <van-cell
                v-for="opt in filteredUpdateAssistantStaffOptions"
                :key="`update-assistant-${opt.value}`"
                clickable
                @click="toggleUpdateAssistant(opt.value)"
              >
                <template #title>{{ opt.text }}</template>
                <template #right-icon>
                  <van-checkbox :name="String(opt.value)" @click.stop />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
        <div class="assign-assistant-actions">
          <van-button round block type="primary" class="theme-btn" @click="updateAssistantPopup.show = false">
            完成
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="updateCoursePicker.show" position="bottom">
      <van-search v-model.trim="courseSearchKeyword" placeholder="搜索课程" />
      <van-picker
        show-toolbar
        title="选择课程"
        :columns="filteredCourseOptions"
        @confirm="onConfirmUpdateCourse"
        @cancel="updateCoursePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="updateCheckInResultPicker.show" position="bottom">
      <van-picker
        show-toolbar
        title="选择到店结果"
        :columns="checkInResultOptions"
        @confirm="onConfirmUpdateCheckInResult"
        @cancel="updateCheckInResultPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="updateTimePicker.show" position="bottom">
      <van-datetime-picker
        :type="updateTimePicker.type"
        :title="updateTimePicker.title || '选择时间'"
        :value="updateTimePicker.value"
        :min-date="updateTimePicker.type === 'date' ? birthDateMinDate : undefined"
        :max-date="updateTimePicker.type === 'date' ? birthDateMaxDate : undefined"
        @confirm="onConfirmUpdateTime"
        @cancel="updateTimePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="paidTimePicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-datetime-picker
        type="datetime"
        title="选择支付时间"
        :value="paidTimePicker.value"
        @confirm="onConfirmPaidTime"
        @cancel="paidTimePicker.show = false"
      />
    </van-popup>

    <van-popup
      v-model="completeDialog.show"
      position="bottom"
      round
      :z-index="FLOW_POPUP_Z_INDEX"
      :style="{ height: isCompleteMdCourse ? '66vh' : '60vh', maxHeight: '85vh' }"
    >
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">成单</div>
          <van-icon name="cross" class="popup-close" @click="completeDialog.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitComplete">
            <van-field
              readonly
              clickable
              label="测试CC"
              :value="completeHostStaffLabel"
              placeholder="请选择测试CC"
              @click="openCompleteHostPicker"
            />
            <van-field
              v-model="completeDialog.amount"
              label="支付金额"
              placeholder="请输入支付金额"
              type="number"
              required
              :readonly="completeOrderAmountReadonly"
              :class="{ 'field-locked': completeOrderAmountReadonly }"
              :rules="[{ required: true, message: '请输入支付金额' }]"
            >
              <template v-if="completeOrderAmountReadonly" #right-icon>
                <van-icon name="lock" class="field-lock-icon" />
              </template>
            </van-field>
            <van-field
              v-model="completeDialog.performanceAmount"
              label="业绩金额"
              placeholder="业绩金额若与支付金额相等不用填"
              type="number"
            />
            <van-field
              readonly
              clickable
              label="人头"
              :value="getHeadcountLabel(completeDialog.headcount)"
              placeholder="请选择人头"
              @click="openHeadcountPicker('complete')"
            />
            <van-field
              readonly
              :clickable="!completeOrderAmountReadonly"
              label="支付方式"
              :value="getPaymentMethodLabel(completeDialog.paymentMethod)"
              placeholder="请选择支付方式"
              required
              :rules="[{ required: true, message: '请选择支付方式' }]"
              @click="onOpenPaymentMethodPicker('complete')"
            />
            <van-field
              readonly
              clickable
              label="项目"
              :value="getProjectLabel(completeDialog.projectId)"
              placeholder="请选择项目（选填）"
              @click="openProjectPicker('complete')"
            />
            <van-field
              readonly
              clickable
              label="课程"
              :value="courseLabel"
              placeholder="请选择课程"
              required
              :rules="[{ required: true, message: '请选择课程' }]"
              @click="openCoursePicker"
            />
            <van-field
              v-if="isCompleteMdCourse"
              readonly
              clickable
              label="教材"
              :value="completeBookLabel"
              placeholder="请选择教材"
              required
              :rules="[{ required: true, message: '请选择教材' }]"
              @click="openMdBookPicker('complete')"
            />
            <van-field
              readonly
              clickable
              label="成单时间"
              :value="completeDialog.completeTime"
              placeholder="请选择成单时间"
              required
              :rules="[{ required: true, message: '请选择成单时间' }]"
              @click="completeTimePicker.show = true"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="completeSubmitting" @click="submitComplete">
            提交
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="completeBookPicker.show" position="bottom" round :z-index="FLOW_POPUP_PICKER_Z_INDEX" :style="{ height: '55vh' }">
      <div class="complete-book-popup">
        <div class="popup-head">
          <div class="popup-title">选择教材</div>
          <van-icon name="cross" class="popup-close" @click="completeBookPicker.show = false" />
        </div>
        <div v-if="!completeBookLoading && completeBookOptions.length" class="complete-book-head">
          <span class="complete-book-tip">已选 {{ activeMdBookIds.length }} / {{ completeBookOptions.length }}</span>
          <span class="complete-book-select-all" @click="toggleMdBookSelectAll">
            <van-icon :name="isActiveMdBookAllSelected ? 'checked' : 'circle'" class="complete-book-select-icon" />
            {{ isActiveMdBookAllSelected ? "取消" : "全选" }}
          </span>
        </div>
        <div class="complete-book-scroll">
          <van-loading v-if="completeBookLoading" class="panel-loading" size="20px" />
          <van-empty v-else-if="!completeBookOptions.length" description="暂无教材" class="panel-empty" />
          <van-checkbox-group v-else :value="activeMdBookIds" @input="onActiveMdBookIdsInput">
            <van-cell-group inset>
              <van-cell
                v-for="opt in completeBookOptions"
                :key="`complete-book-${opt.value}`"
                clickable
                :title="opt.text"
                :class="{ 'complete-book-cell-selected': isMdBookIdSelected(opt.value) }"
                @click="toggleMdBook(opt.value)"
              >
                <template #right-icon>
                  <van-checkbox :name="String(opt.value)" @click.stop />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
        <div class="complete-book-actions">
          <van-button round block type="primary" class="theme-btn" @click="completeBookPicker.show = false">完成</van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="coursePicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-search v-model.trim="courseSearchKeyword" placeholder="搜索课程" />
      <van-picker
        show-toolbar
        title="选择课程"
        :columns="filteredCompleteCourseOptions"
        @confirm="onConfirmCourse"
        @cancel="coursePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="completeTimePicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-datetime-picker
        type="datetime"
        title="选择成单时间"
        :value="completeTimePicker.value"
        @confirm="onConfirmCompleteTime"
        @cancel="completeTimePicker.show = false"
      />
    </van-popup>

    <van-popup
      v-model="confirmClassDialog.show"
      position="bottom"
      round
      :z-index="FLOW_POPUP_Z_INDEX"
      :style="{ height: '72vh', maxHeight: '85vh' }"
    >
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">开课</div>
          <van-icon name="cross" class="popup-close" @click="confirmClassDialog.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitConfirmClass">
            <van-field
              readonly
              clickable
              label="主课老师"
              :value="confirmClassLeadTeacherLabel"
              placeholder="请选择主课老师"
              required
              :rules="[{ required: true, message: '请选择主课老师' }]"
              @click="openFeeStaffPicker('confirmClass', 'leadTeacherId', '选择主课老师')"
            />
            <van-field
              readonly
              clickable
              label="副课老师"
              :value="confirmClassAssistantTeacherLabel"
              placeholder="请选择副课老师（可多选）"
              @click="openFeeAssistantPopup('confirmClass')"
            >
              <template v-if="confirmClassAssistantTeacherLabel" #button>
                <span class="field-clear-btn" @click.stop="clearFeeAssistantField('confirmClass')">清除</span>
              </template>
            </van-field>
            <van-field
              readonly
              clickable
              label="搭班同学"
              :value="confirmClassClassmateLabel"
              placeholder="请选择搭班同学（可多选）"
              @click="openConfirmClassClassmatePicker"
            >
              <template v-if="confirmClassClassmateLabel" #button>
                <span class="field-clear-btn" @click.stop="clearConfirmClassClassmates">清除</span>
              </template>
            </van-field>
            <van-field
              readonly
              clickable
              label="确认开课日期"
              :value="confirmClassDialog.form.confirmStartDate"
              placeholder="请选择确认开课日期"
              required
              :rules="[{ required: true, message: '请选择确认开课日期' }]"
              @click="openConfirmClassDatePicker('confirmStartDate', '选择确认开课日期')"
            />
            <van-field
              readonly
              clickable
              label="第一次上课"
              :value="confirmClassDialog.form.firstClassDate"
              placeholder="请选择第一次上课日期"
              required
              :rules="[{ required: true, message: '请选择第一次上课日期' }]"
              @click="openConfirmClassDatePicker('firstClassDate', '选择第一次上课日期')"
            />
            <van-field
              readonly
              clickable
              label="开课状态"
              :value="confirmClassCourseStatusLabel"
              placeholder="请选择开课状态"
              required
              :rules="[{ required: true, message: '请选择开课状态' }]"
              @click="confirmClassCourseStatusPicker.show = true"
            />
            <van-field
              v-model.trim="confirmClassDialog.form.startUnit"
              label="开始单元"
              placeholder="请输入开始单元，如 Unit 1"
            />
            <div class="course-packages-section">
              <div class="course-packages-head">
                <span class="course-packages-title">课包配置</span>
                <span class="course-packages-add" @click="addCoursePackageRow('confirmClass')">+ 添加</span>
              </div>
              <div
                v-for="(pkg, pkgIdx) in confirmClassDialog.form.coursePackages"
                :key="pkg._key"
                class="course-package-card"
              >
                <div class="course-package-card-head">
                  <span class="course-package-card-index">课包 {{ pkgIdx + 1 }}</span>
                  <van-button
                    plain
                    hairline
                    round
                    size="mini"
                    class="course-package-remove-btn"
                    @click.stop="removeCoursePackageRow('confirmClass', pkgIdx)"
                  >
                    删除
                  </van-button>
                </div>
                <van-field
                  readonly
                  clickable
                  label="课包"
                  :value="pkg.coursePackageName"
                  placeholder="请选择课包"
                  required
                  @click="openCoursePackagePicker('confirmClass', pkgIdx)"
                />
                <van-field
                  readonly
                  clickable
                  label="退课包"
                  :value="pkg.refundCoursePackageLabel"
                  placeholder="接转课（选填）"
                  @click="openRefundCoursePackagePicker('confirmClass', pkgIdx)"
                >
                  <template v-if="pkg.refundCoursePackageLabel" #button>
                    <span class="field-clear-btn" @click.stop="clearRefundCoursePackage('confirmClass', pkgIdx)">清除</span>
                  </template>
                </van-field>
                <van-field
                  v-model="pkg.courseNum"
                  label="课程数"
                  placeholder="请输入课程数"
                  type="digit"
                  required
                  @input="onCoursePackageNumInput('confirmClass', pkgIdx)"
                />
                <van-field
                  v-model="pkg.courseAmount"
                  label="课程金额"
                  placeholder="请输入课程金额"
                  type="number"
                  required
                  :readonly="isRefundCoursePackageLinked(pkg)"
                  :class="{ 'field-locked': isRefundCoursePackageLinked(pkg) }"
                >
                  <template v-if="isRefundCoursePackageLinked(pkg)" #right-icon>
                    <van-icon name="lock" class="field-lock-icon" />
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button
            round
            block
            type="primary"
            class="theme-btn"
            :loading="confirmClassDialog.submitting"
            @click="submitConfirmClass"
          >
            提交
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="notStudyingDialog.show"
      position="bottom"
      round
      :z-index="4230"
      :style="{ height: '52vh', maxHeight: '85vh' }"
    >
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">不在学{{ notStudyingDialog.studentName ? ` - ${notStudyingDialog.studentName}` : "" }}</div>
          <van-icon name="cross" class="popup-close" @click="notStudyingDialog.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-field
            readonly
            clickable
            label="状态"
            :value="notStudyingCourseStatusLabel"
            placeholder="请选择状态"
            required
            @click="notStudyingCourseStatusPicker.show = true"
          />
          <van-field
            readonly
            clickable
            label="生效日期"
            :value="notStudyingDialog.form.statusDate"
            placeholder="请选择生效日期"
            required
            @click="openNotStudyingDatePicker"
          />
          <van-field
            v-model.trim="notStudyingDialog.form.remark"
            label="备注"
            type="textarea"
            rows="2"
            autosize
            placeholder="选填"
          />
        </div>
        <div class="popup-actions">
          <van-button
            round
            block
            type="primary"
            class="theme-btn"
            :loading="notStudyingDialog.submitting"
            @click="submitNotStudying"
          >
            提交
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="activateDialog.show"
      position="bottom"
      round
      :z-index="4230"
      :style="{ height: '52vh', maxHeight: '85vh' }"
    >
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">激活{{ activateDialog.studentName ? ` - ${activateDialog.studentName}` : "" }}</div>
          <van-icon name="cross" class="popup-close" @click="activateDialog.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-field
            readonly
            clickable
            label="预约时间"
            :value="activateDialog.form.bookingTime"
            placeholder="请选择预约时间"
            required
            @click="openActivateTimePicker"
          />
          <van-field
            readonly
            clickable
            label="渠道"
            :value="activateChannelTypeLabel"
            placeholder="请选择渠道"
            @click="openActivateChannelPicker"
          />
          <van-field
            readonly
            clickable
            label="渠道获得者"
            :value="activateChannelStaffLabel"
            placeholder="选填"
            @click="openActivateChannelStaffPicker"
          >
            <template v-if="activateChannelStaffLabel" #button>
              <span class="field-clear-btn" @click.stop="clearActivateChannelStaff">清除</span>
            </template>
          </van-field>
        </div>
        <div class="popup-actions">
          <van-button
            round
            block
            type="primary"
            class="theme-btn"
            :loading="activateDialog.submitting"
            @click="submitActivate"
          >
            提交
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="notStudyingCourseStatusPicker.show" position="bottom" :z-index="4250">
      <van-picker
        show-toolbar
        title="选择状态"
        :columns="notStudyingCourseStatusOptions"
        @confirm="onConfirmNotStudyingCourseStatus"
        @cancel="notStudyingCourseStatusPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="notStudyingDatePicker.show" position="bottom" :z-index="4250">
      <van-datetime-picker
        type="date"
        title="选择生效日期"
        :value="notStudyingDatePicker.value"
        @confirm="onConfirmNotStudyingDate"
        @cancel="notStudyingDatePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="activateTimePicker.show" position="bottom" :z-index="4250">
      <van-datetime-picker
        type="datetime"
        title="选择预约时间"
        :value="activateTimePicker.value"
        @confirm="onConfirmActivateTime"
        @cancel="activateTimePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="activateChannelPicker.show" position="bottom" :z-index="4250">
      <van-picker
        show-toolbar
        title="选择渠道"
        :columns="channelOptions"
        @confirm="onConfirmActivateChannel"
        @cancel="activateChannelPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="activateChannelStaffPicker.show" position="bottom" :z-index="4250">
      <van-search v-model.trim="staffSearch.activateChannel" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        title="选择渠道获得者"
        :columns="filteredActivateChannelStaffOptions"
        @confirm="onConfirmActivateChannelStaff"
        @cancel="activateChannelStaffPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="confirmClassCourseStatusPicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-picker
        show-toolbar
        title="选择开课状态"
        :columns="confirmClassCourseStatusOptions"
        @confirm="onConfirmConfirmClassCourseStatus"
        @cancel="confirmClassCourseStatusPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="confirmClassDatePicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-datetime-picker
        type="date"
        :title="confirmClassDatePicker.title"
        :value="confirmClassDatePicker.value"
        @confirm="onConfirmConfirmClassDate"
        @cancel="confirmClassDatePicker.show = false"
      />
    </van-popup>

    <van-popup
      v-model="confirmClassClassmatePicker.show"
      position="bottom"
      round
      :z-index="FLOW_POPUP_PICKER_Z_INDEX"
      :style="{ height: '70vh' }"
    >
      <div class="student-picker-inner">
        <div class="popup-head">
          <div class="popup-title">选择学员</div>
          <van-icon name="cross" class="popup-close" @click="confirmClassClassmatePicker.show = false" />
        </div>
        <van-search
          v-model="confirmClassClassmatePicker.keyword"
          placeholder="搜索学员姓名/家长/手机号"
          shape="round"
          @search="searchConfirmClassClassmates"
          @input="onConfirmClassClassmateKeywordInput"
        />
        <div class="student-list-wrap">
          <van-loading v-if="confirmClassClassmatePicker.loading" class="panel-loading" size="20px" />
          <van-empty v-else-if="confirmClassClassmatePicker.list.length === 0" description="暂无学员" class="panel-empty" />
          <div
            v-for="stu in confirmClassClassmatePicker.list"
            :key="getConfirmClassStudentRowId(stu)"
            :class="['student-item', { active: isConfirmClassClassmateSelected(getConfirmClassStudentRowId(stu)) }]"
            @click="toggleConfirmClassClassmate(stu)"
          >
            <div class="student-item-name">{{ stu.stuName || "-" }}</div>
            <div class="student-item-sub">{{ stu.name || "-" }} {{ stu.mobile || "" }}</div>
          </div>
        </div>
        <div class="student-picker-actions">
          <span class="student-picker-tip">已选 {{ confirmClassClassmateSelectedCount }} 人</span>
          <van-button
            round
            block
            type="primary"
            class="theme-btn student-picker-confirm-btn"
            @click="confirmConfirmClassClassmatePicker"
          >
            确定
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="checkInResultHostPicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-search v-model.trim="staffSearch.checkInResultHost" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        title="选择测试CC"
        :columns="filteredCheckInResultHostOptions"
        @confirm="onConfirmCheckInResultHost"
        @cancel="checkInResultHostPicker.show = false"
      />
    </van-popup>
    <van-popup v-model="completeHostPicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-search v-model.trim="staffSearch.completeHost" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        title="选择测试CC"
        :columns="filteredCompleteHostOptions"
        @confirm="onConfirmCompleteHost"
        @cancel="completeHostPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="abrsmDialog.show" position="bottom" round :z-index="4300" :style="{ height: '72vh', maxHeight: '85vh' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">{{ abrsmDialog.editMode ? "修改英皇课" : "英皇课" }}</div>
          <van-icon name="cross" class="popup-close" @click="closeFeeBizDialog('abrsm')" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitAbrsm">
            <van-field
              v-model="abrsmDialog.form.amount"
              label="金额"
              placeholder="请输入金额"
              type="number"
              required
              :rules="[{ required: true, message: '请输入金额' }]"
            />
            <van-field
              readonly
              clickable
              label="支付方式"
              :value="getPaymentMethodLabel(abrsmDialog.form.paymentMethod)"
              placeholder="请选择支付方式"
              required
              :rules="[{ required: true, message: '请选择支付方式' }]"
              @click="onOpenPaymentMethodPicker('abrsm')"
            />
            <van-field
              readonly
              clickable
              label="项目"
              :value="getProjectLabel(abrsmDialog.form.projectId)"
              placeholder="请选择项目（选填）"
              @click="openProjectPicker('abrsm')"
            />
            <van-field
              readonly
              clickable
              label="支付时间"
              :value="abrsmDialog.form.completeTime"
              placeholder="请选择支付时间"
              required
              :rules="[{ required: true, message: '请选择支付时间' }]"
              @click="openFeeTimePicker('abrsm')"
            />
            <div class="course-packages-section">
              <div class="course-packages-head">
                <span class="course-packages-title">课包配置</span>
                <span class="course-packages-add" @click="addCoursePackageRow('abrsm')">+ 添加</span>
              </div>
              <div v-for="(pkg, pkgIdx) in abrsmDialog.form.coursePackages" :key="pkg._key" class="course-package-card">
                <div class="course-package-card-head">
                  <span class="course-package-card-index">课包 {{ pkgIdx + 1 }}</span>
                  <van-button
                    plain
                    hairline
                    round
                    size="mini"
                    class="course-package-remove-btn"
                    @click.stop="removeCoursePackageRow('abrsm', pkgIdx)"
                  >
                    删除
                  </van-button>
                </div>
                <van-field
                  readonly
                  clickable
                  label="课包"
                  :value="pkg.coursePackageName"
                  placeholder="请选择课包"
                  required
                  @click="openCoursePackagePicker('abrsm', pkgIdx)"
                />
                <van-field
                  readonly
                  clickable
                  label="退课包"
                  :value="pkg.refundCoursePackageLabel"
                  placeholder="接转课（选填）"
                  @click="openRefundCoursePackagePicker('abrsm', pkgIdx)"
                >
                  <template v-if="pkg.refundCoursePackageLabel" #button>
                    <span class="field-clear-btn" @click.stop="clearRefundCoursePackage('abrsm', pkgIdx)">清除</span>
                  </template>
                </van-field>
                <van-field
                  v-model="pkg.courseNum"
                  label="课程数"
                  placeholder="请输入课程数"
                  type="digit"
                  required
                  @input="onCoursePackageNumInput('abrsm', pkgIdx)"
                />
                <van-field
                  v-model="pkg.courseAmount"
                  label="课程金额"
                  placeholder="请输入课程金额"
                  type="number"
                  required
                  :readonly="isRefundCoursePackageLinked(pkg)"
                  :class="{ 'field-locked': isRefundCoursePackageLinked(pkg) }"
                >
                  <template v-if="isRefundCoursePackageLinked(pkg)" #right-icon>
                    <van-icon name="lock" class="field-lock-icon" />
                  </template>
                </van-field>
              </div>
            </div>
            <van-field
              readonly
              clickable
              label="主课老师"
              :value="abrsmLeadTeacherLabel"
              placeholder="请选择主课老师"
              required
              :rules="[{ required: true, message: '请选择主课老师' }]"
              @click="openFeeStaffPicker('abrsm', 'leadTeacherId', '选择主课老师')"
            />
            <van-field
              readonly
              clickable
              label="副课老师"
              :value="abrsmAssistantTeacherLabel"
              placeholder="选填"
              @click="openFeeAssistantPopup('abrsm')"
            >
              <template v-if="abrsmAssistantTeacherLabel" #button>
                <span class="field-clear-btn" @click.stop="clearFeeAssistantField('abrsm')">清除</span>
              </template>
            </van-field>
            <van-field
              readonly
              clickable
              label="业绩归属人"
              :value="abrsmStaffLabel"
              placeholder="选填"
              @click="openFeeStaffPicker('abrsm', 'staffId', '选择业绩归属人')"
            >
              <template v-if="abrsmStaffLabel" #button>
                <span class="field-clear-btn" @click.stop="clearFeeStaffField('abrsm', 'staffId')">清除</span>
              </template>
            </van-field>
            <van-field
              v-model.trim="abrsmDialog.form.remark"
              label="备注"
              type="textarea"
              rows="2"
              autosize
              placeholder="选填"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="abrsmDialog.submitting" @click="submitAbrsm">
            {{ abrsmDialog.editMode ? "保存" : "提交" }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="renewDialog.show" position="bottom" round :z-index="4300" :style="{ height: '78vh', maxHeight: '85vh' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">{{ renewDialog.editMode ? "修改REN" : "REN" }}</div>
          <van-icon name="cross" class="popup-close" @click="closeFeeBizDialog('renew')" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitRenew">
            <van-field
              v-model="renewDialog.form.amount"
              label="金额"
              placeholder="请输入金额"
              type="number"
              required
              :rules="[{ required: true, message: '请输入金额' }]"
            />
            <van-field
              readonly
              clickable
              label="支付方式"
              :value="getPaymentMethodLabel(renewDialog.form.paymentMethod)"
              placeholder="请选择支付方式"
              required
              :rules="[{ required: true, message: '请选择支付方式' }]"
              @click="onOpenPaymentMethodPicker('renew')"
            />
            <van-field
              readonly
              clickable
              label="项目"
              :value="getProjectLabel(renewDialog.form.projectId)"
              placeholder="请选择项目（选填）"
              @click="openProjectPicker('renew')"
            />
            <van-field
              readonly
              clickable
              label="支付时间"
              :value="renewDialog.form.completeTime"
              placeholder="请选择支付时间"
              required
              :rules="[{ required: true, message: '请选择支付时间' }]"
              @click="openFeeTimePicker('renew')"
            />
            <van-field
              readonly
              clickable
              label="课程"
              :value="renewCourseLabel"
              placeholder="请选择课程"
              required
              :rules="[{ required: true, message: '请选择课程' }]"
              @click="openFeeCoursePicker('renew')"
            />
            <van-field
              v-if="isRenewBookCourse"
              readonly
              clickable
              label="教材"
              :value="renewMdBookLabel"
              placeholder="请选择教材"
              required
              :rules="[{ required: true, message: '请选择教材' }]"
              @click="openMdBookPicker('renew')"
            />
            <div class="course-packages-section">
              <div class="course-packages-head">
                <span class="course-packages-title">课包配置</span>
                <span class="course-packages-add" @click="addCoursePackageRow('renew')">+ 添加</span>
              </div>
              <div v-for="(pkg, pkgIdx) in renewDialog.form.coursePackages" :key="pkg._key" class="course-package-card">
                <div class="course-package-card-head">
                  <span class="course-package-card-index">课包 {{ pkgIdx + 1 }}</span>
                  <van-button
                    plain
                    hairline
                    round
                    size="mini"
                    class="course-package-remove-btn"
                    @click.stop="removeCoursePackageRow('renew', pkgIdx)"
                  >
                    删除
                  </van-button>
                </div>
                <van-field
                  readonly
                  clickable
                  label="课包"
                  :value="pkg.coursePackageName"
                  placeholder="请选择课包"
                  required
                  @click="openCoursePackagePicker('renew', pkgIdx)"
                />
                <van-field
                  readonly
                  clickable
                  label="退课包"
                  :value="pkg.refundCoursePackageLabel"
                  placeholder="接转课（选填）"
                  @click="openRefundCoursePackagePicker('renew', pkgIdx)"
                >
                  <template v-if="pkg.refundCoursePackageLabel" #button>
                    <span class="field-clear-btn" @click.stop="clearRefundCoursePackage('renew', pkgIdx)">清除</span>
                  </template>
                </van-field>
                <van-field
                  v-model="pkg.courseNum"
                  label="课程数"
                  placeholder="请输入课程数"
                  type="digit"
                  required
                  @input="onCoursePackageNumInput('renew', pkgIdx)"
                />
                <van-field
                  v-model="pkg.courseAmount"
                  label="课程金额"
                  placeholder="请输入课程金额"
                  type="number"
                  required
                  :readonly="isRefundCoursePackageLinked(pkg)"
                  :class="{ 'field-locked': isRefundCoursePackageLinked(pkg) }"
                >
                  <template v-if="isRefundCoursePackageLinked(pkg)" #right-icon>
                    <van-icon name="lock" class="field-lock-icon" />
                  </template>
                </van-field>
              </div>
            </div>
            <van-field
              readonly
              clickable
              label="主课老师"
              :value="renewLeadTeacherLabel"
              placeholder="请选择主课老师"
              required
              :rules="[{ required: true, message: '请选择主课老师' }]"
              @click="openFeeStaffPicker('renew', 'leadTeacherId', '选择主课老师')"
            />
            <van-field
              readonly
              clickable
              label="副课老师"
              :value="renewAssistantTeacherLabel"
              placeholder="选填"
              @click="openFeeAssistantPopup('renew')"
            >
              <template v-if="renewAssistantTeacherLabel" #button>
                <span class="field-clear-btn" @click.stop="clearFeeAssistantField('renew')">清除</span>
              </template>
            </van-field>
            <van-field
              readonly
              clickable
              label="业绩归属人"
              :value="renewStaffLabel"
              placeholder="选填"
              @click="openFeeStaffPicker('renew', 'staffId', '选择业绩归属人')"
            >
              <template v-if="renewStaffLabel" #button>
                <span class="field-clear-btn" @click.stop="clearFeeStaffField('renew', 'staffId')">清除</span>
              </template>
            </van-field>
            <van-field
              v-model="renewDialog.form.performanceAmount"
              label="业绩金额"
              placeholder="业绩金额若与支付金额相等不用填"
              type="number"
            />
            <van-field
              v-model.trim="renewDialog.form.remark"
              label="备注"
              type="textarea"
              rows="2"
              autosize
              placeholder="选填"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="renewDialog.submitting" @click="submitRenew">
            {{ renewDialog.editMode ? "保存" : "提交" }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="renew8Dialog.show" position="bottom" round :z-index="4300" :style="{ height: '78vh', maxHeight: '85vh' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">{{ renew8Dialog.editMode ? "修改UP" : "UP" }}</div>
          <van-icon name="cross" class="popup-close" @click="closeFeeBizDialog('renew8')" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitRenew8">
            <van-field
              v-model="renew8Dialog.form.amount"
              label="金额"
              placeholder="请输入金额"
              type="number"
              required
              :rules="[{ required: true, message: '请输入金额' }]"
            />
            <van-field
              readonly
              clickable
              label="支付方式"
              :value="getPaymentMethodLabel(renew8Dialog.form.paymentMethod)"
              placeholder="请选择支付方式"
              required
              :rules="[{ required: true, message: '请选择支付方式' }]"
              @click="onOpenPaymentMethodPicker('renew8')"
            />
            <van-field
              readonly
              clickable
              label="项目"
              :value="getProjectLabel(renew8Dialog.form.projectId)"
              placeholder="请选择项目（选填）"
              @click="openProjectPicker('renew8')"
            />
            <van-field
              readonly
              clickable
              label="支付时间"
              :value="renew8Dialog.form.completeTime"
              placeholder="请选择支付时间"
              required
              :rules="[{ required: true, message: '请选择支付时间' }]"
              @click="openFeeTimePicker('renew8')"
            />
            <van-field
              readonly
              clickable
              label="课程"
              :value="renew8CourseLabel"
              placeholder="请选择课程"
              required
              :rules="[{ required: true, message: '请选择课程' }]"
              @click="openFeeCoursePicker('renew8')"
            />
            <van-field
              v-if="isRenew8BookCourse"
              readonly
              clickable
              label="教材"
              :value="renew8MdBookLabel"
              placeholder="请选择教材"
              required
              :rules="[{ required: true, message: '请选择教材' }]"
              @click="openMdBookPicker('renew8')"
            />
            <div class="course-packages-section">
              <div class="course-packages-head">
                <span class="course-packages-title">课包配置</span>
                <span class="course-packages-add" @click="addCoursePackageRow('renew8')">+ 添加</span>
              </div>
              <div v-for="(pkg, pkgIdx) in renew8Dialog.form.coursePackages" :key="pkg._key" class="course-package-card">
                <div class="course-package-card-head">
                  <span class="course-package-card-index">课包 {{ pkgIdx + 1 }}</span>
                  <van-button
                    plain
                    hairline
                    round
                    size="mini"
                    class="course-package-remove-btn"
                    @click.stop="removeCoursePackageRow('renew8', pkgIdx)"
                  >
                    删除
                  </van-button>
                </div>
                <van-field
                  readonly
                  clickable
                  label="课包"
                  :value="pkg.coursePackageName"
                  placeholder="请选择课包"
                  required
                  @click="openCoursePackagePicker('renew8', pkgIdx)"
                />
                <van-field
                  readonly
                  clickable
                  label="退课包"
                  :value="pkg.refundCoursePackageLabel"
                  placeholder="接转课（选填）"
                  @click="openRefundCoursePackagePicker('renew8', pkgIdx)"
                >
                  <template v-if="pkg.refundCoursePackageLabel" #button>
                    <span class="field-clear-btn" @click.stop="clearRefundCoursePackage('renew8', pkgIdx)">清除</span>
                  </template>
                </van-field>
                <van-field
                  v-model="pkg.courseNum"
                  label="课程数"
                  placeholder="请输入课程数"
                  type="digit"
                  required
                  @input="onCoursePackageNumInput('renew8', pkgIdx)"
                />
                <van-field
                  v-model="pkg.courseAmount"
                  label="课程金额"
                  placeholder="请输入课程金额"
                  type="number"
                  required
                  :readonly="isRefundCoursePackageLinked(pkg)"
                  :class="{ 'field-locked': isRefundCoursePackageLinked(pkg) }"
                >
                  <template v-if="isRefundCoursePackageLinked(pkg)" #right-icon>
                    <van-icon name="lock" class="field-lock-icon" />
                  </template>
                </van-field>
              </div>
            </div>
            <van-field
              readonly
              clickable
              label="主课老师"
              :value="renew8LeadTeacherLabel"
              placeholder="请选择主课老师"
              required
              :rules="[{ required: true, message: '请选择主课老师' }]"
              @click="openFeeStaffPicker('renew8', 'leadTeacherId', '选择主课老师')"
            />
            <van-field
              readonly
              clickable
              label="副课老师"
              :value="renew8AssistantTeacherLabel"
              placeholder="选填"
              @click="openFeeAssistantPopup('renew8')"
            >
              <template v-if="renew8AssistantTeacherLabel" #button>
                <span class="field-clear-btn" @click.stop="clearFeeAssistantField('renew8')">清除</span>
              </template>
            </van-field>
            <van-field
              readonly
              clickable
              label="业绩归属人"
              :value="renew8StaffLabel"
              placeholder="选填"
              @click="openFeeStaffPicker('renew8', 'staffId', '选择业绩归属人')"
            >
              <template v-if="renew8StaffLabel" #button>
                <span class="field-clear-btn" @click.stop="clearFeeStaffField('renew8', 'staffId')">清除</span>
              </template>
            </van-field>
            <van-field
              v-model="renew8Dialog.form.performanceAmount"
              label="业绩金额"
              placeholder="业绩金额若与支付金额相等不用填"
              type="number"
            />
            <van-field
              v-model.trim="renew8Dialog.form.remark"
              label="备注"
              type="textarea"
              rows="2"
              autosize
              placeholder="选填"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="renew8Dialog.submitting" @click="submitRenew8">
            {{ renew8Dialog.editMode ? "保存" : "提交" }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="otherDialog.show" position="bottom" round :z-index="4300" :style="{ height: '58vh', maxHeight: '75vh' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">{{ otherDialog.editMode ? "修改杂费" : "杂费" }}</div>
          <van-icon name="cross" class="popup-close" @click="closeFeeBizDialog('other')" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitOther">
            <van-field
              readonly
              clickable
              label="杂费类型"
              :value="otherFeeTypePickerLabel"
              placeholder="请选择杂费类型"
              required
              :rules="[{ required: true, message: '请选择杂费类型' }]"
              @click="openOtherTypePicker"
            />
            <van-field
              v-model="otherDialog.form.amount"
              label="金额"
              placeholder="请输入金额"
              type="number"
              required
              :rules="[{ required: true, message: '请输入金额' }]"
            />
            <van-field
              readonly
              clickable
              label="支付方式"
              :value="getPaymentMethodLabel(otherDialog.form.paymentMethod)"
              placeholder="请选择支付方式"
              required
              :rules="[{ required: true, message: '请选择支付方式' }]"
              @click="onOpenPaymentMethodPicker('other')"
            />
            <van-field
              readonly
              clickable
              label="项目"
              :value="getProjectLabel(otherDialog.form.projectId)"
              placeholder="请选择项目（选填）"
              @click="openProjectPicker('other')"
            />
            <van-field
              readonly
              clickable
              label="支付时间"
              :value="otherDialog.form.completeTime"
              placeholder="请选择支付时间"
              required
              :rules="[{ required: true, message: '请选择支付时间' }]"
              @click="openFeeTimePicker('other')"
            />
            <van-field
              readonly
              clickable
              label="业绩归属人"
              :value="otherStaffLabel"
              placeholder="请选择业绩归属人（选填）"
              @click="openFeeStaffPicker('other', 'staffId', '选择业绩归属人')"
            >
              <template v-if="otherDialog.form.staffId" #button>
                <span class="field-clear-btn" @click.stop="clearFeeStaffField('other', 'staffId')">清除</span>
              </template>
            </van-field>
            <van-field
              v-model="otherDialog.form.performanceAmount"
              label="业绩金额"
              placeholder="业绩金额若与支付金额相等不用填"
              type="number"
            />
            <van-field
              v-model.trim="otherDialog.form.remark"
              label="备注"
              type="textarea"
              rows="2"
              autosize
              placeholder="选填"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="otherDialog.submitting" @click="submitOther">
            {{ otherDialog.editMode ? "保存" : "提交" }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="otherTypePicker.show" position="bottom" :z-index="4320">
      <van-picker
        show-toolbar
        title="选择杂费类型"
        :columns="otherFeeTypeOptions"
        @confirm="onConfirmOtherType"
        @cancel="otherTypePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="paymentMethodPicker.show" position="bottom" :z-index="FLOW_POPUP_OVERLAY_PICKER_Z_INDEX">
      <van-picker
        show-toolbar
        title="选择支付方式"
        :columns="paymentMethodOptions"
        @confirm="onConfirmPaymentMethod"
        @cancel="paymentMethodPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="headcountPicker.show" position="bottom" :z-index="FLOW_POPUP_OVERLAY_PICKER_Z_INDEX">
      <van-picker
        show-toolbar
        title="选择人头"
        :columns="headcountOptions"
        @confirm="onConfirmHeadcount"
        @cancel="headcountPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="projectPicker.show" position="bottom" :z-index="FLOW_POPUP_OVERLAY_PICKER_Z_INDEX">
      <van-picker
        show-toolbar
        title="选择项目"
        :columns="projectOptions"
        @confirm="onConfirmProject"
        @cancel="projectPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="coursePackagePicker.show" position="bottom" :z-index="FLOW_POPUP_OVERLAY_PICKER_Z_INDEX">
      <van-search
        v-model.trim="coursePackagePicker.keyword"
        placeholder="搜索课包名"
        @search="loadCoursePackageOptions"
        @input="onCoursePackageKeywordInput"
      />
      <van-picker
        show-toolbar
        title="选择课包"
        :columns="coursePackageOptions"
        @confirm="onConfirmCoursePackage"
        @cancel="coursePackagePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="refundCoursePackagePicker.show" position="bottom" :z-index="FLOW_POPUP_OVERLAY_PICKER_Z_INDEX">
      <van-search
        v-model.trim="refundCoursePackagePicker.keyword"
        placeholder="搜索学员姓名"
        shape="round"
        @search="loadRefundCoursePackageOptions"
        @input="onRefundCoursePackageKeywordInput"
      />
      <van-picker
        show-toolbar
        title="选择退课包"
        :columns="refundCoursePackageOptions"
        @confirm="onConfirmRefundCoursePackage"
        @cancel="refundCoursePackagePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="feeStaffPicker.show" position="bottom" :z-index="FLOW_POPUP_OVERLAY_PICKER_Z_INDEX">
      <van-search v-model.trim="staffSearch.fee" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        :title="feeStaffPicker.title || '选择员工'"
        :columns="filteredFeeStaffOptions"
        @confirm="onConfirmFeeStaff"
        @cancel="feeStaffPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="feeAssistantPopup.show" position="bottom" round :z-index="FLOW_POPUP_OVERLAY_PICKER_Z_INDEX" :style="{ height: '60%' }">
      <div class="assign-assistant-popup">
        <div class="popup-head">
          <div class="popup-title">选择副课老师</div>
          <van-icon name="cross" class="popup-close" @click="feeAssistantPopup.show = false" />
        </div>
        <van-search v-model.trim="staffSearch.feeAssistant" placeholder="搜索员工姓名" />
        <div class="assign-assistant-body">
          <van-checkbox-group :value="feeAssistantCurrentIds" @input="onInputFeeAssistantIds">
            <van-cell-group inset>
              <van-cell
                v-for="opt in filteredFeeAssistantStaffOptions"
                :key="`fee-assistant-${opt.value}`"
                clickable
                @click="toggleFeeAssistant(opt.value)"
              >
                <template #title>{{ opt.text }}</template>
                <template #right-icon>
                  <van-checkbox :name="String(opt.value)" @click.stop />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
        <div class="assign-assistant-actions">
          <van-button round block type="primary" class="theme-btn" @click="feeAssistantPopup.show = false">
            完成
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="feeCoursePicker.show" position="bottom" :z-index="4320">
      <van-search v-model.trim="courseSearchKeyword" placeholder="搜索课程" />
      <van-picker
        show-toolbar
        title="选择课程"
        :columns="filteredCourseOptions"
        @confirm="onConfirmFeeCourse"
        @cancel="feeCoursePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="feeTimePicker.show" position="bottom" :z-index="4320">
      <van-datetime-picker
        type="datetime"
        :title="feeTimePicker.title"
        :value="feeTimePicker.value"
        @confirm="onConfirmFeeTime"
        @cancel="feeTimePicker.show = false"
      />
    </van-popup>

    <van-action-sheet
      v-model="detailBizSheetShow"
      :actions="detailBizActions"
      cancel-text="取消"
      close-on-click-action
      :z-index="4250"
      @select="onDetailBizSelect"
    />

    <van-dialog
      v-model="assignDialog.show"
      title="分配老师"
      show-cancel-button
      :before-close="beforeCloseAssignTeacher"
    >
      <div class="dialog-body">
        <van-field
          readonly
          clickable
          label="主课老师"
          :value="assignLeadTeacherLabel"
          placeholder="请选择主课老师"
          @click="openAssignLeadTeacherPicker"
        />
        <van-field
          readonly
          clickable
          label="副课老师"
          :value="assignAssistantTeacherLabels"
          placeholder="请选择副课老师（可多选）"
          @click="openAssignAssistantTeacherPopup"
        >
          <template v-if="assignAssistantTeacherLabels" #button>
            <span class="field-clear-btn" @click.stop="clearAssignAssistantTeachers">清除</span>
          </template>
        </van-field>
      </div>
    </van-dialog>

    <van-dialog
      v-model="setRemainDialog.show"
      title="设置课包剩余课时"
      show-cancel-button
      :z-index="4250"
      :before-close="beforeCloseSetRemain"
    >
      <div class="dialog-body">
        <van-field label="课包" :value="setRemainDialog.coursePackageName" readonly />
        <van-field
          v-model.trim="setRemainDialog.form.remainCourseNum"
          label="剩余课时"
          type="number"
          placeholder="请输入剩余课时"
        />
        <van-field
          v-model.trim="setRemainDialog.form.remark"
          label="备注"
          type="textarea"
          rows="2"
          autosize
          placeholder="必填"
        />
      </div>
    </van-dialog>

    <van-popup v-model="assignLeadTeacherPicker.show" position="bottom">
      <van-search v-model.trim="staffSearch.lead" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        title="选择主课老师"
        :columns="filteredLeadStaffOptions"
        @confirm="onConfirmAssignLeadTeacher"
        @cancel="assignLeadTeacherPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="assignAssistantTeacherPopup.show" position="bottom" round :style="{ height: '60%' }">
      <div class="assign-assistant-popup">
        <div class="popup-head">
          <div class="popup-title">选择副课老师</div>
          <van-icon name="cross" class="popup-close" @click="assignAssistantTeacherPopup.show = false" />
        </div>
        <van-search v-model.trim="staffSearch.assistant" placeholder="搜索员工姓名" />
        <div class="assign-assistant-body">
          <van-checkbox-group v-model="assignDialog.assistantTeacherIds">
            <van-cell-group inset>
              <van-cell
                v-for="opt in filteredAssistantStaffOptions"
                :key="`assistant-${opt.value}`"
                clickable
                @click="toggleAssistant(opt.value)"
              >
                <template #title>{{ opt.text }}</template>
                <template #right-icon>
                  <van-checkbox :name="opt.value" @click.stop />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
        <div class="assign-assistant-actions">
          <van-button round block type="primary" class="theme-btn" @click="assignAssistantTeacherPopup.show = false">
            完成
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="bookingPopup" position="bottom" round :z-index="4000" :style="{ height: '600px' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">新增学员</div>
          <van-icon name="cross" class="popup-close" @click="bookingPopup = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitBooking">
          <van-field
            v-model.trim="bookingForm.stuName"
            name="stuName"
            label="学员名"
            placeholder="请输入学员名"
            required
            :rules="[{ required: true, message: '请输入学员名' }]"
          />
        <van-field
          readonly
          clickable
          name="birthDate"
          label="出生日"
          :value="bookingForm.birthDate"
          placeholder="请选择出生日"
          @click="openBookingBirthDatePicker"
        />
        <van-field :value="bookingAgeDisplay" label="年龄" readonly class="field-locked">
          <template #right-icon>
            <van-icon name="lock" class="field-lock-icon" />
          </template>
        </van-field>
          <van-field name="gender" label="性别">
            <template #input>
              <van-radio-group v-model="bookingForm.gender" direction="horizontal">
                <van-radio :name="1">男</van-radio>
                <van-radio :name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model.trim="bookingForm.name"
            name="name"
            label="家长名"
            placeholder="选填"
          />
          <van-field
            v-model.trim="bookingForm.mobile"
            name="mobile"
            label="手机号"
            placeholder="请输入手机号"
            required
            :rules="[{ required: true, message: '请输入手机号' }]"
          />
          <van-field
            readonly
            clickable
            name="channelType"
            label="渠道"
            :value="channelTypeLabel"
            placeholder="请选择渠道"
            @click="openChannelPicker"
            required
            :rules="[{ required: true, message: '请选择渠道' }]"
          />
          <van-field
            readonly
            clickable
            name="channelStaffId"
            label="渠道获得者"
            :value="bookingChannelStaffLabel"
            placeholder="选填"
            @click="openBookingChannelStaffPicker"
          >
            <template v-if="bookingChannelStaffLabel" #button>
              <span class="field-clear-btn" @click.stop="clearBookingChannelStaff">清除</span>
            </template>
          </van-field>
          <van-field
            v-model.trim="bookingForm.remark"
            name="remark"
            label="备注"
            type="textarea"
            rows="2"
            autosize
            placeholder="选填"
          />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="bookingSubmitting" @click="submitBooking">
            提交
          </van-button>
        </div>
      </div>

      <van-popup v-model="channelPicker.show" position="bottom">
        <van-picker
          show-toolbar
          title="选择渠道"
          :columns="channelOptions"
          @confirm="onConfirmChannel"
          @cancel="channelPicker.show = false"
        />
      </van-popup>
      <van-popup v-model="bookingBirthDatePicker.show" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择出生日"
          :value="bookingBirthDatePicker.value"
          :min-date="birthDateMinDate"
          :max-date="birthDateMaxDate"
          @confirm="onConfirmBookingBirthDate"
          @cancel="bookingBirthDatePicker.show = false"
        />
      </van-popup>
      <van-popup v-model="bookingChannelStaffPicker.show" position="bottom">
        <van-search v-model.trim="staffSearch.bookingChannel" placeholder="搜索员工姓名" />
        <van-picker
          show-toolbar
          title="选择渠道获得者"
          :columns="filteredBookingChannelStaffOptions"
          @confirm="onConfirmBookingChannelStaff"
          @cancel="bookingChannelStaffPicker.show = false"
        />
      </van-popup>
    </van-popup>

    <van-popup v-model="expansionDialog.show" position="bottom" round :z-index="4420" :style="{ height: '300px' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">拓科</div>
          <van-icon name="cross" class="popup-close" @click="expansionDialog.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitExpansion">
            <van-field
              readonly
              clickable
              name="channelType"
              label="渠道"
              :value="expansionChannelTypeLabel"
              placeholder="请选择渠道"
              @click="openExpansionChannelPicker"
            />
            <van-field
              readonly
              clickable
              name="channelStaffId"
              label="渠道获得者"
              :value="expansionChannelStaffLabel"
              placeholder="请选择渠道获得者"
              @click="openExpansionChannelStaffPicker"
            >
              <template v-if="expansionChannelStaffLabel" #button>
                <span class="field-clear-btn" @click.stop="clearExpansionChannelStaff">清除</span>
              </template>
            </van-field>
            <van-field
              v-model.trim="expansionDialog.form.remark"
              label="备注"
              type="textarea"
              rows="2"
              autosize
              placeholder="请输入备注（选填）"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button
            round
            block
            type="primary"
            class="theme-btn"
            :loading="expansionDialog.submitting"
            @click="submitExpansion"
          >
            提交
          </van-button>
        </div>
      </div>

      <van-popup v-model="expansionChannelPicker.show" position="bottom" :z-index="4430">
        <van-picker
          show-toolbar
          title="选择渠道"
          :columns="channelOptions"
          @confirm="onConfirmExpansionChannel"
          @cancel="expansionChannelPicker.show = false"
        />
      </van-popup>
      <van-popup v-model="expansionChannelStaffPicker.show" position="bottom" :z-index="4430">
        <van-search v-model.trim="staffSearch.expansionChannel" placeholder="搜索员工姓名" />
        <van-picker
          show-toolbar
          title="选择渠道获得者"
          :columns="filteredExpansionChannelStaffOptions"
          @confirm="onConfirmExpansionChannelStaff"
          @cancel="expansionChannelStaffPicker.show = false"
        />
      </van-popup>
    </van-popup>

    <van-popup v-model="invitePopup.show" position="bottom" round :z-index="4400" :style="{ height: '320px' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">邀约</div>
          <van-icon name="cross" class="popup-close" @click="invitePopup.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitInvite">
            <van-field
              readonly
              clickable
              name="bookingTime"
              label="邀约时间"
              :value="inviteForm.bookingTime"
              placeholder="请选择邀约时间"
              required
              :rules="[{ required: true, message: '请选择邀约时间' }]"
              @click="inviteTimePicker.show = true"
            />
            <van-field
              readonly
              clickable
              name="channelType"
              label="渠道"
              :value="inviteChannelTypeLabel"
              placeholder="请选择渠道"
              @click="openInviteChannelPicker"
            />
            <van-field
              readonly
              clickable
              name="channelStaffId"
              label="渠道获得者"
              :value="inviteChannelStaffLabel"
              placeholder="请选择渠道获得者"
              @click="openInviteChannelStaffPicker"
            >
              <template v-if="inviteChannelStaffLabel" #button>
                <span class="field-clear-btn" @click.stop="clearInviteChannelStaff">清除</span>
              </template>
            </van-field>
            <van-field
              readonly
              clickable
              name="trialCourseId"
              label="试听课程"
              :value="inviteTrialCourseLabel"
              placeholder="请选择试听课程（选填）"
              @click="openInviteCoursePicker"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="inviteSubmitting" @click="submitInvite">
            提交
          </van-button>
        </div>
      </div>

      <van-popup v-model="inviteTimePicker.show" position="bottom" :z-index="4410">
        <van-datetime-picker
          type="datetime"
          title="选择邀约时间"
          :value="inviteTimePicker.value"
          @confirm="onConfirmInviteTime"
          @cancel="inviteTimePicker.show = false"
        />
      </van-popup>
      <van-popup v-model="inviteCoursePicker.show" position="bottom" :z-index="4410">
        <van-search v-model.trim="courseSearchKeyword" placeholder="搜索课程" />
        <van-picker
          show-toolbar
          title="选择试听课程"
          :columns="filteredInviteCourseOptions"
          @confirm="onConfirmInviteCourse"
          @cancel="inviteCoursePicker.show = false"
        />
      </van-popup>
      <van-popup v-model="inviteChannelPicker.show" position="bottom" :z-index="4410">
        <van-picker
          show-toolbar
          title="选择渠道"
          :columns="channelOptions"
          @confirm="onConfirmInviteChannel"
          @cancel="inviteChannelPicker.show = false"
        />
      </van-popup>
      <van-popup v-model="inviteChannelStaffPicker.show" position="bottom" :z-index="4410">
        <van-search v-model.trim="staffSearch.bookingChannel" placeholder="搜索员工姓名" />
        <van-picker
          show-toolbar
          title="选择渠道获得者"
          :columns="filteredBookingChannelStaffOptions"
          @confirm="onConfirmInviteChannelStaff"
          @cancel="inviteChannelStaffPicker.show = false"
        />
      </van-popup>
    </van-popup>

    <van-popup v-model="checkInPopup.show" position="bottom" round :z-index="FLOW_POPUP_Z_INDEX" :style="{ height: '440px' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">到店信息</div>
          <van-icon name="cross" class="popup-close" @click="checkInPopup.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form class="booking-form" @submit="submitCheckIn">
            <van-field
              readonly
              clickable
              name="hostStaffId"
              label="测试CC"
              :value="hostStaffLabel"
              placeholder="请选择测试CC"
              @click="openHostStaffPicker"
              :rules="[{ required: true, message: '请选择测试CC' }]"
            />
            <van-field
              readonly
              clickable
              name="trialTeacherId"
              label="试听老师"
              :value="trialTeacherLabel"
              placeholder="请选择试听老师"
              @click="openTrialTeacherPicker"
              :rules="[{ required: true, message: '请选择试听老师' }]"
            />
            <van-field
              readonly
              clickable
              name="trialCourseId"
              label="试听课程"
              :value="checkInTrialCourseLabel"
              placeholder="请选择试听课程（选填）"
              @click="openCheckInCoursePicker"
            />
            <van-field
              readonly
              clickable
              name="checkInTime"
              label="测试时间"
              :value="checkInForm.checkInTime"
              placeholder="请选择测试时间"
              @click="checkInTimePicker.show = true"
              :rules="[{ required: true, message: '请选择测试时间' }]"
            />
            <van-field
              v-model.trim="checkInForm.signRemark"
              label="到店备注"
              type="textarea"
              rows="2"
              autosize
              placeholder="选填"
            />
          </van-form>
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="checkInSubmitting" @click="submitCheckIn">
            确认到店
          </van-button>
        </div>
      </div>

      <van-popup v-model="hostStaffPicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
        <van-search v-model.trim="staffSearch.host" placeholder="搜索员工姓名" />
        <van-picker
          show-toolbar
          title="选择测试CC"
          :columns="filteredHostStaffOptions"
          @confirm="onConfirmHostStaff"
          @cancel="hostStaffPicker.show = false"
        />
      </van-popup>

      <van-popup v-model="trialTeacherPicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
        <van-search v-model.trim="staffSearch.trial" placeholder="搜索员工姓名" />
        <van-picker
          show-toolbar
          title="选择试听老师"
          :columns="filteredTrialStaffOptions"
          @confirm="onConfirmTrialTeacher"
          @cancel="trialTeacherPicker.show = false"
        />
      </van-popup>

      <van-popup v-model="checkInTimePicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
        <van-datetime-picker
          type="datetime"
          title="选择测试时间"
          :value="checkInTimePicker.value"
          @confirm="onConfirmCheckInTime"
          @cancel="checkInTimePicker.show = false"
        />
      </van-popup>

      <van-popup v-model="checkInCoursePicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
        <van-search v-model.trim="courseSearchKeyword" placeholder="搜索课程" />
        <van-picker
          show-toolbar
          title="选择试听课程"
          :columns="filteredCheckInCourseOptions"
          @confirm="onConfirmCheckInCourse"
          @cancel="checkInCoursePicker.show = false"
        />
      </van-popup>
    </van-popup>

    <van-calendar
      v-model="dateRangePickerShow"
      type="range"
      :min-date="dateRangePickerMinDate"
      :max-date="dateRangePickerMaxDate"
      :allow-same-day="true"
      :show-confirm="true"
      :default-date="dateRangePickerDefault"
      :z-index="5000"
      color="rgb(242, 124, 52)"
      @close="dateRangePickerShow = false"
      @confirm="onConfirmDateRange"
    />

    <van-popup v-model="topDepartmentPicker.show" position="bottom">
      <van-picker
        show-toolbar
        title="选择中心"
        :columns="topDepartmentOptions"
        @confirm="onConfirmTopDepartment"
        @cancel="topDepartmentPicker.show = false"
      />
    </van-popup>
    <van-popup v-model="timeFilterPicker.show" position="bottom">
      <van-picker
        show-toolbar
        title="选择时间类型"
        :columns="timeFilterOptions"
        @confirm="onConfirmTimeFilter"
        @cancel="timeFilterPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="checkInResultPicker.show" position="bottom" :z-index="FLOW_POPUP_PICKER_Z_INDEX">
      <van-picker
        show-toolbar
        title="选择到店结果"
        :columns="checkInResultOptions"
        @confirm="onConfirmCheckInResult"
        @cancel="checkInResultPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="listCheckInResultFilterPicker.show" position="bottom">
      <van-picker
        show-toolbar
        title="筛选到店结果"
        :columns="listCheckInResultFilterColumns"
        @confirm="onConfirmListCheckInResultFilter"
        @cancel="listCheckInResultFilterPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="listCourseStatusFilterPicker.show" position="bottom">
      <van-picker
        show-toolbar
        title="筛选开课状态"
        :columns="listCourseStatusFilterColumns"
        @confirm="onConfirmListCourseStatusFilter"
        @cancel="listCourseStatusFilterPicker.show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import {
  fetchCustomerList,
  checkInCustomer,
  cancelBooking,
  deleteCustomer,
  checkInResultCustomer,
  createCustomerInput,
  validateCustomerMobile,
  bookingCustomer,
  againBookingCustomer,
  expansionCustomer,
  updateCustomer,
  updateRenew,
  fetchDictionary,
  fetchStaffList,
  fetchTopDepartments,
  completeCustomer,
  confirmClassCustomer,
  submitCourseStatus,
  activateCustomer,
  assignTeacher,
  customerAbrsm,
  customerRenew,
  customerRenew8,
  customerOther
} from "@/api/customer"
import { fetchProjectList } from "@/api/project"
import { getLoginUserId } from "@/utils/auth"
import { normalizeProjectOptions, formatProjectName as formatProjectNameText } from "@/utils/project"
import { ensureCurrentStaffProfile } from "@/store/currentStaff"
import { fetchBooks, fetchBookCourses } from "@/api/book"
import { fetchCoursePackageList } from "@/api/coursePackage"
import { fetchUntransferredCoursePackageList } from "@/api/refund"
import { setCoursePackageRemain } from "@/api/courseConsumed"
import { resetPageScrollAfterPaint } from "@/utils/scroll"

const CHANNEL_DICT_TYPE_ID = 100
const CHECKIN_RESULT_DICT_TYPE_ID = 106
const LIST_CHECKIN_RESULT_FILTER_ALL = "__ALL__"
const LIST_COURSE_STATUS_FILTER_ALL = "__ALL__"
const STAFF_PAGE_SIZE = 200
const ENABLED_BOOK_STATUS = 1
const COMPLETE_MD_COURSE_NAME = "MD"
const INCOME_MANAGE_ALLOWED_USER_IDS = [3, 6, 43, 40, 72]
/** 需选择教材的课程（MD、Smart） */
const BOOK_REQUIRED_COURSE_NAMES = ["MD", "SMART"]
/** 学员列表「全部」Tab：statusList 不含作废(5) */
const CUSTOMER_STATUS_LIST_EXCLUDE_CANCELLED = [0, 1, 2, 3, 4]
/** 学员详情续费子记录一次拉取条数 */
const DETAIL_RENEW_FETCH_SIZE = 500
/** 学员详情弹层 z-index（流程弹层需高于此值） */
const DETAIL_DIALOG_Z_INDEX = 4200
const FLOW_POPUP_Z_INDEX = 4450
const FLOW_POPUP_PICKER_Z_INDEX = 4460
const FLOW_POPUP_OVERLAY_PICKER_Z_INDEX = 4470

/** 录收入子单 type：2=UP，3=REN，4=英皇课，5=杂费 */
const RENEW_RECORD_TYPE = {
  REN: 3,
  UP: 2,
  ABRSM: 4,
  OTHER: 5
}

const RENEW_RECORD_TYPE_LABEL = {
  [RENEW_RECORD_TYPE.REN]: "REN",
  [RENEW_RECORD_TYPE.UP]: "UP",
  [RENEW_RECORD_TYPE.ABRSM]: "英皇课",
  [RENEW_RECORD_TYPE.OTHER]: "杂费"
}

/** 杂费类型 abrsmType */
const OTHER_FEE_TYPE_OPTIONS = [
  { text: "考级费用", value: 1 },
  { text: "比赛费用", value: 2 },
  { text: "琴房使用", value: 3 },
  { text: "钢琴搬运", value: 4 },
  { text: "音乐会门票", value: 5 },
  { text: "节拍器/书本费", value: 6 },
  { text: "乐器售卖", value: 7 },
  { text: "试听费用", value: 9 },
  { text: "其他杂费", value: 8 },
]

/** 开课状态 courseStatus */
const CONFIRM_CLASS_COURSE_STATUS_OPTIONS = [
  { text: "还在学", value: 1 },
  { text: "停课", value: 2 },
  { text: "16次未学完6个阶段未续费", value: 3 },
  { text: "16次以上未学完6个阶段未续费", value: 4 },
  { text: "6个阶段毕业", value: 5 },
  { text: "转中心", value: 6 },
  { text: "退费", value: 7 },
  { text: "转课", value: 8 }
]

/** 不在学状态（submit-course-status） */
const NOT_STUDYING_COURSE_STATUS_OPTIONS = [
  { text: "停课", value: 2 },
  { text: "16次未学完6个阶段未续费", value: 3 },
  { text: "16次以上未学完6个阶段未续费", value: 4 },
  { text: "6个阶段毕业", value: 5 }
]

const TIME_FILTER_OPTIONS = [
  { text: "创建时间", value: "create" },
  { text: "预约时间", value: "booking" },
  { text: "测试时间", value: "checkIn" },
  { text: "定金支付时间", value: "paid" },
  { text: "成单时间", value: "complete" }
]

const PAYMENT_METHOD_OPTIONS = [
  { text: "刷卡(用POS机)", value: 1 },
  { text: "支付宝-校方主扫码", value: 2 },
  { text: "支付宝-校方被扫", value: 3 },
  { text: "微信-校方主扫码", value: 4 },
  { text: "微信-校方被扫", value: 5 },
  { text: "转账(转公司公账)", value: 6 },
  { text: "大众点评", value: 7 },
  { text: "扫后台码付款", value: 8 },
  { text: "现金(微信或支付宝收款)", value: 9 }
]

const HEADCOUNT_OPTIONS = [
  { text: "0", value: 0 },
  { text: "0.5", value: 0.5 },
  { text: "1", value: 1 }
]

function pad2(n) {
  return String(n).padStart(2, "0")
}

function formatDateTime(d) {
  const yyyy = d.getFullYear()
  const mm = pad2(d.getMonth() + 1)
  const dd = pad2(d.getDate())
  const hh = pad2(d.getHours())
  const mi = pad2(d.getMinutes())
  const ss = pad2(d.getSeconds())
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`
}

function formatDate(d) {
  const yyyy = d.getFullYear()
  const mm = pad2(d.getMonth() + 1)
  const dd = pad2(d.getDate())
  return `${yyyy}-${mm}-${dd}`
}

function parseDateSafe(v) {
  if (!v) return null
  const dt = new Date(String(v).replace(/-/g, "/"))
  return Number.isNaN(dt.getTime()) ? null : dt
}

function calcAgeByBirthDate(birthDate) {
  const birth = parseDateSafe(birthDate)
  if (!birth) return null
  const now = new Date()
  let age = now.getFullYear() - birth.getFullYear()
  const m = now.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
    age -= 1
  }
  return age >= 0 ? age : null
}

function getTenYearsAgoJan1() {
  const now = new Date()
  return new Date(now.getFullYear() - 10, 0, 1)
}

function getBirthDateMinDate() {
  return new Date(1900, 0, 1)
}

function getBirthDateMaxDate() {
  const now = new Date()
  now.setHours(23, 59, 59, 999)
  return now
}

function getEmptyRange() {
  return {
    startDate: "",
    endDate: ""
  }
}

function getNextDayNineAM() {
  const dt = new Date()
  dt.setDate(dt.getDate() + 1)
  dt.setHours(9, 0, 0, 0)
  return dt
}

export default {
  name: "CustomerTrackView",
  data() {
    return {
      DETAIL_DIALOG_Z_INDEX,
      FLOW_POPUP_Z_INDEX,
      FLOW_POPUP_PICKER_Z_INDEX,
      FLOW_POPUP_OVERLAY_PICKER_Z_INDEX,
      keyword: "",
      statusTab: "all",
      /** 从到店结果筛选确认里切换 Tab 时，避免 @change 与手动 onRefresh 各刷一次 */
      skipStatusChangeRefreshOnce: false,

      page: 1,
      pageSize: 10,
      listTotalRecords: 0,

      items: [],
      loading: false,
      finished: false,
      refreshing: false,
      loadError: false,
      scrollToTopAfterLoad: false,

      checkInResultDialog: {
        show: false,
        id: null,
        parentCustomerId: null,
        hostStaffId: null,
        hostStaffName: "",
        checkInResult: null,
        checkInRemark: "",
        depositAmount: "",
        paidTime: "",
        isDepositIncomeConfirm: false,
        isPersonalPerformance: false,
        depositPaymentMethod: null,
        depositProjectId: null
      },
      checkInResultSubmitting: false,
      checkInResultOptions: [],
      checkInResultLoading: false,
      checkInResultPicker: { show: false },
      listCheckInResultFilter: null,
      listCheckInResultFilterPicker: { show: false },
      listCourseStatusFilter: null,
      listCourseStatusFilterPicker: { show: false },
      detailDialog: {
        show: false
      },
      detailBizSheetShow: false,
      detailBizActions: [
        { name: "UP", key: "renew8" },
        { name: "REN", key: "renew" },
        { name: "英皇课", key: "abrsm" },
        { name: "杂费", key: "other" }
      ],
      detailItem: {},
      detailRenewList: [],
      detailRenewLoading: false,
      updateDialog: {
        show: false,
        isDepositIncomeConfirm: false,
        isOrderIncomeConfirm: false,
        form: {
          id: null,
          status: null,
          name: "",
          stuName: "",
          mobile: "",
          birthDate: "",
          age: "",
          gender: null,
          channelType: null,
          channelStaffId: null,
          remark: "",
          bookingTime: "",
          hostStaffId: null,
          trialTeacherId: null,
          checkInTime: "",
          checkInResult: null,
          checkInRemark: "",
          depositAmount: "",
          paidTime: "",
          depositPaymentMethod: null,
          depositProjectId: null,
          isPersonalPerformance: false,
          amount: "",
          completeTime: "",
          paymentMethod: null,
          performanceAmount: "",
          projectId: null,
          courseId: null,
          leadTeacherId: null,
          assistantTeacherIds: []
        }
      },
      updateSubmitting: false,
      updateChannelPicker: {
        show: false
      },
      updateStaffPicker: {
        show: false,
        title: "",
        target: ""
      },
      updateAssistantPopup: {
        show: false
      },
      updateCoursePicker: {
        show: false
      },
      updateCheckInResultPicker: {
        show: false
      },
      updateTimePicker: {
        show: false,
        title: "",
        target: "",
        type: "datetime",
        value: new Date()
      },
      updateStaffSearch: {
        single: "",
        assistant: ""
      },
      paidTimePicker: {
        show: false,
        value: new Date()
      },
      completeDialog: {
        show: false,
        id: null,
        parentCustomerId: null,
        hostStaffId: null,
        hostStaffName: "",
        amount: "",
        courseId: null,
        courseName: "",
        completeTime: "",
        bookIds: [],
        isOrderIncomeConfirm: false,
        paymentMethod: null,
        performanceAmount: "",
        headcount: 1,
        projectId: null
      },
      completeSubmitting: false,
      completeBookOptions: [],
      completeBookLoading: false,
      completeBookPicker: {
        show: false,
        source: "complete"
      },
      purchasedBooksExpanded: {},
      assignDialog: {
        show: false,
        id: null,
        leadTeacherId: null,
        assistantTeacherIds: []
      },
      setRemainDialog: {
        show: false,
        submitting: false,
        coursePackageId: null,
        coursePackageName: "",
        form: {
          remainCourseNum: "",
          remark: ""
        }
      },
      assignLeadTeacherPicker: {
        show: false
      },
      assignAssistantTeacherPopup: {
        show: false
      },
      completeTimePicker: {
        show: false,
        value: new Date()
      },
      confirmClassDialog: {
        show: false,
        submitting: false,
        form: {
          id: null,
          parentCustomerId: null,
          leadTeacherId: null,
          leadTeacherName: "",
          assistantTeacherIds: [],
          classmateIds: [],
          classmateNameMap: {},
          confirmStartDate: "",
          firstClassDate: "",
          courseStatus: 1,
          startUnit: "",
          coursePackages: []
        }
      },
      confirmClassCourseStatusPicker: {
        show: false
      },
      confirmClassDatePicker: {
        show: false,
        field: "",
        title: "",
        value: new Date()
      },
      confirmClassClassmatePicker: {
        show: false,
        loading: false,
        keyword: "",
        keywordTimer: null,
        list: []
      },
      notStudyingDialog: {
        show: false,
        submitting: false,
        recordId: null,
        studentName: "",
        form: {
          courseStatus: null,
          statusDate: "",
          remark: ""
        }
      },
      notStudyingCourseStatusPicker: { show: false },
      notStudyingDatePicker: { show: false, value: new Date() },
      activateDialog: {
        show: false,
        submitting: false,
        recordId: null,
        studentName: "",
        form: {
          channelType: null,
          channelStaffId: null,
          bookingTime: ""
        }
      },
      activateTimePicker: { show: false, value: new Date() },
      activateChannelPicker: { show: false },
      activateChannelStaffPicker: { show: false },
      checkInResultHostPicker: {
        show: false
      },
      completeHostPicker: {
        show: false
      },
      courseOptions: [],
      expansionCourseOptions: [],
      courseSearchKeyword: "",
      courseLoading: false,
      expansionCourseLoading: false,
      coursePicker: {
        show: false
      },
      abrsmDialog: {
        show: false,
        submitting: false,
        editMode: false,
        form: {
          id: null,
          amount: "",
          completeTime: "",
          paymentMethod: null,
          coursePackages: [],
          leadTeacherId: null,
          assistantTeacherIds: [],
          remark: "",
          staffId: null,
          projectId: null
        }
      },
      renewDialog: {
        show: false,
        submitting: false,
        editMode: false,
        form: {
          id: null,
          amount: "",
          completeTime: "",
          paymentMethod: null,
          coursePackages: [],
          courseId: null,
          courseName: "",
          leadTeacherId: null,
          assistantTeacherIds: [],
          remark: "",
          staffId: null,
          performanceAmount: "",
          bookIds: [],
          projectId: null
        }
      },
      renew8Dialog: {
        show: false,
        submitting: false,
        editMode: false,
        form: {
          id: null,
          amount: "",
          completeTime: "",
          paymentMethod: null,
          coursePackages: [],
          courseId: null,
          courseName: "",
          leadTeacherId: null,
          assistantTeacherIds: [],
          remark: "",
          staffId: null,
          performanceAmount: "",
          bookIds: [],
          projectId: null
        }
      },
      otherDialog: {
        show: false,
        submitting: false,
        editMode: false,
        form: {
          id: null,
          abrsmType: null,
          amount: "",
          completeTime: "",
          paymentMethod: null,
          staffId: null,
          staffName: "",
          performanceAmount: "",
          remark: "",
          projectId: null
        }
      },
      feeStaffPicker: {
        show: false,
        dialogKey: "",
        field: "",
        title: ""
      },
      feeAssistantPopup: {
        show: false,
        dialogKey: ""
      },
      feeCoursePicker: {
        show: false,
        dialogKey: ""
      },
      feeTimePicker: {
        show: false,
        dialogKey: "",
        title: "选择时间",
        value: new Date()
      },
      otherFeeTypeOptions: OTHER_FEE_TYPE_OPTIONS,
      paymentMethodOptions: PAYMENT_METHOD_OPTIONS,
      headcountOptions: HEADCOUNT_OPTIONS,
      otherTypePicker: {
        show: false
      },
      paymentMethodPicker: {
        show: false,
        target: ""
      },
      headcountPicker: {
        show: false,
        target: ""
      },
      projectOptions: [],
      projectLoading: false,
      projectPicker: {
        show: false,
        target: ""
      },
      coursePackageOptions: [],
      coursePackagePicker: {
        show: false,
        target: "",
        index: 0,
        keyword: "",
        keywordTimer: null
      },
      refundCoursePackageOptions: [],
      refundCoursePackagePicker: {
        show: false,
        target: "",
        index: 0,
        keyword: "",
        keywordTimer: null
      },
      bookingPopup: false,
      bookingSubmitting: false,
      bookingForm: {
        name: "",
        mobile: "",
        stuName: "",
        birthDate: "",
        age: "",
        gender: null,
        channelType: null,
        channelStaffId: null,
        remark: ""
      },
      bookingBirthDatePicker: {
        show: false,
        value: getTenYearsAgoJan1()
      },
      birthDateMinDate: getBirthDateMinDate(),
      birthDateMaxDate: getBirthDateMaxDate(),
      invitePopup: {
        show: false,
        id: null,
        parentCustomerId: null,
        mode: "booking"
      },
      inviteSubmitting: false,
      inviteForm: {
        bookingTime: "",
        trialCourseId: null,
        channelType: null,
        channelStaffId: null
      },
      inviteTimePicker: { show: false, value: new Date() },
      inviteCoursePicker: { show: false },
      inviteChannelPicker: { show: false },
      inviteChannelStaffPicker: { show: false },
      channelOptions: [],
      channelLoading: false,
      channelPicker: {
        show: false
      },
      bookingChannelStaffPicker: {
        show: false
      },

      checkInPopup: {
        show: false,
        customerId: null,
        parentCustomerId: null
      },
      checkInSubmitting: false,
      checkInForm: {
        hostStaffId: null,
        trialTeacherId: null,
        trialCourseId: null,
        checkInTime: "",
        signRemark: ""
      },
      checkInCoursePicker: { show: false },
      staffOptions: [],
      staffSearch: {
        host: "",
        trial: "",
        lead: "",
        assistant: "",
        bookingChannel: "",
        activateChannel: "",
        checkInResultHost: "",
        completeHost: "",
        fee: "",
        feeAssistant: "",
        expansionChannel: ""
      },
      staffLoading: false,
      hostStaffPicker: { show: false },
      trialTeacherPicker: { show: false },
      checkInTimePicker: { show: false, value: new Date() },

      dateRange: getEmptyRange(),
      timeFilterOptions: TIME_FILTER_OPTIONS,
      timeFilterType: "checkIn",
      timeFilterPicker: { show: false },
      topDepartmentId: null,
      topDepartmentOptions: [],
      topDepartmentLoading: false,
      topDepartmentPicker: { show: false },
      dateRangePickerShow: false,
      dateRangePickerMinDate: new Date(1970, 0, 1),
      dateRangePickerMaxDate: new Date(2100, 11, 31),
      keywordTimer: null,
      loginAuthType: null,
      expansionDialog: {
        show: false,
        submitting: false,
        form: {
          channelType: null,
          channelStaffId: null,
          remark: ""
        }
      },
      expansionChannelPicker: { show: false },
      expansionChannelStaffPicker: { show: false }
    }
  },
  mounted() {
    this.ensureLoginStaffInfo()
    this.ensureTopDepartmentOptions()
    this.onRefresh()
  },
  beforeDestroy() {
    if (this.keywordTimer) {
      clearTimeout(this.keywordTimer)
      this.keywordTimer = null
    }
  },
  watch: {
    keyword() {
      this.onKeywordInput()
    }
  },
  computed: {
    dateRangePickerDefault() {
      const start = this.dateRange.startDate
      const end = this.dateRange.endDate
      if (!start || !end) {
        const today = new Date()
        const tomorrow = new Date()
        tomorrow.setDate(today.getDate() + 1)
        return [today, tomorrow]
      }
      return [new Date(start.replace(/-/g, "/")), new Date(end.replace(/-/g, "/"))]
    },
    timeFilterLabel() {
      const opt = TIME_FILTER_OPTIONS.find(x => x.value === this.timeFilterType)
      return opt ? opt.text : "测试时间"
    },
    topDepartmentLabel() {
      if (!this.topDepartmentId) return ""
      const opt = this.topDepartmentOptions.find(x => String(x.value) === String(this.topDepartmentId))
      return opt ? opt.text : ""
    },
    canDeleteCancelledStudent() {
      const uid = Number(getLoginUserId())
      return Number.isFinite(uid) && INCOME_MANAGE_ALLOWED_USER_IDS.includes(uid)
    },
    canShowVoidButton() {
      const authType = Number(this.loginAuthType)
      return authType === 2 || authType === 3
    },
    channelTypeLabel() {
      const v = this.bookingForm.channelType
      if (v === null || v === undefined || v === "") return ""
      const o = this.channelOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    bookingChannelStaffLabel() {
      const v = this.bookingForm.channelStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    checkInResultLabel() {
      const v = this.checkInResultDialog.checkInResult
      if (v === null || v === undefined || v === "") return ""
      const o = this.checkInResultOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    listCheckInResultFilterColumns() {
      return [{ text: "全部", value: LIST_CHECKIN_RESULT_FILTER_ALL }, ...this.checkInResultOptions]
    },
    listCheckInResultFilterLabel() {
      const v = this.listCheckInResultFilter
      if (v === null || v === undefined || v === "") return "全部"
      const o = this.checkInResultOptions.find(x => String(x.value) === String(v))
      return o ? o.text : String(v)
    },
    listCourseStatusFilterColumns() {
      return [{ text: "全部", value: LIST_COURSE_STATUS_FILTER_ALL }, ...CONFIRM_CLASS_COURSE_STATUS_OPTIONS]
    },
    listCourseStatusFilterLabel() {
      const v = this.listCourseStatusFilter
      if (v === null || v === undefined || v === "") return "全部"
      const hit = CONFIRM_CLASS_COURSE_STATUS_OPTIONS.find(x => Number(x.value) === Number(v))
      return hit ? hit.text : String(v)
    },
    updateCheckInResultLabel() {
      const v = this.updateDialog.form.checkInResult
      if (v === null || v === undefined || v === "") return ""
      const o = this.checkInResultOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateChannelTypeLabel() {
      const v = this.updateDialog.form.channelType
      if (v === null || v === undefined || v === "") return ""
      const o = this.channelOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateChannelStaffLabel() {
      const v = this.updateDialog.form.channelStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    bookingAgeDisplay() {
      const n = calcAgeByBirthDate(this.bookingForm.birthDate)
      return n === null ? "-" : `${n}岁`
    },
    updateAgeDisplay() {
      const n = calcAgeByBirthDate(this.updateDialog.form.birthDate)
      return n === null ? "-" : `${n}岁`
    },
    hostStaffLabel() {
      const v = this.checkInForm.hostStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    trialTeacherLabel() {
      const v = this.checkInForm.trialTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    checkInResultHostStaffLabel() {
      const v = this.checkInResultDialog.hostStaffId
      if (v === null || v === undefined || v === "") return this.checkInResultDialog.hostStaffName || ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : (this.checkInResultDialog.hostStaffName || "")
    },
    completeHostStaffLabel() {
      const v = this.completeDialog.hostStaffId
      if (v === null || v === undefined || v === "") return this.completeDialog.hostStaffName || ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : (this.completeDialog.hostStaffName || "")
    },
    courseLabel() {
      const v = this.completeDialog.courseId
      if (v === null || v === undefined || v === "") return (this.completeDialog.courseName || "").trim()
      const options = this.completeDialog.parentCustomerId ? this.expansionCourseOptions : this.courseOptions
      const o = options.find(x => String(x.value) === String(v))
      return o ? o.text : (this.completeDialog.courseName || "").trim()
    },
    isCompleteMdCourse() {
      return this.isBookRequiredCourseLabel(this.courseLabel)
    },
    isRenewBookCourse() {
      return this.isBookRequiredCourseLabel(this.renewCourseLabel)
    },
    isRenew8BookCourse() {
      return this.isBookRequiredCourseLabel(this.renew8CourseLabel)
    },
    activeMdBookIds() {
      const source = this.completeBookPicker.source || "complete"
      return this.getMdBookIdsArray(source)
    },
    isActiveMdBookAllSelected() {
      const ids = this.allCompleteBookIds()
      if (!ids.length) return false
      const selected = new Set(this.activeMdBookIds.map(x => String(x)))
      return ids.every(id => selected.has(String(id)))
    },
    completeBookLabel() {
      return this.mdBookLabelByIds(this.completeDialog?.bookIds || [])
    },
    renewMdBookLabel() {
      return this.mdBookDisplayLabel(this.renewDialog.form)
    },
    renew8MdBookLabel() {
      return this.mdBookDisplayLabel(this.renew8Dialog.form)
    },
    isCompleteBookAllSelected() {
      return this.isActiveMdBookAllSelected
    },
    inviteTrialCourseLabel() {
      const v = this.inviteForm.trialCourseId
      if (v === null || v === undefined || v === "") return ""
      const options = this.invitePopup.parentCustomerId ? this.expansionCourseOptions : this.courseOptions
      const o = options.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    inviteChannelTypeLabel() {
      const v = this.inviteForm.channelType
      if (v === null || v === undefined || v === "") return ""
      const o = this.channelOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    inviteChannelStaffLabel() {
      const v = this.inviteForm.channelStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    expansionChannelTypeLabel() {
      const v = this.expansionDialog.form.channelType
      if (v === null || v === undefined || v === "") return ""
      const o = this.channelOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    expansionChannelStaffLabel() {
      const v = this.expansionDialog.form.channelStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    checkInTrialCourseLabel() {
      const v = this.checkInForm.trialCourseId
      if (v === null || v === undefined || v === "") return ""
      const options = this.checkInPopup.parentCustomerId ? this.expansionCourseOptions : this.courseOptions
      const o = options.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    assignLeadTeacherLabel() {
      const v = this.assignDialog.leadTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    assignAssistantTeacherLabels() {
      const ids = Array.isArray(this.assignDialog.assistantTeacherIds) ? this.assignDialog.assistantTeacherIds : []
      if (!ids.length) return ""
      const labels = this.staffOptions
        .filter(x => ids.some(id => String(id) === String(x.value)))
        .map(x => x.text)
      return labels.join("、")
    },
    filteredHostStaffOptions() {
      const kw = (this.staffSearch.host || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredTrialStaffOptions() {
      const kw = (this.staffSearch.trial || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredLeadStaffOptions() {
      const kw = (this.staffSearch.lead || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredAssistantStaffOptions() {
      const kw = (this.staffSearch.assistant || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredBookingChannelStaffOptions() {
      const kw = (this.staffSearch.bookingChannel || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredExpansionChannelStaffOptions() {
      const kw = (this.staffSearch.expansionChannel || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredActivateChannelStaffOptions() {
      const kw = (this.staffSearch.activateChannel || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredCheckInResultHostOptions() {
      const kw = (this.staffSearch.checkInResultHost || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredCompleteHostOptions() {
      const kw = (this.staffSearch.completeHost || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    updateStatusNum() {
      const s = Number(this.updateDialog.form.status)
      return Number.isFinite(s) ? s : -1
    },
    updateCanBooking() {
      return this.updateStatusNum >= 1
    },
    updateCanArrive() {
      return this.updateStatusNum >= 2
    },
    updateCanDeposit() {
      return this.updateStatusNum >= 3
    },
    updateCanEditDepositFields() {
      return this.updateCanDeposit && Number(this.updateDialog.form.checkInResult) === 5
    },
    updateCanComplete() {
      return this.updateStatusNum >= 4
    },
    checkInResultDepositReadonly() {
      return this.isDepositIncomeConfirmed(this.checkInResultDialog)
    },
    updateDepositAmountReadonly() {
      return this.isDepositIncomeConfirmed(this.updateDialog)
    },
    updateOrderAmountReadonly() {
      return this.isOrderIncomeConfirmed(this.updateDialog)
    },
    completeOrderAmountReadonly() {
      return this.isOrderIncomeConfirmed(this.completeDialog)
    },
    updateHostStaffLabel() {
      const v = this.updateDialog.form.hostStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateTrialTeacherLabel() {
      const v = this.updateDialog.form.trialTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateLeadTeacherLabel() {
      const v = this.updateDialog.form.leadTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateAssistantTeacherLabels() {
      const ids = Array.isArray(this.updateDialog.form.assistantTeacherIds) ? this.updateDialog.form.assistantTeacherIds : []
      if (!ids.length) return ""
      const labels = this.staffOptions
        .filter(x => ids.some(id => String(id) === String(x.value)))
        .map(x => x.text)
      return labels.join("、")
    },
    updateCourseLabel() {
      const v = this.updateDialog.form.courseId
      if (v === null || v === undefined || v === "") return ""
      const o = this.courseOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    filteredCourseOptions() {
      return this.filterCourseOptionsByKeyword(this.courseOptions)
    },
    filteredInviteCourseOptions() {
      const options = this.invitePopup.parentCustomerId ? this.expansionCourseOptions : this.courseOptions
      return this.filterCourseOptionsByKeyword(options)
    },
    filteredCheckInCourseOptions() {
      const options = this.checkInPopup.parentCustomerId ? this.expansionCourseOptions : this.courseOptions
      return this.filterCourseOptionsByKeyword(options)
    },
    filteredCompleteCourseOptions() {
      const options = this.completeDialog.parentCustomerId ? this.expansionCourseOptions : this.courseOptions
      return this.filterCourseOptionsByKeyword(options)
    },
    filteredUpdateStaffOptions() {
      const kw = (this.updateStaffSearch.single || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredUpdateAssistantStaffOptions() {
      const kw = (this.updateStaffSearch.assistant || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    detailAvatarText() {
      const s = (this.detailItem.stuName || "").trim()
      return s ? s.slice(0, 1) : "客"
    },
    detailAssistantTeacherNames() {
      const arr = this.detailItem.assistantTeacherNames
      if (Array.isArray(arr) && arr.length) return arr.join("、")
      return "-"
    },
    detailStatusNum() {
      const s = Number(this.detailItem.status)
      return Number.isFinite(s) ? s : -1
    },
    showArriveStepFields() {
      return this.detailStatusNum >= 2 && this.detailStatusNum <= 4
    },
    showTrialTeacherField() {
      return this.detailStatusNum === 2
    },
    detailIsDepositResult() {
      const rawCode =
        this.detailItem.checkInResult ??
        this.detailItem.checkinResult ??
        this.detailItem.checkInResultCode ??
        this.detailItem.checkinResultCode
      if (Number(rawCode) === 5) return true
      const rawName = (
        this.detailItem.checkInResultName ||
        this.detailItem.checkinResultName ||
        this.detailItem.checkInResultText ||
        this.detailItem.checkinResultText ||
        ""
      )
        .toString()
        .trim()
      return rawName === "支付定金"
    },
    showDepositStepFields() {
      return this.detailStatusNum >= 3 && this.detailStatusNum <= 4 && this.detailIsDepositResult
    },
    detailPersonalPerformanceLabel() {
      const v = this.detailItem?.isPersonalPerformance
      if (v === true || v === 1 || v === "1" || v === "true") return "是"
      return "否"
    },
    showCompleteStepFields() {
      return this.detailStatusNum === 4
    },
    detailPerformanceAmountDisplay() {
      const v = this.detailItem?.performanceAmount
      if (v === null || v === undefined || v === "") return ""
      const n = Number(v)
      if (!Number.isFinite(n)) return ""
      return this.formatAmountDisplay(n)
    },
    showConfirmClassStepFields() {
      return this.isConfirmClassDone(this.detailItem)
    },
    detailConfirmClassCourseStatusLabel() {
      return this.getCourseStatusLabel(this.detailItem)
    },
    detailClassmateNamesDisplay() {
      return this.formatClassmateNamesDisplay(this.detailItem)
    },
    isDetailMdCourse() {
      return this.isBookRequiredCourseLabel(this.detailItem?.courseName)
    },
    showDetailPurchasedBooks() {
      return this.showCompleteStepFields && this.isDetailMdCourse
    },
    abrsmLeadTeacherLabel() {
      return this.feeStaffDisplayLabel(this.abrsmDialog.form, "leadTeacherId", "leadTeacherName")
    },
    abrsmAssistantTeacherLabel() {
      return this.assistantLabelsByIds(this.abrsmDialog.form.assistantTeacherIds)
    },
    abrsmStaffLabel() {
      return this.feeStaffDisplayLabel(this.abrsmDialog.form, "staffId", "staffName")
    },
    renewCourseLabel() {
      return this.feeCourseDisplayLabel(this.renewDialog.form)
    },
    renewLeadTeacherLabel() {
      return this.feeStaffDisplayLabel(this.renewDialog.form, "leadTeacherId", "leadTeacherName")
    },
    renewAssistantTeacherLabel() {
      return this.assistantLabelsByIds(this.renewDialog.form.assistantTeacherIds)
    },
    renewStaffLabel() {
      return this.feeStaffDisplayLabel(this.renewDialog.form, "staffId", "staffName")
    },
    renew8CourseLabel() {
      return this.feeCourseDisplayLabel(this.renew8Dialog.form)
    },
    renew8LeadTeacherLabel() {
      return this.feeStaffDisplayLabel(this.renew8Dialog.form, "leadTeacherId", "leadTeacherName")
    },
    renew8AssistantTeacherLabel() {
      return this.assistantLabelsByIds(this.renew8Dialog.form.assistantTeacherIds)
    },
    renew8StaffLabel() {
      return this.feeStaffDisplayLabel(this.renew8Dialog.form, "staffId", "staffName")
    },
    otherStaffLabel() {
      return this.feeStaffDisplayLabel(this.otherDialog.form, "staffId", "staffName")
    },
    otherFeeTypePickerLabel() {
      const t = this.otherDialog.form.abrsmType
      if (t === null || t === undefined || t === "") return ""
      return this.otherFeeTypeLabel(t)
    },
    filteredFeeStaffOptions() {
      const kw = (this.staffSearch.fee || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredFeeAssistantStaffOptions() {
      const kw = (this.staffSearch.feeAssistant || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    feeAssistantCurrentIds() {
      const key = this.feeAssistantPopup.dialogKey
      if (key === "abrsm") return this.abrsmDialog.form.assistantTeacherIds || []
      if (key === "renew") return this.renewDialog.form.assistantTeacherIds || []
      if (key === "renew8") return this.renew8Dialog.form.assistantTeacherIds || []
      if (key === "confirmClass") return this.confirmClassDialog.form.assistantTeacherIds || []
      return []
    },
    confirmClassCourseStatusOptions() {
      return CONFIRM_CLASS_COURSE_STATUS_OPTIONS
    },
    confirmClassLeadTeacherLabel() {
      return this.feeStaffDisplayLabel(this.confirmClassDialog.form, "leadTeacherId", "leadTeacherName")
    },
    confirmClassAssistantTeacherLabel() {
      return this.assistantLabelsByIds(this.confirmClassDialog.form.assistantTeacherIds)
    },
    confirmClassCourseStatusLabel() {
      const v = this.confirmClassDialog.form.courseStatus
      if (v === null || v === undefined || v === "") return ""
      const hit = CONFIRM_CLASS_COURSE_STATUS_OPTIONS.find(x => Number(x.value) === Number(v))
      return hit ? hit.text : ""
    },
    confirmClassClassmateLabel() {
      const ids = this.normalizeIdArray(this.confirmClassDialog.form.classmateIds)
      if (!ids.length) return ""
      const map = this.confirmClassDialog.form.classmateNameMap || {}
      return ids
        .map(id => (map[String(id)] || "").trim() || String(id))
        .filter(Boolean)
        .join("、")
    },
    confirmClassClassmateSelectedCount() {
      return this.normalizeIdArray(this.confirmClassDialog.form.classmateIds).length
    },
    notStudyingCourseStatusOptions() {
      return NOT_STUDYING_COURSE_STATUS_OPTIONS
    },
    notStudyingCourseStatusLabel() {
      const v = this.notStudyingDialog.form.courseStatus
      if (v === null || v === undefined || v === "") return ""
      const hit = NOT_STUDYING_COURSE_STATUS_OPTIONS.find(x => Number(x.value) === Number(v))
      return hit ? hit.text : ""
    },
    activateChannelTypeLabel() {
      const v = this.activateDialog.form.channelType
      if (v === null || v === undefined || v === "") return ""
      const o = this.channelOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    activateChannelStaffLabel() {
      const v = this.activateDialog.form.channelStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    detailRecordList() {
      const list = this.detailItem?.recordList
      return Array.isArray(list) ? list : []
    },
    detailExpansionList() {
      const list = this.detailItem?.expansionList
      return Array.isArray(list) ? list : []
    },
  },
  methods: {
    normalizeExpansionList(row) {
      const list = row?.expansionList
      return Array.isArray(list) ? list : []
    },
    expansionDisplayName(row, idx = 0) {
      const name = (row?.expansionName || row?.name || row?.trialCourseName || row?.courseName || "").trim()
      if (name) return name
      return `拓科 ${idx + 1}`
    },
    async refreshAfterFlowSubmit(parentCustomerId) {
      await this.onRefresh()
      if (
        parentCustomerId &&
        this.detailDialog.show &&
        String(this.detailItem?.id) === String(parentCustomerId)
      ) {
        await this.refreshCustomerDetail(parentCustomerId)
      }
    },
    expansionStatusNum(row) {
      const s = Number(row?.status)
      return Number.isFinite(s) ? s : -1
    },
    expansionIsDepositResult(row) {
      const rawCode =
        row?.checkInResult ?? row?.checkinResult ?? row?.checkInResultCode ?? row?.checkinResultCode
      if (Number(rawCode) === 5) return true
      const rawName = (
        row?.checkInResultName ||
        row?.checkinResultName ||
        row?.checkInResultText ||
        row?.checkinResultText ||
        ""
      )
        .toString()
        .trim()
      return rawName === "支付定金"
    },
    showExpansionArriveFields(row) {
      const s = this.expansionStatusNum(row)
      return s >= 2 && s <= 4
    },
    showExpansionDepositFields(row) {
      const s = this.expansionStatusNum(row)
      return s >= 3 && s <= 4 && this.expansionIsDepositResult(row)
    },
    showExpansionCompleteFields(row) {
      return this.expansionStatusNum(row) === 4
    },
    showExpansionConfirmClassFields(row) {
      return this.isConfirmClassDone(row)
    },
    buildExpansionFlowOptions(parent) {
      return {
        parentCustomerId: parent?.id ?? null
      }
    },
    async openExpansionFromDetail() {
      if (!this.detailItem?.id) return Toast.fail("缺少学员信息")
      await Promise.all([this.ensureChannelOptions(), this.ensureStaffOptions()])
      this.expansionDialog.form = {
        channelType: this.detailItem?.channelType ?? null,
        channelStaffId: this.detailItem?.channelStaffId ?? null,
        remark: ""
      }
      this.expansionDialog.show = true
    },
    async openExpansionChannelPicker() {
      await this.ensureChannelOptions()
      if (!this.channelOptions.length) return Toast.fail("暂无渠道选项")
      this.expansionChannelPicker.show = true
    },
    onConfirmExpansionChannel(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.channelOptions)
      if (opt) this.expansionDialog.form.channelType = opt.value
      this.expansionChannelPicker.show = false
    },
    async openExpansionChannelStaffPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.expansionChannel = ""
      this.expansionChannelStaffPicker.show = true
    },
    onConfirmExpansionChannelStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredExpansionChannelStaffOptions)
      if (opt) this.expansionDialog.form.channelStaffId = opt.value
      this.expansionChannelStaffPicker.show = false
    },
    clearExpansionChannelStaff() {
      this.expansionDialog.form.channelStaffId = null
    },
    async submitExpansion() {
      if (this.expansionDialog.submitting) return
      const orderId = this.detailItem?.id
      if (!orderId) return Toast.fail("缺少学员ID")
      const form = this.expansionDialog.form
      const payload = { orderId }
      const channelType = form.channelType
      if (channelType !== null && channelType !== undefined && channelType !== "") {
        payload.channelType = channelType
      }
      const channelStaffId = form.channelStaffId
      if (channelStaffId !== null && channelStaffId !== undefined && channelStaffId !== "") {
        payload.channelStaffId = channelStaffId
      }
      const remark = (form.remark || "").trim()
      if (remark) payload.remark = remark
      this.expansionDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await expansionCustomer(payload)
        Toast.clear()
        Toast.success("拓科成功")
        this.expansionDialog.show = false
        await this.refreshCustomerDetail(orderId)
      } catch (e) {
        Toast.clear()
      } finally {
        this.expansionDialog.submitting = false
      }
    },
    openExpansionInvite(parent, expansion) {
      return this.openInvite(expansion, this.buildExpansionFlowOptions(parent))
    },
    openExpansionCheckIn(parent, expansion) {
      return this.openCheckIn(expansion, this.buildExpansionFlowOptions(parent))
    },
    openExpansionCheckInResult(parent, expansion) {
      return this.openCheckInResult(expansion, this.buildExpansionFlowOptions(parent))
    },
    openExpansionComplete(parent, expansion) {
      return this.openComplete(expansion, this.buildExpansionFlowOptions(parent))
    },
    openExpansionConfirmClass(parent, expansion) {
      return this.openConfirmClass(expansion, this.buildExpansionFlowOptions(parent))
    },
    formatAmountDisplay(v) {
      const n = Number(v)
      if (!Number.isFinite(n) || n <= 0) return "-"
      return `￥${n}`
    },
    formatListHostStaffDisplay(row) {
      const name = (row?.hostStaffName || "").trim()
      const time = (row?.checkInTime || "").trim()
      if (!name && !time) return "-"
      if (time) return `${name || "-"}（${time}）`
      return name
    },
    getPaymentMethodLabel(value, fallbackName) {
      const name = (fallbackName || "").trim()
      if (name) return name
      if (value === null || value === undefined || value === "") return ""
      const hit = PAYMENT_METHOD_OPTIONS.find(x => Number(x.value) === Number(value))
      return hit ? hit.text : String(value)
    },
    formatPaymentMethodDisplay(row) {
      if (!row || typeof row !== "object") return "-"
      const name = (row.paymentMethodName || "").trim()
      return name || "-"
    },
    formatDepositPaymentMethodDisplay(row) {
      if (!row || typeof row !== "object") return "-"
      const name = (row.depositPaymentMethodName || "").trim()
      return name || "-"
    },
    formatPersonalPerformanceLabel(row) {
      const v = row?.isPersonalPerformance
      if (v === true || v === 1 || v === "1" || v === "true") return "是"
      return "否"
    },
    formatHeadcountDisplay(value) {
      return this.getHeadcountLabel(value) || "-"
    },
    normalizeHeadcountValue(value, fallback = 1) {
      const n = Number(value)
      if (n === 0) return 0
      if (n === 0.5) return 0.5
      if (n === 1) return 1
      return fallback
    },
    getHeadcountLabel(value) {
      if (value === null || value === undefined || value === "") return ""
      const n = Number(value)
      const hit = HEADCOUNT_OPTIONS.find(x => Number(x.value) === n)
      return hit ? hit.text : (Number.isFinite(n) ? String(n) : String(value))
    },
    openHeadcountPicker(target) {
      this.headcountPicker.target = target
      this.headcountPicker.show = true
    },
    onConfirmHeadcount(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, HEADCOUNT_OPTIONS)
      const value = opt ? opt.value : null
      const target = this.headcountPicker.target
      if (target === "complete") {
        this.completeDialog.headcount = value
      } else if (target === "update") {
        this.updateDialog.form.headcount = value
      }
      this.headcountPicker.show = false
    },
    async ensureProjectOptions() {
      if (this.projectOptions.length || this.projectLoading) return
      this.projectLoading = true
      try {
        const res = await fetchProjectList({})
        this.projectOptions = normalizeProjectOptions(res)
      } finally {
        this.projectLoading = false
      }
    },
    getProjectLabel(projectId) {
      if (projectId === null || projectId === undefined || projectId === "") return ""
      const hit = this.projectOptions.find(x => String(x.value) === String(projectId))
      return hit ? hit.text : ""
    },
    formatProjectNameDisplay(row) {
      const text = formatProjectNameText(row)
      if (text !== "-") return text
      const label = this.getProjectLabel(row?.projectId)
      return label || "-"
    },
    formatDepositProjectDisplay(row) {
      const text = formatProjectNameText(row, { deposit: true })
      if (text !== "-") return text
      const label = this.getProjectLabel(row?.depositProjectId)
      return label || "-"
    },
    appendProjectIdIfNeeded(payload, projectId) {
      if (projectId === null || projectId === undefined || projectId === "") return
      payload.projectId = projectId
    },
    appendDepositProjectIdIfNeeded(payload, depositProjectId) {
      if (depositProjectId === null || depositProjectId === undefined || depositProjectId === "") return
      payload.depositProjectId = depositProjectId
    },
    async openProjectPicker(target) {
      await this.ensureProjectOptions()
      if (!this.projectOptions.length) return Toast.fail("暂无项目，请先在项目管理中新增")
      this.projectPicker.target = target
      this.projectPicker.show = true
    },
    onConfirmProject(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.projectOptions)
      const value = opt ? opt.value : null
      const target = this.projectPicker.target
      if (target === "checkInResultDeposit") {
        this.checkInResultDialog.depositProjectId = value
      } else if (target === "complete") {
        this.completeDialog.projectId = value
      } else if (target === "abrsm") {
        this.abrsmDialog.form.projectId = value
      } else if (target === "renew") {
        this.renewDialog.form.projectId = value
      } else if (target === "renew8") {
        this.renew8Dialog.form.projectId = value
      } else if (target === "other") {
        this.otherDialog.form.projectId = value
      } else if (target === "updateDeposit") {
        this.updateDialog.form.depositProjectId = value
      } else if (target === "updateComplete") {
        this.updateDialog.form.projectId = value
      }
      this.projectPicker.show = false
    },
    normalizeCoursePackagesList(row) {
      if (!row || typeof row !== "object") return []
      const list = row.coursePackages
      return Array.isArray(list) ? list : []
    },
    hasCoursePackages(row) {
      return this.normalizeCoursePackagesList(row).length > 0
    },
    formatCoursePackageItem(pkg) {
      if (!pkg || typeof pkg !== "object") return "-"
      const name = (pkg.coursePackageName || "").trim() || "-"
      const num = this.formatRemainTotalValue(pkg.remainCourseNum, pkg.courseNum, "课时")
      const amount = this.formatRemainTotalValue(pkg.remainCourseAmount, pkg.courseAmount, "元", true)
      return `${name} · ${num} · ${amount}`
    },
    formatRemainTotalValue(remain, total, unit, isAmount = false) {
      const formatVal = v => {
        if (v === null || v === undefined || v === "") return "-"
        const n = Number(v)
        if (Number.isFinite(n)) {
          return isAmount ? `￥${n}` : String(n)
        }
        return isAmount ? this.formatAmountDisplay(v) : String(v)
      }
      const text = `${formatVal(remain)}/${formatVal(total)}`
      return isAmount ? text : `${text}${unit}`
    },
    resolveCoursePackageId(pkg) {
      if (!pkg || typeof pkg !== "object") return null
      const raw = pkg.id
      if (raw === null || raw === undefined || raw === "") return null
      return String(raw)
    },
    openSetRemainDialog(pkg) {
      const coursePackageId = this.resolveCoursePackageId(pkg)
      if (coursePackageId === null || coursePackageId === undefined || coursePackageId === "") {
        Toast.fail("缺少课包 ID")
        return
      }
      this.setRemainDialog = {
        show: true,
        submitting: false,
        coursePackageId,
        coursePackageName: (pkg.coursePackageName || "").trim() || "-",
        form: {
          remainCourseNum:
            pkg.remainCourseNum === null || pkg.remainCourseNum === undefined || pkg.remainCourseNum === ""
              ? ""
              : String(pkg.remainCourseNum),
          remark: ""
        }
      }
    },
    async beforeCloseSetRemain(action, done) {
      if (action !== "confirm") {
        done()
        return
      }
      if (this.setRemainDialog.submitting) {
        done(false)
        return
      }
      const ok = await this.submitSetRemain()
      done(ok)
    },
    parseRemainCourseNumInput(value) {
      const raw = value === null || value === undefined ? "" : String(value).trim()
      if (!raw) return null
      const n = Number(raw)
      if (!Number.isFinite(n) || n < 0) return null
      return n
    },
    async submitSetRemain() {
      const form = this.setRemainDialog.form || {}
      const remainCourseNum = this.parseRemainCourseNumInput(form.remainCourseNum)
      if (remainCourseNum === null) {
        Toast.fail("请输入正确的剩余课时")
        return false
      }
      const payload = {
        coursePackageId: this.setRemainDialog.coursePackageId,
        remainCourseNum,
        remark: (form.remark || "").trim() || undefined
      }
      this.setRemainDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await setCoursePackageRemain(payload)
        Toast.clear()
        Toast.success("设置成功")
        await this.refreshCustomerDetail(this.detailItem?.id)
        return true
      } catch (e) {
        Toast.clear()
        return false
      } finally {
        this.setRemainDialog.submitting = false
      }
    },
    createEmptyCoursePackageRow() {
      return {
        _key: `pkg-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        id: null,
        coursePackageId: null,
        coursePackageName: "",
        courseNum: "",
        courseAmount: "",
        refundCoursePackageId: null,
        refundCoursePackageLabel: "",
        refundRemainTransferAmount: null,
        refundRemainTransferNum: null
      }
    },
    normalizeCoursePackagesForForm(row) {
      const list = this.normalizeCoursePackagesList(row)
      if (!list.length) return [this.createEmptyCoursePackageRow()]
      return list.map((item, index) => ({
        _key: item.id ? `pkg-${item.id}` : `pkg-new-${index}`,
        id: item.id ?? null,
        coursePackageId: item.coursePackageId ?? null,
        coursePackageName: (item.coursePackageName || "").trim(),
        courseNum: item.courseNum === null || item.courseNum === undefined ? "" : String(item.courseNum),
        courseAmount: item.courseAmount === null || item.courseAmount === undefined ? "" : String(item.courseAmount),
        refundCoursePackageId: item.refundCoursePackageId ?? null,
        refundCoursePackageLabel: this.buildRefundCoursePackageLabel(item),
        refundRemainTransferAmount: null,
        refundRemainTransferNum: null
      }))
    },
    isRefundCoursePackageLinked(row) {
      const id = row?.refundCoursePackageId
      return id !== null && id !== undefined && id !== ""
    },
    formatRefundCourseAmountValue(value) {
      const n = Number(value)
      if (!Number.isFinite(n)) return ""
      const floored = Math.floor(n * 100 + 1e-8) / 100
      if (Number.isInteger(floored)) return String(floored)
      return String(floored).replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0$/, "")
    },
    calcRefundLinkedCourseAmount(courseNum, remainTransferAmount, remainTransferNum) {
      const num = Number(courseNum)
      const remainAmount = Number(remainTransferAmount)
      const remainNum = Number(remainTransferNum)
      if (!Number.isFinite(num) || num <= 0) return ""
      if (!Number.isFinite(remainAmount) || remainAmount < 0) return ""
      if (!Number.isFinite(remainNum) || remainNum <= 0) return ""

      const scale = 1000000
      const numScaled = Math.round(num * scale)
      const remainNumScaled = Math.round(remainNum * scale)
      if (remainNumScaled <= 0) return ""

      if (numScaled === remainNumScaled) {
        return remainTransferAmount === null || remainTransferAmount === undefined
          ? ""
          : String(remainTransferAmount)
      }

      const amountScaled = Math.round(remainAmount * scale)
      const resultScaled = Math.floor((amountScaled * numScaled) / remainNumScaled)
      return this.formatRefundCourseAmountValue(resultScaled / scale)
    },
    applyRefundCourseAmountToRow(row) {
      if (!row || !this.isRefundCoursePackageLinked(row)) return
      row.courseAmount = this.calcRefundLinkedCourseAmount(
        row.courseNum,
        row.refundRemainTransferAmount,
        row.refundRemainTransferNum
      )
    },
    onCoursePackageNumInput(target, index) {
      const form = this.getCoursePackagesFormRef(target)
      if (!form || !Array.isArray(form.coursePackages) || !form.coursePackages[index]) return
      const row = form.coursePackages[index]
      if (!this.isRefundCoursePackageLinked(row)) return
      if (
        row.refundRemainTransferAmount === null ||
        row.refundRemainTransferAmount === undefined ||
        row.refundRemainTransferNum === null ||
        row.refundRemainTransferNum === undefined
      ) {
        return
      }
      this.applyRefundCourseAmountToRow(row)
    },
    buildRefundCoursePackageLabel(item) {
      if (!item) return ""
      const saved = (item.refundCoursePackageLabel || "").trim()
      if (saved) return saved
      const name = (item.refundCoursePackageName || item.refundCoursePackageStudentName || "").trim()
      return name
    },
    getCoursePackagesFormRef(target) {
      if (target === "confirmClass") return this.confirmClassDialog.form
      if (target === "abrsm") return this.abrsmDialog.form
      if (target === "renew") return this.renewDialog.form
      if (target === "renew8") return this.renew8Dialog.form
      return null
    },
    addCoursePackageRow(target) {
      const form = this.getCoursePackagesFormRef(target)
      if (!form) return
      if (!Array.isArray(form.coursePackages)) form.coursePackages = []
      form.coursePackages.push(this.createEmptyCoursePackageRow())
    },
    removeCoursePackageRow(target, index) {
      const form = this.getCoursePackagesFormRef(target)
      if (!form || !Array.isArray(form.coursePackages)) return
      if (form.coursePackages.length <= 1) return Toast.fail("至少保留一条课包配置")
      form.coursePackages.splice(index, 1)
    },
    async loadCoursePackageOptions() {
      try {
        const name = (this.coursePackagePicker.keyword || "").trim()
        const res = await fetchCoursePackageList(name ? { name } : {})
        let list = []
        if (Array.isArray(res)) list = res
        else if (Array.isArray(res?.data)) list = res.data
        else if (Array.isArray(res?.list)) list = res.list
        this.coursePackageOptions = list
          .map(item => {
            const text = (item.name || "").trim()
            const value = item.id
            if (!text || value === null || value === undefined || value === "") return null
            return { text, value }
          })
          .filter(Boolean)
      } catch (e) {
        this.coursePackageOptions = []
      }
    },
    onCoursePackageKeywordInput() {
      if (this.coursePackagePicker.keywordTimer) clearTimeout(this.coursePackagePicker.keywordTimer)
      this.coursePackagePicker.keywordTimer = setTimeout(() => {
        this.loadCoursePackageOptions()
      }, 350)
    },
    async openCoursePackagePicker(target, index) {
      this.coursePackagePicker.target = target
      this.coursePackagePicker.index = index
      this.coursePackagePicker.keyword = ""
      await this.loadCoursePackageOptions()
      this.coursePackagePicker.show = true
    },
    onConfirmCoursePackage(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.coursePackageOptions)
      const form = this.getCoursePackagesFormRef(this.coursePackagePicker.target)
      const index = this.coursePackagePicker.index
      if (opt && form && Array.isArray(form.coursePackages) && form.coursePackages[index]) {
        form.coursePackages[index].coursePackageId = opt.value
        form.coursePackages[index].coursePackageName = opt.text
      }
      this.coursePackagePicker.show = false
    },
    async loadRefundCoursePackageOptions() {
      try {
        const stuName = (this.refundCoursePackagePicker.keyword || "").trim()
        const res = await fetchUntransferredCoursePackageList({
          displayStart: 1,
          displayLength: 50,
          stuName: stuName || undefined,
          topDepartmentId: this.topDepartmentId || undefined
        })
        let students = []
        if (Array.isArray(res)) students = res
        else if (Array.isArray(res?.data)) students = res.data
        else if (Array.isArray(res?.list)) students = res.list
        const options = []
        for (const stu of students) {
          const studentName = (stu.studentName || stu.stuName || "").trim()
          const pkgList = Array.isArray(stu.coursePackageList) ? stu.coursePackageList : []
          for (const pkg of pkgList) {
            const pkgId = pkg.id ?? pkg.orderCoursePackageId
            if (pkgId === null || pkgId === undefined || pkgId === "") continue
            const pkgName = (pkg.coursePackageName || "").trim() || "课包"
            const parts = [studentName || "学员", pkgName]
            if (pkg.remainTransferNum != null) parts.push(`剩余${pkg.remainTransferNum}课时`)
            if (pkg.remainTransferAmount != null) parts.push(`￥${pkg.remainTransferAmount}`)
            options.push({
              text: parts.join(" · "),
              value: pkgId,
              remainTransferAmount: pkg.remainTransferAmount,
              remainTransferNum: pkg.remainTransferNum
            })
          }
        }
        this.refundCoursePackageOptions = options
      } catch (e) {
        this.refundCoursePackageOptions = []
      }
    },
    onRefundCoursePackageKeywordInput() {
      if (this.refundCoursePackagePicker.keywordTimer) clearTimeout(this.refundCoursePackagePicker.keywordTimer)
      this.refundCoursePackagePicker.keywordTimer = setTimeout(() => {
        this.loadRefundCoursePackageOptions()
      }, 350)
    },
    async openRefundCoursePackagePicker(target, index) {
      this.refundCoursePackagePicker.target = target
      this.refundCoursePackagePicker.index = index
      this.refundCoursePackagePicker.keyword = ""
      await this.loadRefundCoursePackageOptions()
      this.refundCoursePackagePicker.show = true
    },
    onConfirmRefundCoursePackage(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.refundCoursePackageOptions)
      const form = this.getCoursePackagesFormRef(this.refundCoursePackagePicker.target)
      const index = this.refundCoursePackagePicker.index
      if (opt && form && Array.isArray(form.coursePackages) && form.coursePackages[index]) {
        const row = form.coursePackages[index]
        row.refundCoursePackageId = opt.value
        row.refundCoursePackageLabel = opt.text
        row.refundRemainTransferAmount = opt.remainTransferAmount ?? null
        row.refundRemainTransferNum = opt.remainTransferNum ?? null
        this.applyRefundCourseAmountToRow(row)
      }
      this.refundCoursePackagePicker.show = false
    },
    clearRefundCoursePackage(target, index) {
      const form = this.getCoursePackagesFormRef(target)
      if (!form || !Array.isArray(form.coursePackages) || !form.coursePackages[index]) return
      form.coursePackages[index].refundCoursePackageId = null
      form.coursePackages[index].refundCoursePackageLabel = ""
      form.coursePackages[index].refundRemainTransferAmount = null
      form.coursePackages[index].refundRemainTransferNum = null
    },
    buildCoursePackagesPayload(list) {
      const rows = Array.isArray(list) ? list : []
      if (!rows.length) {
        Toast.fail("请配置课包")
        return null
      }
      const payload = []
      for (const row of rows) {
        const coursePackageId = row.coursePackageId
        const courseNum = Number(row.courseNum)
        const courseAmount = Number(row.courseAmount)
        if (coursePackageId === null || coursePackageId === undefined || coursePackageId === "") {
          Toast.fail("请选择课包")
          return null
        }
        if (!Number.isFinite(courseNum) || courseNum <= 0) {
          Toast.fail("请输入正确的课程数")
          return null
        }
        if (!Number.isFinite(courseAmount) || courseAmount < 0) {
          Toast.fail("请输入正确的课程金额")
          return null
        }
        const item = { coursePackageId, courseNum, courseAmount }
        if (row.id !== null && row.id !== undefined && row.id !== "") item.id = row.id
        const refundCoursePackageId = row.refundCoursePackageId
        if (refundCoursePackageId !== null && refundCoursePackageId !== undefined && refundCoursePackageId !== "") {
          item.refundCoursePackageId = refundCoursePackageId
        }
        payload.push(item)
      }
      return payload
    },
    appendCoursePackagesPayload(payload, list) {
      const coursePackages = this.buildCoursePackagesPayload(list)
      if (!coursePackages) return false
      payload.coursePackages = coursePackages
      return true
    },
    resolvePaymentMethodValue(value) {
      if (value === null || value === undefined || value === "") return null
      const n = Number(value)
      return Number.isFinite(n) ? n : null
    },
    onOpenPaymentMethodPicker(target) {
      if (target === "checkInResult" && this.checkInResultDepositReadonly) return
      if (target === "updateDeposit" && this.updateDepositAmountReadonly) return
      if (target === "updateComplete" && this.updateOrderAmountReadonly) return
      if (target === "complete" && this.completeOrderAmountReadonly) return
      this.paymentMethodPicker.target = target
      this.paymentMethodPicker.show = true
    },
    onConfirmPaymentMethod(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, PAYMENT_METHOD_OPTIONS)
      const value = opt ? opt.value : null
      const target = this.paymentMethodPicker.target
      if (target === "checkInResult") {
        this.checkInResultDialog.depositPaymentMethod = value
      } else if (target === "updateDeposit") {
        this.updateDialog.form.depositPaymentMethod = value
      } else if (target === "updateComplete") {
        this.updateDialog.form.paymentMethod = value
      } else if (target === "complete") {
        this.completeDialog.paymentMethod = value
      } else if (target === "abrsm") {
        this.abrsmDialog.form.paymentMethod = value
      } else if (target === "renew") {
        this.renewDialog.form.paymentMethod = value
      } else if (target === "renew8") {
        this.renew8Dialog.form.paymentMethod = value
      } else if (target === "other") {
        this.otherDialog.form.paymentMethod = value
      }
      this.paymentMethodPicker.show = false
    },
    appendPaymentMethodPayload(payload, value) {
      const n = this.resolvePaymentMethodValue(value)
      if (n !== null) payload.paymentMethod = n
    },
    appendDepositPaymentMethodPayload(payload, value) {
      const n = this.resolvePaymentMethodValue(value)
      if (n !== null) payload.depositPaymentMethod = n
    },
    ensurePaymentMethodSelected(value) {
      if (this.resolvePaymentMethodValue(value) === null) {
        Toast.fail("请选择支付方式")
        return false
      }
      return true
    },
    formatAmountInputValue(amount) {
      if (amount === null || amount === undefined || amount === "") return ""
      const n = Number(amount)
      if (!Number.isFinite(n) || n === 0) return ""
      return String(amount)
    },
    statusText(statusOrRow) {
      const row =
        statusOrRow && typeof statusOrRow === "object"
          ? statusOrRow
          : { status: statusOrRow }
      const status = Number(row.status)
      if (status === 5) return "已作废"
      if (this.isConfirmClassDone(row)) {
        return this.getCourseStatusLabel(row, "已开课")
      }
      const isExpired =
        row.isCheckinExpired === true ||
        row.isCheckinExpired === 1 ||
        row.isCheckinExpired === "1" ||
        row.isCheckinExpired === "true"
      if (status === 1 && isExpired) return "预约未到店"
      if (status === 3) {
        const checkInResultLabel = (
          row.checkInResultName ||
          row.checkinResultName ||
          row.checkInResultText ||
          row.checkinResultText ||
          row.checkInResult ||
          ""
        )
          .toString()
          .trim()
        return checkInResultLabel || "到店结果"
      }
      const map = {
        0: "待邀约",
        1: "已预约",
        2: "已到店",
        3: "到店结果",
        4: "已成交",
        5: "已作废"
      }
      return map[status] || "-"
    },
    statusClass(statusOrRow) {
      const row =
        statusOrRow && typeof statusOrRow === "object"
          ? statusOrRow
          : { status: statusOrRow }
      const status = Number(row.status)
      if (status === 5) return "status-cancel"
      if (this.isConfirmClassDone(row)) return "status-confirm-class"
      const isExpired =
        row.isCheckinExpired === true ||
        row.isCheckinExpired === 1 ||
        row.isCheckinExpired === "1" ||
        row.isCheckinExpired === "true"
      if (status === 1 && isExpired) return "status-expired"
      if (status === 0) return "status-pending"
      if (status === 1) return "status-booking"
      if (status === 2) return "status-arrive"
      if (status === 3) return "status-check-result"
      if (status === 4) return "status-deal"
      if (status === 5) return "status-cancel"
      return ""
    },
    canSwipeDeleteCancelledStudent(row) {
      if (!this.canDeleteCancelledStudent) return false
      const status = Number(row?.status)
      return status === 5
    },
    resolveDeleteStudentId(row) {
      const id = row?.studentId ?? row?.id
      if (id === null || id === undefined || id === "") return null
      return id
    },
    async onDeleteCancelledStudent(row) {
      if (!this.canSwipeDeleteCancelledStudent(row)) return
      const studentId = this.resolveDeleteStudentId(row)
      if (!studentId) return Toast.fail("缺少学员ID")
      try {
        await Dialog.confirm({ title: "确认删除？", message: "删除后不可恢复" })
      } catch (e) {
        return
      }
      Toast.loading({ message: "删除中...", forbidClick: true, duration: 0 })
      try {
        await deleteCustomer(studentId)
        Toast.clear()
        Toast.success("删除成功")
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      }
    },
    parseKeyword() {
      const kw = (this.keyword || "").trim()
      return { allName: kw }
    },
    currentStatus() {
      if (this.statusTab === "expired") return 1
      if (this.statusTab === "all" || this.statusTab === "confirmClass") return null
      const n = Number(this.statusTab)
      return Number.isFinite(n) ? n : null
    },
    async fetchPage() {
      const { allName } = this.parseKeyword()
      const status = this.currentStatus()
      const { startDate, endDate } = this.dateRange
      const rangeFieldMap = {
        create: ["createStartDate", "createEndDate"],
        booking: ["bookingStartDate", "bookingEndDate"],
        checkIn: ["checkInStartDate", "checkInEndDate"],
        paid: ["paidStartDate", "paidEndDate"],
        complete: ["completeStartDate", "completeEndDate"]
      }
      const [startField, endField] = rangeFieldMap[this.timeFilterType] || rangeFieldMap.checkIn

      const payload = {
        displayStart: this.page,
        displayLength: this.pageSize,
        allName,
        isCheckinExpired: this.statusTab === "expired" ? true : undefined,
        topDepartmentId: this.topDepartmentId || undefined,
        [startField]: startDate || undefined,
        [endField]: endDate || undefined
      }
      if (this.timeFilterType === "paid") {
        payload.isDepositPaid = true
      }
      if (this.statusTab === "all") {
        payload.statusList = CUSTOMER_STATUS_LIST_EXCLUDE_CANCELLED
      } else if (this.statusTab === "confirmClass") {
        payload.isConfirmClass = true
      } else if (this.statusTab !== "5") {
        payload.status = status
        payload.isConfirmClass = false
      } else {
        payload.status = status
      }
      if (
        status === 3 &&
        this.listCheckInResultFilter !== null &&
        this.listCheckInResultFilter !== undefined &&
        this.listCheckInResultFilter !== ""
      ) {
        payload.checkInResult = this.listCheckInResultFilter
      }
      if (
        this.statusTab === "confirmClass" &&
        this.listCourseStatusFilter !== null &&
        this.listCourseStatusFilter !== undefined &&
        this.listCourseStatusFilter !== ""
      ) {
        payload.courseStatus = this.listCourseStatusFilter
      }
      const res = await fetchCustomerList(payload)
      const list = Array.isArray(res?.data) ? res.data : []
      const totalRecords = res?.page?.totalRecords
      this.listTotalRecords = Number.isFinite(Number(totalRecords)) ? Number(totalRecords) : 0
      return list
    },
    async onLoad() {
      this.loadError = false
      try {
        const list = await this.fetchPage()
        if (this.refreshing) {
          this.items = []
          this.refreshing = false
        }
        this.items = this.items.concat(list)

        const noMore = list.length < this.pageSize
        this.finished = noMore
        this.page += 1
      } catch (e) {
        this.loadError = true
      } finally {
        this.loading = false
        if (this.scrollToTopAfterLoad) {
          this.scrollToTopAfterLoad = false
          this.$nextTick(() => resetPageScrollAfterPaint(this.$el))
        }
      }
    },
    onRefresh(scrollToTop = false) {
      if (scrollToTop) {
        this.scrollToTopAfterLoad = true
        resetPageScrollAfterPaint(this.$el)
      }
      this.finished = false
      this.loading = true
      this.refreshing = true
      this.page = 1
      return this.onLoad()
    },
    onSearch() {
      this.onRefresh()
    },
    onKeywordInput() {
      if (this.keywordTimer) {
        clearTimeout(this.keywordTimer)
      }
      this.keywordTimer = setTimeout(() => {
        this.onRefresh()
      }, 350)
    },
    onStatusChange() {
      if (this.skipStatusChangeRefreshOnce) return
      this.onRefresh(true)
    },
    async openListCheckInResultFilterPicker() {
      await this.ensureCheckInResultOptions()
      if (!this.checkInResultOptions.length) return Toast.fail("暂无到店结果选项")
      this.listCheckInResultFilterPicker.show = true
    },
    onConfirmListCheckInResultFilter(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.listCheckInResultFilterColumns)
      if (opt && opt.value === LIST_CHECKIN_RESULT_FILTER_ALL) {
        this.listCheckInResultFilter = null
      } else if (opt) {
        this.listCheckInResultFilter = opt.value
      } else {
        this.listCheckInResultFilter = null
      }
      this.listCheckInResultFilterPicker.show = false
      this.skipStatusChangeRefreshOnce = true
      this.statusTab = "3"
      this.$nextTick(() => {
        this.skipStatusChangeRefreshOnce = false
        this.onRefresh(true)
      })
    },
    clearListCheckInResultFilter() {
      this.listCheckInResultFilter = null
      if (this.statusTab === "3") {
        this.onRefresh()
      }
    },
    openListCourseStatusFilterPicker() {
      this.listCourseStatusFilterPicker.show = true
    },
    onConfirmListCourseStatusFilter(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.listCourseStatusFilterColumns)
      if (opt && opt.value === LIST_COURSE_STATUS_FILTER_ALL) {
        this.listCourseStatusFilter = null
      } else if (opt) {
        this.listCourseStatusFilter = opt.value
      } else {
        this.listCourseStatusFilter = null
      }
      this.listCourseStatusFilterPicker.show = false
      this.skipStatusChangeRefreshOnce = true
      this.statusTab = "confirmClass"
      this.$nextTick(() => {
        this.skipStatusChangeRefreshOnce = false
        this.onRefresh(true)
      })
    },
    clearListCourseStatusFilter() {
      this.listCourseStatusFilter = null
      if (this.statusTab === "confirmClass") {
        this.onRefresh()
      }
    },
    openDateRangePicker() {
      this.dateRangePickerShow = true
    },
    openTimeFilterPicker() {
      this.timeFilterPicker.show = true
    },
    onConfirmTimeFilter(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, TIME_FILTER_OPTIONS)
      if (opt) this.timeFilterType = opt.value
      this.timeFilterPicker.show = false
      this.onRefresh()
    },
    clearDateRange() {
      this.dateRange = getEmptyRange()
      this.onRefresh()
    },
    async openTopDepartmentPicker() {
      await this.ensureTopDepartmentOptions()
      if (!this.topDepartmentOptions.length) return Toast.fail("暂无中心选项")
      this.topDepartmentPicker.show = true
    },
    onConfirmTopDepartment(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.topDepartmentOptions)
      this.topDepartmentId = opt ? opt.value : null
      this.topDepartmentPicker.show = false
      this.onRefresh()
    },
    clearTopDepartment() {
      this.topDepartmentId = null
      this.onRefresh()
    },
    onConfirmDateRange(dates) {
      // 先关闭弹框，避免因回参格式差异导致弹框不收起
      this.dateRangePickerShow = false

      let start = null
      let end = null

      if (Array.isArray(dates) && dates.length >= 2) {
        start = dates[0]
        end = dates[1]
      } else if (dates && dates.startDate && dates.endDate) {
        start = dates.startDate
        end = dates.endDate
      }

      if (!start || !end) return

      const startDate = start instanceof Date ? start : new Date(start)
      const endDate = end instanceof Date ? end : new Date(end)
      this.dateRange.startDate = formatDate(startDate)
      this.dateRange.endDate = formatDate(endDate)
      this.onRefresh()
    },
    isFlowStepActive(it, step) {
      const s = Number(it?.status)
      if (!Number.isFinite(s)) return false
      if (step === "booking") return s >= 1
      if (step === "arrive") return s >= 2
      if (step === "deposit") return s >= 3
      if (step === "complete") return s >= 4
      if (step === "confirmClass") return this.isConfirmClassDone(it)
      return false
    },
    isConfirmClassDone(it) {
      const v = it?.isConfirmClass
      return v === true || v === 1 || v === "1" || v === "true"
    },
    getCourseStatusLabel(row, fallback = "-") {
      const name = (row?.courseStatusName || "").trim()
      if (name) return name
      const v = row?.courseStatus
      if (v === null || v === undefined || v === "") return fallback
      const hit = CONFIRM_CLASS_COURSE_STATUS_OPTIONS.find(x => Number(x.value) === Number(v))
      return hit ? hit.text : fallback
    },
    isIncomeConfirmTrue(v) {
      return v === true || v === 1 || v === "1" || v === "true"
    },
    isDepositIncomeConfirmed(row) {
      return this.isIncomeConfirmTrue(row?.isDepositIncomeConfirm)
    },
    isOrderIncomeConfirmed(row) {
      return this.isIncomeConfirmTrue(row?.isOrderIncomeConfirm)
    },
    openDetail(it) {
      this.detailItem = { ...it }
      this.detailDialog.show = true
      this.fetchDetailRenewList(it?.id)
    },
    async refreshCustomerDetail(recordId) {
      if (recordId === null || recordId === undefined || recordId === "") return
      await this.onRefresh()
      if (!this.detailDialog.show || String(this.detailItem?.id) !== String(recordId)) return
      const hit = this.items.find(x => String(x.id) === String(recordId))
      if (!hit) return
      this.detailItem = { ...hit }
      await this.fetchDetailRenewList(hit.id)
    },
    async fetchDetailRenewList(parentId) {
      if (parentId === null || parentId === undefined || parentId === "") {
        this.detailRenewList = []
        return
      }
      this.detailRenewLoading = true
      try {
        const res = await fetchCustomerList({
          displayStart: 1,
          displayLength: DETAIL_RENEW_FETCH_SIZE,
          parentId
        })
        const list = Array.isArray(res?.data) ? res.data : []
        this.detailRenewList = list
          .filter(x => this.isRenewFeeRecord(x) && this.isRenewRecordActive(x))
          .sort((a, b) => this.renewRecordSortTime(b) - this.renewRecordSortTime(a))
      } catch (e) {
        this.detailRenewList = []
      } finally {
        this.detailRenewLoading = false
      }
    },
    renewRecordSortTime(row) {
      const raw = row?.completeTime || row?.paidTime || row?.createTime || ""
      if (!raw) return 0
      const t = new Date(String(raw).replace(/-/g, "/")).getTime()
      return Number.isFinite(t) ? t : 0
    },
    getRenewRecordType(row) {
      const t = Number(row?.type)
      return Number.isFinite(t) ? t : null
    },
    isRenewRecordCancelled(row) {
      return Number(row?.status) === 5
    },
    isRenewRecordActive(row) {
      return !this.isRenewRecordCancelled(row)
    },
    isRenewFeeRecord(row) {
      const t = this.getRenewRecordType(row)
      return (
        t === RENEW_RECORD_TYPE.REN ||
        t === RENEW_RECORD_TYPE.UP ||
        t === RENEW_RECORD_TYPE.ABRSM ||
        t === RENEW_RECORD_TYPE.OTHER
      )
    },
    renewRecordTypeLabel(row) {
      const t = this.getRenewRecordType(row)
      if (t && RENEW_RECORD_TYPE_LABEL[t]) return RENEW_RECORD_TYPE_LABEL[t]
      return "录收入"
    },
    renewRecordStaffName(row) {
      return (row?.hostStaffName || "").trim()
    },
    renewAssistantTeacherNames(row) {
      const names = row?.assistantTeacherNames
      if (Array.isArray(names) && names.length) return names.join("、")
      if (typeof names === "string" && names.trim()) return names.trim()
      const byIds = this.assistantLabelsByIds(row?.assistantTeacherIds)
      return byIds || "-"
    },
    showRenewCourseField(row) {
      const t = this.getRenewRecordType(row)
      return t === RENEW_RECORD_TYPE.REN || t === RENEW_RECORD_TYPE.UP
    },
    showRenewPurchasedBooks(row) {
      return this.showRenewCourseField(row) && this.isBookRequiredCourseLabel(row?.courseName)
    },
    showRenewCoursePackagesField(row) {
      const t = this.getRenewRecordType(row)
      return t === RENEW_RECORD_TYPE.REN || t === RENEW_RECORD_TYPE.UP || t === RENEW_RECORD_TYPE.ABRSM
    },
    showRenewTeacherField(row) {
      const t = this.getRenewRecordType(row)
      return t === RENEW_RECORD_TYPE.REN || t === RENEW_RECORD_TYPE.UP || t === RENEW_RECORD_TYPE.ABRSM
    },
    showRenewStaffField(row) {
      const t = this.getRenewRecordType(row)
      return t === RENEW_RECORD_TYPE.REN || t === RENEW_RECORD_TYPE.UP || t === RENEW_RECORD_TYPE.ABRSM || t === RENEW_RECORD_TYPE.OTHER
    },
    showRenewPerformanceAmountField(row) {
      const t = this.getRenewRecordType(row)
      if (t !== RENEW_RECORD_TYPE.REN && t !== RENEW_RECORD_TYPE.UP && t !== RENEW_RECORD_TYPE.OTHER) return false
      const v = row?.performanceAmount
      if (v === null || v === undefined || v === "") return false
      return Number.isFinite(Number(v))
    },
    showRenewOtherTypeField(row) {
      return this.getRenewRecordType(row) === RENEW_RECORD_TYPE.OTHER
    },
    otherFeeTypeLabel(value) {
      const n = Number(value)
      const hit = OTHER_FEE_TYPE_OPTIONS.find(x => Number(x.value) === n)
      return hit ? hit.text : "-"
    },
    parseOtherFeeType(form) {
      const n = Number(form?.abrsmType)
      if (!Number.isFinite(n) || n < 1 || n > 9) {
        Toast.fail("请选择杂费类型")
        return null
      }
      return n
    },
    closeFeeBizDialog(key) {
      if (key === "abrsm") {
        this.abrsmDialog.show = false
        this.abrsmDialog.editMode = false
      } else if (key === "renew") {
        this.renewDialog.show = false
        this.renewDialog.editMode = false
      } else if (key === "renew8") {
        this.renew8Dialog.show = false
        this.renew8Dialog.editMode = false
      } else if (key === "other") {
        this.otherDialog.show = false
        this.otherDialog.editMode = false
      }
    },
    buildRenewRecordEditForm(row) {
      const amount = row?.amount
      const staffNameText = (row?.hostStaffName || "").trim()
      const leadTeacherName = (row?.leadTeacherName || "").trim()
      const courseName = (row?.courseName || "").trim()
      return {
        id: row?.id ?? null,
        amount: amount === null || amount === undefined ? "" : String(amount),
        coursePackages: this.normalizeCoursePackagesForForm(row),
        completeTime: (row?.completeTime || row?.paidTime || "").trim(),
        paymentMethod: row?.paymentMethod ?? null,
        courseId: this.resolveRecordCourseId(row),
        courseName,
        leadTeacherId: this.resolveRecordLeadTeacherId(row),
        leadTeacherName,
        assistantTeacherIds: this.normalizeIdArray(row?.assistantTeacherIds),
        staffId: this.resolveRecordStaffId(row),
        staffName: staffNameText,
        remark: (row?.remark || "").trim(),
        performanceAmount:
          row?.performanceAmount === null || row?.performanceAmount === undefined
            ? ""
            : String(row.performanceAmount),
        abrsmType: row?.abrsmType ?? null,
        bookIds: this.normalizeRecordBookIdsForForm(row),
        bookItems: this.parseRecordBookIds(row),
        projectId: row?.projectId ?? null
      }
    },
    renewEditMdCourseLabel(form) {
      const name = (form?.courseName || "").trim()
      if (name) return name
      return this.courseLabelById(form?.courseId)
    },
    async openRenewRecordEdit(row) {
      const type = this.getRenewRecordType(row)
      if (!this.isRenewFeeRecord(row)) return Toast.fail("无法修改该记录")
      if (this.isRenewRecordCancelled(row)) return Toast.fail("该记录已作废")
      if (this.isOrderIncomeConfirmed(row)) return Toast.fail("订单流水已确认，无法修改")
      if (!row?.id) return Toast.fail("缺少记录ID")
      await Promise.all([this.ensureStaffOptions(), this.ensureProjectOptions()])
      const form = this.buildRenewRecordEditForm(row)
      if (!form.courseName && form.courseId) {
        form.courseName = this.courseLabelById(form.courseId) || form.courseName
      }
      if (type === RENEW_RECORD_TYPE.REN) {
        await this.ensureCourseOptions()
        if (!form.courseName && form.courseId) {
          form.courseName = this.courseLabelById(form.courseId) || form.courseName
        }
        if (!this.courseOptions.length) return Toast.fail("暂无课程选项")
        this.renewDialog.editMode = true
        this.renewDialog.submitting = false
        this.renewDialog.form = { ...form }
        if (this.isBookRequiredCourseLabel(this.renewEditMdCourseLabel(form))) {
          this.completeBookPicker.source = "renew"
          await this.loadMdBooks("renew")
        }
        this.renewDialog.show = true
      } else if (type === RENEW_RECORD_TYPE.UP) {
        await this.ensureCourseOptions()
        if (!form.courseName && form.courseId) {
          form.courseName = this.courseLabelById(form.courseId) || form.courseName
        }
        if (!this.courseOptions.length) return Toast.fail("暂无课程选项")
        this.renew8Dialog.editMode = true
        this.renew8Dialog.submitting = false
        this.renew8Dialog.form = { ...form }
        if (this.isBookRequiredCourseLabel(this.renewEditMdCourseLabel(form))) {
          this.completeBookPicker.source = "renew8"
          await this.loadMdBooks("renew8")
        }
        this.renew8Dialog.show = true
      } else if (type === RENEW_RECORD_TYPE.ABRSM) {
        this.abrsmDialog.editMode = true
        this.abrsmDialog.submitting = false
        this.abrsmDialog.form = { ...form }
        this.abrsmDialog.show = true
      } else if (type === RENEW_RECORD_TYPE.OTHER) {
        this.otherDialog.editMode = true
        this.otherDialog.submitting = false
        this.otherDialog.form = {
          id: form.id,
          abrsmType: form.abrsmType ?? null,
          amount: form.amount,
          completeTime: form.completeTime,
          paymentMethod: form.paymentMethod ?? null,
          staffId: form.staffId ?? null,
          staffName: form.staffName || "",
          performanceAmount: form.performanceAmount || "",
          remark: form.remark,
          projectId: form.projectId ?? null
        }
        this.otherDialog.show = true
      }
    },
    async doCancelRenewRecord(row) {
      const label = this.renewRecordTypeLabel(row)
      if (!row?.id) return Toast.fail("缺少记录ID")
      if (this.isOrderIncomeConfirmed(row)) return Toast.fail("订单流水已确认，无法作废")
      try {
        await Dialog.confirm({
          title: "确认作废？",
          message: `确定作废该${label}记录吗？`
        })
      } catch (e) {
        return
      }
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await cancelBooking(row.id)
        Toast.clear()
        Toast.success("已作废")
        await this.fetchDetailRenewList(this.detailItem.id)
      } catch (e) {
        Toast.clear()
      }
    },
    buildRenewUpdatePayload(form, recordType) {
      const id = form.id
      const amount = Number(form.amount)
      const completeTime = (form.completeTime || "").trim()
      if (!id) {
        Toast.fail("缺少记录ID")
        return null
      }
      if (!Number.isFinite(amount) || amount <= 0) {
        Toast.fail("请输入正确的金额")
        return null
      }
      if (!completeTime) {
        Toast.fail("请选择支付时间")
        return null
      }
      const payload = {
        id,
        amount,
        completeTime,
        remark: (form.remark || "").trim() || undefined
      }
      if (!this.ensurePaymentMethodSelected(form.paymentMethod)) return null
      this.appendPaymentMethodPayload(payload, form.paymentMethod)
      if (recordType === RENEW_RECORD_TYPE.OTHER) {
        const abrsmType = this.parseOtherFeeType(form)
        if (abrsmType === null) return null
        payload.abrsmType = abrsmType
        const staffId = form.staffId
        if (staffId !== null && staffId !== undefined && staffId !== "") {
          payload.staffId = staffId
        }
        this.appendPerformanceAmountIfNeeded(payload, form)
        this.appendProjectIdIfNeeded(payload, form.projectId)
        return payload
      }
      if (!this.appendCoursePackagesPayload(payload, form.coursePackages)) return null
      if (recordType === RENEW_RECORD_TYPE.REN || recordType === RENEW_RECORD_TYPE.UP) {
        const courseId = form.courseId
        const leadTeacherId = form.leadTeacherId
        const assistantTeacherIds = this.normalizeIdArray(form.assistantTeacherIds)
        const staffId = form.staffId
        if (courseId === null || courseId === undefined || courseId === "") {
          Toast.fail("请选择课程")
          return null
        }
        if (leadTeacherId === null || leadTeacherId === undefined || leadTeacherId === "") {
          Toast.fail("请选择主课老师")
          return null
        }
        payload.courseId = courseId
        payload.leadTeacherId = leadTeacherId
        payload.assistantTeacherIds = assistantTeacherIds
        if (staffId !== null && staffId !== undefined && staffId !== "") {
          payload.staffId = staffId
        }
        this.appendPerformanceAmountIfNeeded(payload, form)
        const courseLabel = this.feeCourseDisplayLabel(form)
        if (!this.appendMdBookIdsIfNeeded(payload, form, courseLabel)) return null
        this.appendProjectIdIfNeeded(payload, form.projectId)
        return payload
      }
      if (recordType === RENEW_RECORD_TYPE.ABRSM) {
        const leadTeacherId = form.leadTeacherId
        const assistantTeacherIds = this.normalizeIdArray(form.assistantTeacherIds)
        const staffId = form.staffId
        if (leadTeacherId === null || leadTeacherId === undefined || leadTeacherId === "") {
          Toast.fail("请选择主课老师")
          return null
        }
        payload.leadTeacherId = leadTeacherId
        payload.assistantTeacherIds = assistantTeacherIds
        if (staffId !== null && staffId !== undefined && staffId !== "") {
          payload.staffId = staffId
        }
        this.appendProjectIdIfNeeded(payload, form.projectId)
        return payload
      }
      return null
    },
    async submitFeeRecordUpdate(recordType, dialogState, dialogKey) {
      const form = dialogState.form
      const payload = this.buildRenewUpdatePayload(form, recordType)
      if (!payload) return
      dialogState.submitting = true
      Toast.loading({ message: "保存中...", forbidClick: true, duration: 0 })
      try {
        await updateRenew(payload)
        Toast.clear()
        Toast.success("修改成功")
        this.closeFeeBizDialog(dialogKey)
        await this.fetchDetailRenewList(this.detailItem.id)
      } catch (e) {
        Toast.clear()
      } finally {
        dialogState.submitting = false
      }
    },
    formatCourseNumDisplay(v) {
      if (v === null || v === undefined || v === "") return "-"
      const n = Number(v)
      return Number.isFinite(n) ? String(n) : String(v)
    },
    onDetailBizSelect(action) {
      if (!action || !action.key) return
      const key = action.key
      this.detailBizSheetShow = false
      this.$nextTick(() => {
        if (key === "abrsm") this.openAbrsmFromDetail()
        else if (key === "renew") this.openRenewFromDetail()
        else if (key === "renew8") this.openRenew8FromDetail()
        else if (key === "other") this.openOtherFromDetail()
      })
    },
    staffLabelById(id) {
      if (id === null || id === undefined || id === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(id))
      return o ? o.text : ""
    },
    feeStaffDisplayLabel(form, idField, nameField) {
      const label = this.staffLabelById(form?.[idField])
      if (label) return label
      return (form?.[nameField] || "").trim()
    },
    feeCourseDisplayLabel(form) {
      const label = this.courseLabelById(form?.courseId)
      if (label) return label
      return (form?.courseName || "").trim()
    },
    resolveStaffIdByName(name) {
      const n = (name || "").trim()
      if (!n || !this.staffOptions.length) return null
      const hit = this.staffOptions.find(x => String(x.text || "").trim() === n)
      return hit ? hit.value : null
    },
    resolveRecordStaffId(row) {
      const staffId = row?.hostStaffId
      if (staffId !== null && staffId !== undefined && staffId !== "") return staffId
      const staffName = (row?.hostStaffName || "").trim()
      if (staffName) return this.resolveStaffIdByName(staffName)
      return null
    },
    resolveRecordLeadTeacherId(row) {
      const leadTeacherId = row?.leadTeacherId
      if (leadTeacherId !== null && leadTeacherId !== undefined && leadTeacherId !== "") {
        return leadTeacherId
      }
      return this.resolveStaffIdByName(row?.leadTeacherName)
    },
    resolveRecordCourseId(row) {
      const id = row?.courseId
      if (id !== null && id !== undefined && id !== "") return id
      const name = (row?.courseName || "").trim()
      if (!name || !this.courseOptions.length) return null
      const hit = this.courseOptions.find(x => String(x.text || "").trim() === name)
      return hit ? hit.value : null
    },
    courseLabelById(id) {
      if (id === null || id === undefined || id === "") return ""
      const o = this.courseOptions.find(x => String(x.value) === String(id))
      return o ? o.text : ""
    },
    assistantLabelsByIds(ids) {
      const list = Array.isArray(ids) ? ids : []
      if (!list.length) return ""
      return this.staffOptions
        .filter(x => list.some(id => String(id) === String(x.value)))
        .map(x => x.text)
        .join("、")
    },
    resolveDefaultStaffId() {
      const uid = getLoginUserId()
      if (!uid) return null
      const found = this.staffOptions.find(x => String(x.value) === String(uid))
      if (found) return found.value
      const n = Number(uid)
      return Number.isFinite(n) ? n : uid
    },
    getFeeDefaultsFromDetail() {
      const it = this.detailItem || {}
      return {
        courseId: it.courseId ?? null,
        leadTeacherId: it.leadTeacherId ?? null,
        assistantTeacherIds: this.normalizeIdArray(it.assistantTeacherIds),
        staffId: null
      }
    },
    async openAbrsmFromDetail() {
      const id = this.detailItem.id
      if (!id) return Toast.fail("缺少学员ID")
      await this.ensureStaffOptions()
      const now = new Date()
      const feeDefaults = this.getFeeDefaultsFromDetail()
      this.abrsmDialog.editMode = false
      this.abrsmDialog.show = true
      this.abrsmDialog.submitting = false
      this.abrsmDialog.form = {
        id,
        amount: "",
        completeTime: formatDateTime(now),
        leadTeacherId: null,
        assistantTeacherIds: [...feeDefaults.assistantTeacherIds],
        paymentMethod: null,
        coursePackages: [this.createEmptyCoursePackageRow()],
        remark: "",
        staffId: null,
        projectId: null
      }
      this.feeTimePicker.value = now
    },
    async openRenewFromDetail() {
      const id = this.detailItem.id
      if (!id) return Toast.fail("缺少学员ID")
      await this.ensureStaffOptions()
      await this.ensureCourseOptions()
      if (!this.courseOptions.length) return Toast.fail("暂无课程选项")
      const now = new Date()
      const feeDefaults = this.getFeeDefaultsFromDetail()
      const courseName =
        this.courseLabelById(feeDefaults.courseId) ||
        (this.detailItem.courseName || "").trim()
      this.renewDialog.editMode = false
      this.renewDialog.show = true
      this.renewDialog.submitting = false
      this.renewDialog.form = {
        id,
        amount: "",
        completeTime: formatDateTime(now),
        courseId: feeDefaults.courseId,
        courseName,
        leadTeacherId: feeDefaults.leadTeacherId,
        assistantTeacherIds: [...feeDefaults.assistantTeacherIds],
        paymentMethod: null,
        coursePackages: [this.createEmptyCoursePackageRow()],
        remark: "",
        staffId: null,
        performanceAmount: "",
        bookIds: [],
        projectId: null
      }
      if (this.isBookRequiredCourseLabel(courseName) && feeDefaults.courseId) {
        this.completeBookPicker.source = "renew"
        await this.loadMdBooks("renew")
      }
      this.feeTimePicker.value = now
    },
    async openRenew8FromDetail() {
      const id = this.detailItem.id
      if (!id) return Toast.fail("缺少学员ID")
      await this.ensureStaffOptions()
      await this.ensureCourseOptions()
      if (!this.courseOptions.length) return Toast.fail("暂无课程选项")
      const now = new Date()
      const feeDefaults = this.getFeeDefaultsFromDetail()
      const courseName =
        this.courseLabelById(feeDefaults.courseId) ||
        (this.detailItem.courseName || "").trim()
      this.renew8Dialog.editMode = false
      this.renew8Dialog.show = true
      this.renew8Dialog.submitting = false
      this.renew8Dialog.form = {
        id,
        amount: "",
        completeTime: formatDateTime(now),
        courseId: feeDefaults.courseId,
        courseName,
        leadTeacherId: feeDefaults.leadTeacherId,
        assistantTeacherIds: [...feeDefaults.assistantTeacherIds],
        paymentMethod: null,
        coursePackages: [this.createEmptyCoursePackageRow()],
        remark: "",
        staffId: null,
        performanceAmount: "",
        bookIds: [],
        projectId: null
      }
      if (this.isBookRequiredCourseLabel(courseName) && feeDefaults.courseId) {
        this.completeBookPicker.source = "renew8"
        await this.loadMdBooks("renew8")
      }
      this.feeTimePicker.value = now
    },
    openOtherFromDetail() {
      const id = this.detailItem.id
      if (!id) return Toast.fail("缺少学员ID")
      const now = new Date()
      this.otherDialog.editMode = false
      this.otherDialog.show = true
      this.otherDialog.submitting = false
      this.otherDialog.form = {
        id,
        abrsmType: null,
        amount: "",
        completeTime: formatDateTime(now),
        paymentMethod: null,
        staffId: null,
        staffName: "",
        performanceAmount: "",
        remark: "",
        projectId: null
      }
      this.feeTimePicker.value = now
    },
    openOtherTypePicker() {
      this.otherTypePicker.show = true
    },
    onConfirmOtherType(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.otherFeeTypeOptions)
      if (opt) this.otherDialog.form.abrsmType = opt.value
      this.otherTypePicker.show = false
    },
    clearFeeStaffField(dialogKey, field) {
      const nameField = field === "staffId" ? "staffName" : field === "leadTeacherId" ? "leadTeacherName" : ""
      let dialog = null
      if (dialogKey === "abrsm") dialog = this.abrsmDialog
      else if (dialogKey === "renew") dialog = this.renewDialog
      else if (dialogKey === "renew8") dialog = this.renew8Dialog
      else if (dialogKey === "other") dialog = this.otherDialog
      if (!dialog) return
      dialog.form[field] = null
      if (nameField) dialog.form[nameField] = ""
    },
    async openFeeStaffPicker(dialogKey, field, title) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.fee = ""
      this.feeStaffPicker.dialogKey = dialogKey
      this.feeStaffPicker.field = field
      this.feeStaffPicker.title = title
      this.feeStaffPicker.show = true
    },
    onConfirmFeeStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredFeeStaffOptions)
      if (opt) {
        const { dialogKey, field } = this.feeStaffPicker
        const nameField = field === "staffId" ? "staffName" : field === "leadTeacherId" ? "leadTeacherName" : ""
        if (dialogKey === "abrsm") {
          this.abrsmDialog.form[field] = opt.value
          if (nameField) this.abrsmDialog.form[nameField] = opt.text
        } else if (dialogKey === "renew") {
          this.renewDialog.form[field] = opt.value
          if (nameField) this.renewDialog.form[nameField] = opt.text
        } else if (dialogKey === "renew8") {
          this.renew8Dialog.form[field] = opt.value
          if (nameField) this.renew8Dialog.form[nameField] = opt.text
        } else if (dialogKey === "confirmClass") {
          this.confirmClassDialog.form[field] = opt.value
          if (nameField) this.confirmClassDialog.form[nameField] = opt.text
        } else if (dialogKey === "other") {
          this.otherDialog.form[field] = opt.value
          if (nameField) this.otherDialog.form[nameField] = opt.text
        }
      }
      this.feeStaffPicker.show = false
    },
    async openFeeAssistantPopup(dialogKey) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.feeAssistant = ""
      this.feeAssistantPopup.dialogKey = dialogKey
      this.feeAssistantPopup.show = true
    },
    onInputFeeAssistantIds(val) {
      const ids = this.normalizeIdArray(val)
      const key = this.feeAssistantPopup.dialogKey
      if (key === "abrsm") this.abrsmDialog.form.assistantTeacherIds = ids
      else if (key === "renew") this.renewDialog.form.assistantTeacherIds = ids
      else if (key === "renew8") this.renew8Dialog.form.assistantTeacherIds = ids
      else if (key === "confirmClass") this.confirmClassDialog.form.assistantTeacherIds = ids
    },
    clearFeeAssistantField(key) {
      if (key === "abrsm") this.abrsmDialog.form.assistantTeacherIds = []
      else if (key === "renew") this.renewDialog.form.assistantTeacherIds = []
      else if (key === "renew8") this.renew8Dialog.form.assistantTeacherIds = []
      else if (key === "confirmClass") this.confirmClassDialog.form.assistantTeacherIds = []
    },
    toggleFeeAssistant(staffId) {
      const key = this.feeAssistantPopup.dialogKey
      const current = this.normalizeIdArray(this.feeAssistantCurrentIds)
      const idx = current.findIndex(id => String(id) === String(staffId))
      if (idx >= 0) current.splice(idx, 1)
      else current.push(String(staffId))
      this.onInputFeeAssistantIds(current)
    },
    async openFeeCoursePicker(dialogKey) {
      await this.ensureCourseOptions()
      if (!this.courseOptions.length) return Toast.fail("暂无课程选项")
      this.feeCoursePicker.dialogKey = dialogKey
      this.courseSearchKeyword = ""
      this.feeCoursePicker.show = true
    },
    onConfirmFeeCourse(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCourseOptions)
      if (opt) {
        if (this.feeCoursePicker.dialogKey === "renew") {
          this.renewDialog.form.courseId = opt.value
          this.renewDialog.form.courseName = opt.text
          this.renewDialog.form.bookIds = []
          this.completeBookOptions = []
          if (this.isBookRequiredCourseLabel(opt.text)) {
            this.completeBookPicker.source = "renew"
            this.loadMdBooks("renew")
          }
        } else if (this.feeCoursePicker.dialogKey === "renew8") {
          this.renew8Dialog.form.courseId = opt.value
          this.renew8Dialog.form.courseName = opt.text
          this.renew8Dialog.form.bookIds = []
          this.completeBookOptions = []
          if (this.isBookRequiredCourseLabel(opt.text)) {
            this.completeBookPicker.source = "renew8"
            this.loadMdBooks("renew8")
          }
        }
      }
      this.feeCoursePicker.show = false
    },
    openFeeTimePicker(dialogKey) {
      const titleMap = {
        abrsm: "选择支付时间",
        renew: "选择支付时间",
        renew8: "选择支付时间",
        other: "选择支付时间"
      }
      this.feeTimePicker.dialogKey = dialogKey
      this.feeTimePicker.title = titleMap[dialogKey] || "选择时间"
      let raw = ""
      if (dialogKey === "abrsm") raw = this.abrsmDialog.form.completeTime
      else if (dialogKey === "renew") raw = this.renewDialog.form.completeTime
      else if (dialogKey === "renew8") raw = this.renew8Dialog.form.completeTime
      else if (dialogKey === "other") raw = this.otherDialog.form.completeTime
      this.feeTimePicker.value = raw ? new Date(String(raw).replace(/-/g, "/")) : new Date()
      this.feeTimePicker.show = true
    },
    onConfirmFeeTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      const str = formatDateTime(dt)
      const key = this.feeTimePicker.dialogKey
      if (key === "abrsm") this.abrsmDialog.form.completeTime = str
      else if (key === "renew") this.renewDialog.form.completeTime = str
      else if (key === "renew8") this.renew8Dialog.form.completeTime = str
      else if (key === "other") this.otherDialog.form.completeTime = str
      this.feeTimePicker.value = dt
      this.feeTimePicker.show = false
    },
    async submitAbrsm() {
      if (this.abrsmDialog.submitting) return
      if (this.abrsmDialog.editMode) {
        return this.submitFeeRecordUpdate(RENEW_RECORD_TYPE.ABRSM, this.abrsmDialog, "abrsm")
      }
      const form = this.abrsmDialog.form
      const id = form.id
      const amount = Number(form.amount)
      const completeTime = (form.completeTime || "").trim()
      if (!id) return Toast.fail("缺少学员ID")
      if (!Number.isFinite(amount) || amount <= 0) return Toast.fail("请输入正确的金额")
      if (!completeTime) return Toast.fail("请选择支付时间")
      if (form.leadTeacherId === null || form.leadTeacherId === undefined || form.leadTeacherId === "") {
        return Toast.fail("请选择主课老师")
      }
      if (!this.ensurePaymentMethodSelected(form.paymentMethod)) return
      this.abrsmDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        const payload = {
          id,
          amount,
          completeTime,
          leadTeacherId: form.leadTeacherId,
          assistantTeacherIds: this.normalizeIdArray(form.assistantTeacherIds),
          remark: (form.remark || "").trim() || undefined
        }
        this.appendPaymentMethodPayload(payload, form.paymentMethod)
        if (!this.appendCoursePackagesPayload(payload, form.coursePackages)) {
          Toast.clear()
          return
        }
        if (form.staffId !== null && form.staffId !== undefined && form.staffId !== "") {
          payload.staffId = form.staffId
        }
        this.appendProjectIdIfNeeded(payload, form.projectId)
        await customerAbrsm(payload)
        Toast.clear()
        Toast.success("提交成功")
        this.closeFeeBizDialog("abrsm")
        await this.fetchDetailRenewList(this.detailItem.id)
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.abrsmDialog.submitting = false
      }
    },
    async submitRenew() {
      if (this.renewDialog.submitting) return
      if (this.renewDialog.editMode) {
        return this.submitFeeRecordUpdate(RENEW_RECORD_TYPE.REN, this.renewDialog, "renew")
      }
      const form = this.renewDialog.form
      const payload = this.buildRenewPayload(form)
      if (!payload) return
      this.renewDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await customerRenew(payload)
        Toast.clear()
        Toast.success("提交成功")
        this.closeFeeBizDialog("renew")
        await this.fetchDetailRenewList(this.detailItem.id)
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.renewDialog.submitting = false
      }
    },
    async submitRenew8() {
      if (this.renew8Dialog.submitting) return
      if (this.renew8Dialog.editMode) {
        return this.submitFeeRecordUpdate(RENEW_RECORD_TYPE.UP, this.renew8Dialog, "renew8")
      }
      const form = this.renew8Dialog.form
      const payload = this.buildRenewPayload(form)
      if (!payload) return
      this.renew8Dialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await customerRenew8(payload)
        Toast.clear()
        Toast.success("提交成功")
        this.closeFeeBizDialog("renew8")
        await this.fetchDetailRenewList(this.detailItem.id)
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.renew8Dialog.submitting = false
      }
    },
    buildRenewPayload(form) {
      const id = form.id
      const amount = Number(form.amount)
      const completeTime = (form.completeTime || "").trim()
      const courseId = form.courseId
      const leadTeacherId = form.leadTeacherId
      const assistantTeacherIds = this.normalizeIdArray(form.assistantTeacherIds)
      const staffId = form.staffId
      if (!id) {
        Toast.fail("缺少学员ID")
        return null
      }
      if (!Number.isFinite(amount) || amount <= 0) {
        Toast.fail("请输入正确的金额")
        return null
      }
      if (!completeTime) {
        Toast.fail("请选择支付时间")
        return null
      }
      if (courseId === null || courseId === undefined || courseId === "") {
        Toast.fail("请选择课程")
        return null
      }
      if (leadTeacherId === null || leadTeacherId === undefined || leadTeacherId === "") {
        Toast.fail("请选择主课老师")
        return null
      }
      if (!this.ensurePaymentMethodSelected(form.paymentMethod)) return null
      const payload = {
        id,
        amount,
        completeTime,
        courseId,
        leadTeacherId,
        assistantTeacherIds,
        remark: (form.remark || "").trim() || undefined
      }
      if (!this.appendCoursePackagesPayload(payload, form.coursePackages)) return null
      if (staffId !== null && staffId !== undefined && staffId !== "") {
        payload.staffId = staffId
      }
      this.appendPaymentMethodPayload(payload, form.paymentMethod)
      this.appendPerformanceAmountIfNeeded(payload, form)
      this.appendProjectIdIfNeeded(payload, form.projectId)
      const courseLabel = this.feeCourseDisplayLabel(form)
      if (!this.appendMdBookIdsIfNeeded(payload, form, courseLabel)) return null
      return payload
    },
    async submitOther() {
      if (this.otherDialog.submitting) return
      if (this.otherDialog.editMode) {
        return this.submitFeeRecordUpdate(RENEW_RECORD_TYPE.OTHER, this.otherDialog, "other")
      }
      const form = this.otherDialog.form
      const id = form.id
      const amount = Number(form.amount)
      const completeTime = (form.completeTime || "").trim()
      if (!id) return Toast.fail("缺少学员ID")
      if (!Number.isFinite(amount) || amount <= 0) return Toast.fail("请输入正确的金额")
      if (!completeTime) return Toast.fail("请选择支付时间")
      const abrsmType = this.parseOtherFeeType(form)
      if (abrsmType === null) return
      if (!this.ensurePaymentMethodSelected(form.paymentMethod)) return
      this.otherDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        const payload = {
          id,
          abrsmType,
          amount,
          completeTime,
          remark: (form.remark || "").trim() || undefined
        }
        const staffId = form.staffId
        if (staffId !== null && staffId !== undefined && staffId !== "") {
          payload.staffId = staffId
        }
        this.appendPaymentMethodPayload(payload, form.paymentMethod)
        this.appendPerformanceAmountIfNeeded(payload, form)
        this.appendProjectIdIfNeeded(payload, form.projectId)
        await customerOther(payload)
        Toast.clear()
        Toast.success("提交成功")
        this.closeFeeBizDialog("other")
        await this.fetchDetailRenewList(this.detailItem.id)
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.otherDialog.submitting = false
      }
    },
    async openUpdateFromDetail() {
      await this.ensureStaffOptions()
      await this.ensureCourseOptions()
      await this.ensureChannelOptions()
      await this.ensureCheckInResultOptions()
      await this.ensureProjectOptions()
      const rawCheckInResult = this.detailItem.checkInResult
      const checkInResultFromName =
        rawCheckInResult === null || rawCheckInResult === undefined || rawCheckInResult === ""
          ? (
              this.checkInResultOptions.find(
                x =>
                  String(x.text) === String(this.detailItem.checkInResultName || "") ||
                  String(x.text) === String(this.detailItem.checkinResultName || "")
              ) || {}
            ).value
          : undefined
      this.updateDialog.isDepositIncomeConfirm = this.isDepositIncomeConfirmed(this.detailItem)
      this.updateDialog.isOrderIncomeConfirm = this.isOrderIncomeConfirmed(this.detailItem)
      this.updateDialog.form = {
        id: this.detailItem.id ?? null,
        status: this.detailItem.status ?? null,
        name: (this.detailItem.name || "").trim(),
        stuName: (this.detailItem.stuName || "").trim(),
        mobile: (this.detailItem.mobile || "").trim(),
        birthDate: (this.detailItem.birthDate || "").trim(),
        age: this.detailItem.age === null || this.detailItem.age === undefined ? "" : String(this.detailItem.age),
        gender: this.detailItem.gender === null || this.detailItem.gender === undefined ? null : Number(this.detailItem.gender),
        channelType: this.detailItem.channelType ?? null,
        channelStaffId: this.detailItem.channelStaffId ?? null,
        remark: (this.detailItem.remark || "").trim(),
        bookingTime: (this.detailItem.bookingTime || "").trim(),
        hostStaffId: this.detailItem.hostStaffId ?? null,
        trialTeacherId: this.detailItem.trialTeacherId ?? null,
        checkInTime: (this.detailItem.checkInTime || "").trim(),
        signRemark: (this.detailItem.signRemark || "").trim(),
        checkInResult:
          rawCheckInResult === null || rawCheckInResult === undefined || rawCheckInResult === ""
            ? checkInResultFromName ?? null
            : rawCheckInResult,
        checkInRemark: (this.detailItem.checkInRemark || "").trim(),
        depositAmount:
          this.detailItem.depositAmount === null || this.detailItem.depositAmount === undefined
            ? ""
            : String(this.detailItem.depositAmount),
        paidTime: (this.detailItem.paidTime || "").trim(),
        depositPaymentMethod: this.detailItem.depositPaymentMethod ?? null,
        depositProjectId: this.detailItem.depositProjectId ?? null,
        isPersonalPerformance: this.isIncomeConfirmTrue(this.detailItem?.isPersonalPerformance),
        amount: this.detailItem.amount === null || this.detailItem.amount === undefined ? "" : String(this.detailItem.amount),
        completeTime: (this.detailItem.completeTime || "").trim(),
        paymentMethod: this.detailItem.paymentMethod ?? null,
        performanceAmount:
          this.detailItem.performanceAmount === null || this.detailItem.performanceAmount === undefined
            ? ""
            : String(this.detailItem.performanceAmount),
        headcount: this.normalizeHeadcountValue(this.detailItem.headcount, 1),
        projectId: this.detailItem.projectId ?? null,
        courseId: this.detailItem.courseId ?? null,
        leadTeacherId: this.detailItem.leadTeacherId ?? null,
        assistantTeacherIds: this.normalizeIdArray(this.detailItem.assistantTeacherIds)
      }
      this.updateDialog.show = true
    },
    async openUpdateChannelPicker() {
      await this.ensureChannelOptions()
      this.updateChannelPicker.show = true
    },
    onConfirmUpdateChannel(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.channelOptions)
      if (opt) this.updateDialog.form.channelType = opt.value
      this.updateChannelPicker.show = false
    },
    async openUpdateStaffPicker(target, title) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.updateStaffSearch.single = ""
      this.updateStaffPicker.target = target
      this.updateStaffPicker.title = title
      this.updateStaffPicker.show = true
    },
    onConfirmUpdateStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredUpdateStaffOptions)
      if (opt && this.updateStaffPicker.target) {
        this.updateDialog.form[this.updateStaffPicker.target] = opt.value
      }
      this.updateStaffPicker.show = false
    },
    async openUpdateAssistantPopup() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.updateStaffSearch.assistant = ""
      this.updateAssistantPopup.show = true
    },
    toggleUpdateAssistant(staffId) {
      const ids = Array.isArray(this.updateDialog.form.assistantTeacherIds) ? this.updateDialog.form.assistantTeacherIds : []
      const target = String(staffId)
      const idx = ids.findIndex(id => String(id) === target)
      if (idx >= 0) ids.splice(idx, 1)
      else ids.push(target)
      this.updateDialog.form.assistantTeacherIds = [...ids]
    },
    clearUpdateAssistantTeachers() {
      this.updateDialog.form.assistantTeacherIds = []
    },
    async openUpdateCoursePicker() {
      await this.ensureCourseOptions()
      if (!this.courseOptions.length) return Toast.fail("暂无课程选项")
      this.courseSearchKeyword = ""
      this.updateCoursePicker.show = true
    },
    async openUpdateCheckInResultPicker() {
      await this.ensureCheckInResultOptions()
      if (!this.checkInResultOptions.length) return Toast.fail("暂无到店结果选项")
      this.updateCheckInResultPicker.show = true
    },
    onConfirmUpdateCheckInResult(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.checkInResultOptions)
      if (opt) this.updateDialog.form.checkInResult = opt.value
      this.updateCheckInResultPicker.show = false
    },
    onConfirmUpdateCourse(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCourseOptions)
      if (opt) this.updateDialog.form.courseId = opt.value
      this.updateCoursePicker.show = false
    },
    openUpdateTimePicker(target, title) {
      const raw = this.updateDialog.form[target]
      let base = target === "birthDate" ? getTenYearsAgoJan1() : new Date()
      if (raw) {
        const dt = new Date(raw)
        if (!Number.isNaN(dt.getTime())) base = dt
      }
      this.updateTimePicker.target = target
      this.updateTimePicker.title = title
      this.updateTimePicker.type = target === "birthDate" ? "date" : "datetime"
      this.updateTimePicker.value = base
      this.updateTimePicker.show = true
    },
    onConfirmUpdateTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.updateTimePicker.value = dt
      if (this.updateTimePicker.target) {
        this.updateDialog.form[this.updateTimePicker.target] =
          this.updateTimePicker.type === "date" ? formatDate(dt) : formatDateTime(dt)
      }
      this.updateTimePicker.show = false
    },
    openBookingBirthDatePicker() {
      const dt = parseDateSafe(this.bookingForm.birthDate) || getTenYearsAgoJan1()
      this.bookingBirthDatePicker.value = dt
      this.bookingBirthDatePicker.show = true
    },
    onConfirmBookingBirthDate(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.bookingBirthDatePicker.value = dt
      this.bookingForm.birthDate = formatDate(dt)
      this.bookingBirthDatePicker.show = false
    },
    async openBookingChannelStaffPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.bookingChannel = ""
      this.bookingChannelStaffPicker.show = true
    },
    onConfirmBookingChannelStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredBookingChannelStaffOptions)
      if (opt) this.bookingForm.channelStaffId = opt.value
      this.bookingChannelStaffPicker.show = false
    },
    clearBookingChannelStaff() {
      this.bookingForm.channelStaffId = null
    },
    clearUpdateChannelStaff() {
      this.updateDialog.form.channelStaffId = null
    },
    async submitUpdate() {
      if (this.updateSubmitting) return
      const form = this.updateDialog.form || {}
      const id = form.id
      const name = (form.name || "").trim()
      const stuName = (form.stuName || "").trim()
      const mobile = (form.mobile || "").trim()
      const channelType = form.channelType
      if (!id) {
        Toast.fail("缺少ID")
        return
      }
      if (!stuName) {
        Toast.fail("请输入学员名")
        return
      }
      if (!mobile) {
        Toast.fail("请输入手机号")
        return
      }
      if (channelType === null || channelType === undefined || channelType === "") {
        Toast.fail("请选择渠道")
        return
      }
      const birthDate = (form.birthDate || "").trim()
      const ageNum = calcAgeByBirthDate(birthDate)
      const status = Number(form.status)
      const depositStr = (form.depositAmount || "").trim()
      const depositNum = depositStr === "" ? null : Number(depositStr)
      const amountStr = (form.amount || "").trim()
      const amountNum = amountStr === "" ? null : Number(amountStr)
      const payload = {
        id,
        name: name || undefined,
        stuName,
        mobile,
        birthDate: birthDate || undefined,
        channelType,
        remark: (form.remark || "").trim() || undefined,
        gender: form.gender || undefined
      }
      const csIdUpd = form.channelStaffId
      if (csIdUpd !== null && csIdUpd !== undefined && csIdUpd !== "") {
        payload.channelStaffId = csIdUpd
      }
      if (ageNum !== null) {
        payload.age = ageNum
      }
      if (status >= 1) {
        payload.bookingTime = (form.bookingTime || "").trim() || undefined
      }
      if (status >= 2) {
        payload.hostStaffId = form.hostStaffId || undefined
        payload.trialTeacherId = form.trialTeacherId || undefined
        payload.checkInTime = (form.checkInTime || "").trim() || undefined
        payload.signRemark = (form.signRemark || "").trim() || undefined
      }
      if (status >= 3) {
        const shouldSendDepositFields = Number(form.checkInResult) === 5
        if (form.checkInResult !== null && form.checkInResult !== undefined && form.checkInResult !== "") {
          payload.checkInResult = form.checkInResult
        }
        payload.checkInRemark = (form.checkInRemark || "").trim() || undefined
        if (shouldSendDepositFields) {
          if (!this.updateDepositAmountReadonly && !this.ensurePaymentMethodSelected(form.depositPaymentMethod)) {
            return
          }
          if (depositStr !== "" && Number.isFinite(depositNum)) payload.depositAmount = depositNum
          payload.paidTime = (form.paidTime || "").trim() || undefined
          payload.isPersonalPerformance = !!form.isPersonalPerformance
          if (!this.updateDepositAmountReadonly) {
            this.appendDepositPaymentMethodPayload(payload, form.depositPaymentMethod)
          }
          this.appendDepositProjectIdIfNeeded(payload, form.depositProjectId)
        }
      }
      if (status >= 4) {
        if (!this.updateOrderAmountReadonly && !this.ensurePaymentMethodSelected(form.paymentMethod)) {
          return
        }
        if (amountStr !== "" && Number.isFinite(amountNum)) payload.amount = amountNum
        payload.completeTime = (form.completeTime || "").trim() || undefined
        payload.courseId = form.courseId || undefined
        payload.leadTeacherId = form.leadTeacherId || undefined
        payload.assistantTeacherIds = (Array.isArray(form.assistantTeacherIds) ? form.assistantTeacherIds : [])
          .filter(x => x !== null && x !== undefined && x !== "")
        if (!this.updateOrderAmountReadonly) {
          this.appendPaymentMethodPayload(payload, form.paymentMethod)
        }
        this.appendPerformanceAmountIfNeeded(payload, form)
        this.appendHeadcountIfNeeded(payload, form)
        this.appendProjectIdIfNeeded(payload, form.projectId)
      }
      this.updateSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await updateCustomer(payload)
        Toast.clear()
        Toast.success("修改成功")
        this.updateDialog.show = false
        this.detailDialog.show = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.updateSubmitting = false
      }
    },
    async openInvite(it, options = {}) {
      const isExpansionFlow = options.parentCustomerId !== null && options.parentCustomerId !== undefined && options.parentCustomerId !== ""
      await Promise.all([
        isExpansionFlow ? this.ensureExpansionCourseOptions() : this.ensureCourseOptions(),
        this.ensureChannelOptions(),
        this.ensureStaffOptions()
      ])
      const nextDayNine = getNextDayNineAM()
      this.invitePopup.id = it.id
      this.invitePopup.parentCustomerId = options.parentCustomerId ?? null
      this.invitePopup.mode = "booking"
      this.inviteForm = {
        bookingTime: formatDateTime(nextDayNine),
        trialCourseId: it?.trialCourseId ?? null,
        channelType: it?.channelType ?? null,
        channelStaffId: it?.channelStaffId ?? null
      }
      this.inviteTimePicker.value = nextDayNine
      this.invitePopup.show = true
    },
    async openAgainInviteFromDetail() {
      if (!this.detailItem?.id) return Toast.fail("缺少学员ID")
      await Promise.all([this.ensureCourseOptions(), this.ensureChannelOptions(), this.ensureStaffOptions()])
      const nextDayNine = getNextDayNineAM()
      this.invitePopup.id = this.detailItem.id
      this.invitePopup.parentCustomerId = null
      this.invitePopup.mode = "again"
      this.inviteForm = {
        bookingTime: formatDateTime(nextDayNine),
        trialCourseId: this.detailItem?.trialCourseId ?? null,
        channelType: this.detailItem?.channelType ?? null,
        channelStaffId: this.detailItem?.channelStaffId ?? null
      }
      this.inviteTimePicker.value = nextDayNine
      this.invitePopup.show = true
    },
    async openInviteChannelPicker() {
      await this.ensureChannelOptions()
      if (!this.channelOptions.length) return Toast.fail("暂无渠道选项")
      this.inviteChannelPicker.show = true
    },
    onConfirmInviteChannel(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.channelOptions)
      if (opt) this.inviteForm.channelType = opt.value
      this.inviteChannelPicker.show = false
    },
    async openInviteChannelStaffPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.bookingChannel = ""
      this.inviteChannelStaffPicker.show = true
    },
    onConfirmInviteChannelStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredBookingChannelStaffOptions)
      if (opt) this.inviteForm.channelStaffId = opt.value
      this.inviteChannelStaffPicker.show = false
    },
    clearInviteChannelStaff() {
      this.inviteForm.channelStaffId = null
    },
    async openInviteCoursePicker() {
      if (this.invitePopup.parentCustomerId) {
        await this.ensureExpansionCourseOptions()
        if (!this.expansionCourseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      } else {
        await this.ensureCourseOptions()
        if (!this.courseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      }
      this.courseSearchKeyword = ""
      this.inviteCoursePicker.show = true
    },
    onConfirmInviteCourse(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredInviteCourseOptions)
      if (opt) this.inviteForm.trialCourseId = opt.value
      this.inviteCoursePicker.show = false
    },
    onConfirmInviteTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.inviteForm.bookingTime = formatDateTime(dt)
      this.inviteTimePicker.show = false
    },
    async submitInvite() {
      if (this.inviteSubmitting) return
      const id = this.invitePopup.id
      if (!id) return Toast.fail("缺少学员ID")
      const bookingTime = (this.inviteForm.bookingTime || "").trim()
      if (!bookingTime) return Toast.fail("请选择邀约时间")
      const trialCourseId = this.inviteForm.trialCourseId
      const isAgainBooking = this.invitePopup.mode === "again"
      this.inviteSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        const payload = {
          id,
          bookingTime,
          trialCourseId: trialCourseId === null || trialCourseId === undefined || trialCourseId === "" ? undefined : trialCourseId
        }
        const channelType = this.inviteForm.channelType
        if (channelType !== null && channelType !== undefined && channelType !== "") {
          payload.channelType = channelType
        }
        const channelStaffId = this.inviteForm.channelStaffId
        if (channelStaffId !== null && channelStaffId !== undefined && channelStaffId !== "") {
          payload.channelStaffId = channelStaffId
        }
        if (isAgainBooking) await againBookingCustomer(payload)
        else await bookingCustomer(payload)
        Toast.clear()
        Toast.success(isAgainBooking ? "再邀约成功" : "邀约成功")
        this.invitePopup.show = false
        if (isAgainBooking) this.detailDialog.show = false
        await this.refreshAfterFlowSubmit(this.invitePopup.parentCustomerId)
      } catch (e) {
        Toast.clear()
      } finally {
        this.inviteSubmitting = false
      }
    },
    normalizeStaffRows(raw) {
      let list = []
      if (Array.isArray(raw)) list = raw
      else if (raw && Array.isArray(raw.data)) list = raw.data
      else if (raw && Array.isArray(raw.list)) list = raw.list
      else if (raw && Array.isArray(raw.records)) list = raw.records
      return list
        .map(item => {
          const text = item.weName ?? item.name ?? item.label ?? ""
          const value = item.id
          return { text: String(text), value }
        })
        .filter(x => x.text && x.value !== undefined && x.value !== null && x.value !== "")
    },
    normalizeTopDepartments(raw) {
      let list = []
      if (Array.isArray(raw)) list = raw
      else if (raw && Array.isArray(raw.data)) list = raw.data
      else if (raw && Array.isArray(raw.list)) list = raw.list
      else if (raw && Array.isArray(raw.records)) list = raw.records
      return list
        .map(item => {
          const text = item.weName ?? item.name ?? item.label ?? ""
          const value = item.weId ?? item.id
          return { text: String(text), value }
        })
        .filter(x => x.text && x.value !== undefined && x.value !== null && x.value !== "")
    },
    async ensureTopDepartmentOptions() {
      if (this.topDepartmentOptions.length || this.topDepartmentLoading) return
      this.topDepartmentLoading = true
      try {
        const res = await fetchTopDepartments()
        this.topDepartmentOptions = this.normalizeTopDepartments(res)
      } finally {
        this.topDepartmentLoading = false
      }
    },
    async ensureLoginStaffInfo() {
      try {
        const staff = await ensureCurrentStaffProfile()
        if (staff && staff.authType !== null && staff.authType !== undefined && staff.authType !== "") {
          this.loginAuthType = staff.authType
        }
      } catch (e) {
        // ignore
      }
    },
    async ensureStaffOptions() {
      if (this.staffOptions.length || this.staffLoading) return
      this.staffLoading = true
      try {
        const res = await fetchStaffList({ displayStart: 1, displayLength: STAFF_PAGE_SIZE })
        this.staffOptions = this.normalizeStaffRows(res)
      } finally {
        this.staffLoading = false
      }
    },
    pickOptionFromPicker(values, indexes, options) {
      if (Number.isInteger(indexes) && options[indexes]) return options[indexes]
      if (Array.isArray(indexes) && indexes.length && options[indexes[0]]) return options[indexes[0]]
      if (Array.isArray(values) && values.length) {
        const v = values[0]
        if (v && typeof v === "object" && "value" in v) return v
        return options.find(o => String(o.value) === String(v) || String(o.text) === String(v)) || null
      }
      if (values && typeof values === "object" && "value" in values) return values
      if (values !== undefined && values !== null && values !== "") {
        return options.find(o => String(o.value) === String(values) || String(o.text) === String(values)) || null
      }
      return null
    },
    async openCheckIn(it, options = {}) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) {
        Toast.fail("暂无员工列表")
        return
      }
      const now = new Date()
      this.checkInPopup.customerId = it.id
      this.checkInPopup.parentCustomerId = options.parentCustomerId ?? null
      this.checkInForm = {
        hostStaffId: null,
        trialTeacherId: null,
        trialCourseId: it?.trialCourseId ?? null,
        checkInTime: formatDateTime(now),
        signRemark: (it?.signRemark || "").trim()
      }
      this.checkInTimePicker.value = now
      this.checkInPopup.show = true
    },
    async openHostStaffPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.host = ""
      this.hostStaffPicker.show = true
    },
    async openTrialTeacherPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.trial = ""
      this.trialTeacherPicker.show = true
    },
    onConfirmHostStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredHostStaffOptions)
      if (opt) this.checkInForm.hostStaffId = opt.value
      this.hostStaffPicker.show = false
    },
    onConfirmTrialTeacher(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredTrialStaffOptions)
      if (opt) this.checkInForm.trialTeacherId = opt.value
      this.trialTeacherPicker.show = false
    },
    onConfirmCheckInTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.checkInTimePicker.value = dt
      this.checkInForm.checkInTime = formatDateTime(dt)
      this.checkInTimePicker.show = false
    },
    async openCheckInCoursePicker() {
      if (this.checkInPopup.parentCustomerId) {
        await this.ensureExpansionCourseOptions()
        if (!this.expansionCourseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      } else {
        await this.ensureCourseOptions()
        if (!this.courseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      }
      this.courseSearchKeyword = ""
      this.checkInCoursePicker.show = true
    },
    onConfirmCheckInCourse(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCheckInCourseOptions)
      if (opt) this.checkInForm.trialCourseId = opt.value
      this.checkInCoursePicker.show = false
    },
    async submitCheckIn() {
      if (this.checkInSubmitting) return
      const customerId = this.checkInPopup.customerId
      if (!customerId) return Toast.fail("缺少家长ID")
      const trialCourseId = this.checkInForm.trialCourseId
      const payload = {
        id: customerId,
        hostStaffId: this.checkInForm.hostStaffId,
        trialTeacherId: this.checkInForm.trialTeacherId,
        checkInTime: this.checkInForm.checkInTime,
        trialCourseId: trialCourseId === null || trialCourseId === undefined || trialCourseId === "" ? undefined : trialCourseId
      }
      const signRemark = (this.checkInForm.signRemark || "").trim()
      if (signRemark) payload.signRemark = signRemark
      this.checkInSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await checkInCustomer(payload)
        Toast.clear()
        Toast.success("已到店")
        this.checkInPopup.show = false
        await this.refreshAfterFlowSubmit(this.checkInPopup.parentCustomerId)
      } catch (e) {
        Toast.clear()
      } finally {
        this.checkInSubmitting = false
      }
    },
    async ensureCheckInResultOptions() {
      if (this.checkInResultOptions.length || this.checkInResultLoading) return
      this.checkInResultLoading = true
      try {
        const res = await fetchDictionary(CHECKIN_RESULT_DICT_TYPE_ID)
        this.checkInResultOptions = this.normalizeDictionaryRows(res)
      } finally {
        this.checkInResultLoading = false
      }
    },
    async openCheckInResult(it, options = {}) {
      await this.ensureCheckInResultOptions()
      if (!this.checkInResultOptions.length) return Toast.fail("暂无到店结果选项")
      const now = new Date()
      this.checkInResultDialog.id = it.id
      this.checkInResultDialog.parentCustomerId = options.parentCustomerId ?? null
      this.checkInResultDialog.hostStaffId = it.hostStaffId ?? null
      this.checkInResultDialog.hostStaffName = (it.hostStaffName || "").trim()
      this.checkInResultDialog.checkInResult = null
      this.checkInResultDialog.checkInRemark = ""
      this.checkInResultDialog.depositAmount = it.depositAmount ? String(it.depositAmount) : ""
      this.checkInResultDialog.paidTime = formatDateTime(now)
      this.checkInResultDialog.isDepositIncomeConfirm = this.isDepositIncomeConfirmed(it)
      this.checkInResultDialog.isPersonalPerformance = false
      this.checkInResultDialog.depositPaymentMethod = it.depositPaymentMethod ?? null
      this.checkInResultDialog.depositProjectId = null
      this.paidTimePicker.value = now
      this.checkInResultDialog.show = true
    },
    async openCheckInResultHostPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.checkInResultHost = ""
      this.checkInResultHostPicker.show = true
    },
    onConfirmCheckInResultHost(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCheckInResultHostOptions)
      if (opt) this.checkInResultDialog.hostStaffId = opt.value
      this.checkInResultHostPicker.show = false
    },
    async openCheckInResultPicker() {
      await this.ensureCheckInResultOptions()
      if (!this.checkInResultOptions.length) return Toast.fail("暂无到店结果选项")
      this.checkInResultPicker.show = true
    },
    onConfirmCheckInResult(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.checkInResultOptions)
      this.checkInResultDialog.checkInResult = opt ? opt.value : null
      this.checkInResultPicker.show = false
    },
    onConfirmPaidTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.paidTimePicker.value = dt
      if (this.checkInResultDialog && this.checkInResultDialog.show) {
        this.checkInResultDialog.paidTime = formatDateTime(dt)
      }
      this.paidTimePicker.show = false
    },
    async submitCheckInResult() {
      if (this.checkInResultSubmitting) return
      const id = this.checkInResultDialog.id
      const checkInResult = this.checkInResultDialog.checkInResult
      const checkInRemark = (this.checkInResultDialog.checkInRemark || "").trim()
      const depositAmountNum = Number(this.checkInResultDialog.depositAmount)
      const paidTime = this.checkInResultDialog.paidTime
      if (!id) return Toast.fail("缺少学员ID")
      if (checkInResult === null || checkInResult === undefined || checkInResult === "") {
        return Toast.fail("请选择到店结果")
      }
      if (Number(checkInResult) === 5) {
        if (!Number.isFinite(depositAmountNum) || depositAmountNum <= 0) return Toast.fail("请输入正确的定金金额")
        if (!paidTime) return Toast.fail("请选择支付时间")
        if (!this.checkInResultDepositReadonly && !this.ensurePaymentMethodSelected(this.checkInResultDialog.depositPaymentMethod)) {
          return
        }
      }
      this.checkInResultSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        const payload = {
          id,
          checkInResult,
          hostStaffId: this.checkInResultDialog.hostStaffId || undefined,
          checkInRemark: checkInRemark || undefined
        }
        if (Number(checkInResult) === 5) {
          payload.depositAmount = depositAmountNum
          payload.paidTime = paidTime
          payload.isPersonalPerformance = !!this.checkInResultDialog.isPersonalPerformance
          if (!this.checkInResultDepositReadonly) {
            this.appendDepositPaymentMethodPayload(payload, this.checkInResultDialog.depositPaymentMethod)
          }
          this.appendDepositProjectIdIfNeeded(payload, this.checkInResultDialog.depositProjectId)
        }
        await checkInResultCustomer(payload)
        Toast.clear()
        Toast.success("提交成功")
        this.checkInResultDialog.show = false
        await this.refreshAfterFlowSubmit(this.checkInResultDialog.parentCustomerId)
      } catch (e) {
        Toast.clear()
      } finally {
        this.checkInResultSubmitting = false
      }
    },
    async beforeCloseCheckInResult(action, done) {
      if (action !== "confirm") {
        done()
        return
      }
      const id = this.checkInResultDialog.id
      const checkInResult = this.checkInResultDialog.checkInResult
      const checkInRemark = (this.checkInResultDialog.checkInRemark || "").trim()
      const depositAmountNum = Number(this.checkInResultDialog.depositAmount)
      const paidTime = this.checkInResultDialog.paidTime
      if (!id) {
        Toast.fail("缺少学员ID")
        done(false)
        return
      }
      if (checkInResult === null || checkInResult === undefined || checkInResult === "") {
        Toast.fail("请选择到店结果")
        done(false)
        return
      }
      if (Number(checkInResult) === 5) {
        if (!Number.isFinite(depositAmountNum) || depositAmountNum <= 0) {
          Toast.fail("请输入正确的定金金额")
          done(false)
          return
        }
        if (!paidTime) {
          Toast.fail("请选择支付时间")
          done(false)
          return
        }
        if (!this.checkInResultDepositReadonly && !this.ensurePaymentMethodSelected(this.checkInResultDialog.depositPaymentMethod)) {
          done(false)
          return
        }
      }
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        const payload = {
          id,
          checkInResult,
          hostStaffId: this.checkInResultDialog.hostStaffId || undefined,
          checkInRemark: checkInRemark || undefined
        }
        if (Number(checkInResult) === 5) {
          payload.depositAmount = depositAmountNum
          payload.paidTime = paidTime
          payload.isPersonalPerformance = !!this.checkInResultDialog.isPersonalPerformance
          if (!this.checkInResultDepositReadonly) {
            this.appendDepositPaymentMethodPayload(payload, this.checkInResultDialog.depositPaymentMethod)
          }
          this.appendDepositProjectIdIfNeeded(payload, this.checkInResultDialog.depositProjectId)
        }
        await checkInResultCustomer(payload)
        Toast.clear()
        Toast.success("提交成功")
        done()
        await this.refreshAfterFlowSubmit(this.checkInResultDialog.parentCustomerId)
      } catch (e) {
        Toast.clear()
        done(false)
      }
    },
    async ensureCourseOptions() {
      if (this.courseOptions.length || this.courseLoading) return
      this.courseLoading = true
      try {
        const res = await fetchBookCourses({ status: ENABLED_BOOK_STATUS })
        this.courseOptions = this.normalizeCourseOptions(res)
      } finally {
        this.courseLoading = false
      }
    },
    async ensureExpansionCourseOptions() {
      if (this.expansionCourseOptions.length || this.expansionCourseLoading) return
      this.expansionCourseLoading = true
      try {
        const res = await fetchBookCourses({ status: ENABLED_BOOK_STATUS, isExpansion: 1 })
        this.expansionCourseOptions = this.normalizeCourseOptions(res)
      } finally {
        this.expansionCourseLoading = false
      }
    },
    filterCourseOptionsByKeyword(options) {
      const list = Array.isArray(options) ? options : []
      const kw = (this.courseSearchKeyword || "").trim()
      if (!kw) return list
      return list.filter(x => String(x.text || "").includes(kw))
    },
    normalizeCourseOptions(raw) {
      let list = []
      if (Array.isArray(raw)) list = raw
      else if (raw && Array.isArray(raw.data)) list = raw.data
      else if (raw && Array.isArray(raw.list)) list = raw.list
      else if (raw && Array.isArray(raw.records)) list = raw.records
      return list
        .map(item => {
          const text = (item.courseName ?? item.name ?? item.weName ?? "").trim()
          const value = item.id ?? item.courseId
          if (!text || value === null || value === undefined || value === "") return null
          return { text, value }
        })
        .filter(Boolean)
    },
    async openCoursePicker() {
      if (this.completeDialog.parentCustomerId) {
        await this.ensureExpansionCourseOptions()
        if (!this.expansionCourseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      } else {
        await this.ensureCourseOptions()
        if (!this.courseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      }
      this.courseSearchKeyword = ""
      this.coursePicker.show = true
    },
    onConfirmCourse(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCompleteCourseOptions)
      if (opt) {
        this.completeDialog.courseId = opt.value
        this.completeDialog.bookIds = []
        this.completeBookOptions = []
        if (this.isBookRequiredCourseLabel(opt.text)) {
          this.completeBookPicker.source = "complete"
          this.loadMdBooks("complete")
        }
      }
      this.coursePicker.show = false
    },
    isBookRequiredCourseLabel(text) {
      const t = String(text || "").trim().toUpperCase()
      return BOOK_REQUIRED_COURSE_NAMES.includes(t)
    },
    isMdCourseLabel(text) {
      return this.isBookRequiredCourseLabel(text)
    },
    normalizeCompleteBookOption(item) {
      if (!item || typeof item !== "object") return null
      const value = item.id ?? item.bookId
      if (value === null || value === undefined || value === "") return null
      const text = (item.bookName ?? item.name ?? "").trim() || "-"
      return { text, value: String(value) }
    },
    getMdBookCourseId(source) {
      if (source === "renew") return this.renewDialog.form?.courseId
      if (source === "renew8") return this.renew8Dialog.form?.courseId
      return this.completeDialog.courseId
    },
    getMdBookIdsArray(source) {
      if (source === "renew") return Array.isArray(this.renewDialog.form?.bookIds) ? this.renewDialog.form.bookIds : []
      if (source === "renew8") return Array.isArray(this.renew8Dialog.form?.bookIds) ? this.renew8Dialog.form.bookIds : []
      return Array.isArray(this.completeDialog.bookIds) ? this.completeDialog.bookIds : []
    },
    setMdBookIds(source, ids) {
      if (source === "renew") this.renewDialog.form.bookIds = ids
      else if (source === "renew8") this.renew8Dialog.form.bookIds = ids
      else this.completeDialog.bookIds = ids
    },
    getMdBookCourseLabel(source) {
      if (source === "renew") return this.renewCourseLabel
      if (source === "renew8") return this.renew8CourseLabel
      return this.courseLabel
    },
    mdBookLabelByIds(ids) {
      const list = Array.isArray(ids) ? ids : []
      if (!list.length) return ""
      return list
        .map(id => {
          const o = this.completeBookOptions.find(x => String(x.value) === String(id))
          return o ? o.text : String(id)
        })
        .filter(Boolean)
        .join("、")
    },
    mdBookDisplayLabel(form) {
      const ids = form?.bookIds || []
      const fromOptions = this.mdBookLabelByIds(ids)
      if (fromOptions) return fromOptions
      const items = Array.isArray(form?.bookItems) ? form.bookItems : []
      const names = items.map(b => (b?.name || "").trim()).filter(Boolean)
      return names.length ? names.join("、") : ""
    },
    parseRecordBookRaw(row) {
      const raw =
        row?.bookIds !== undefined && row?.bookIds !== null
          ? row.bookIds
          : row?.books !== undefined && row?.books !== null
            ? row.books
            : row?.bookIdList
      if (raw === null || raw === undefined) return []
      if (Array.isArray(raw)) return raw
      if (typeof raw === "string") {
        const s = raw.trim()
        if (!s) return []
        if (s.startsWith("[") && s.endsWith("]")) {
          try {
            const parsed = JSON.parse(s)
            return Array.isArray(parsed) ? parsed : []
          } catch (e) {
            // ignore
          }
        }
        return s
          .split(",")
          .map(x => x.trim())
          .filter(Boolean)
      }
      return []
    },
    normalizeRecordBookIdsForForm(row) {
      return this.parseRecordBookRaw(row)
        .map(item => {
          if (typeof item === "object" && item) {
            const id = item.id ?? item.bookId
            return id !== null && id !== undefined && id !== "" ? String(id) : null
          }
          if (item !== null && item !== undefined && item !== "") return String(item)
          return null
        })
        .filter(Boolean)
    },
    parseRecordBookIds(row) {
      const list = this.parseRecordBookRaw(row)
      return list
        .map(item => {
          if (!item || typeof item !== "object") {
            if (item !== null && item !== undefined && item !== "") {
              return { id: item, name: String(item) }
            }
            return null
          }
          const id = item.id ?? item.bookId ?? item.name
          const name = (item.name ?? item.bookName ?? item.title ?? "").trim() || (id != null ? String(id) : "")
          if (!name) return null
          return { id, name }
        })
        .filter(Boolean)
    },
    purchasedBooksSummary(row) {
      const list = this.parseRecordBookIds(row)
      if (!list.length) return "-"
      return `${list.length}本`
    },
    purchasedBooksKey(prefix, row, idx) {
      if (prefix === "detail") return `detail-${row?.id ?? "unknown"}`
      return `renew-${row?.id ?? idx}`
    },
    isPurchasedBooksExpanded(key) {
      return !!this.purchasedBooksExpanded[key]
    },
    togglePurchasedBooks(key) {
      this.$set(this.purchasedBooksExpanded, key, !this.purchasedBooksExpanded[key])
    },
    appendPerformanceAmountIfNeeded(payload, form) {
      const raw = form?.performanceAmount
      if (raw === null || raw === undefined || raw === "") return
      const n = Number(raw)
      if (Number.isFinite(n)) payload.performanceAmount = n
    },
    appendHeadcountIfNeeded(payload, form) {
      const raw = form?.headcount
      if (raw === null || raw === undefined || raw === "") return
      const normalized = this.normalizeHeadcountValue(raw, null)
      if (normalized === null) return
      payload.headcount = normalized
    },
    appendMdBookIdsIfNeeded(payload, form, courseLabel) {
      if (!this.isBookRequiredCourseLabel(courseLabel)) return true
      const bookIds = (Array.isArray(form?.bookIds) ? form.bookIds : [])
        .map(x => String(x).trim())
        .filter(Boolean)
      if (!bookIds.length) {
        Toast.fail("请选择教材")
        return false
      }
      payload.bookIds = bookIds
      return true
    },
    async loadMdBooks(source) {
      const courseId = this.getMdBookCourseId(source)
      if (courseId === null || courseId === undefined || courseId === "") {
        this.completeBookOptions = []
        return
      }
      this.completeBookLoading = true
      try {
        const res = await fetchBooks({ courseId, status: ENABLED_BOOK_STATUS })
        const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : [])
        this.completeBookOptions = list.map(item => this.normalizeCompleteBookOption(item)).filter(Boolean)
      } catch (e) {
        this.completeBookOptions = []
        Toast.fail("教材列表加载失败")
      } finally {
        this.completeBookLoading = false
      }
    },
    async openMdBookPicker(source) {
      const courseLabel = this.getMdBookCourseLabel(source)
      if (!this.isBookRequiredCourseLabel(courseLabel)) return
      if (!this.getMdBookCourseId(source)) return Toast.fail("请先选择课程")
      this.completeBookPicker.source = source
      if (!this.completeBookOptions.length && !this.completeBookLoading) {
        await this.loadMdBooks(source)
      }
      if (this.completeBookLoading) return Toast.fail("教材加载中")
      if (!this.completeBookOptions.length) return Toast.fail("暂无教材")
      this.completeBookPicker.show = true
    },
    onActiveMdBookIdsInput(val) {
      this.setMdBookIds(this.completeBookPicker.source || "complete", val)
    },
    isMdBookIdSelected(id) {
      return this.activeMdBookIds.some(x => String(x) === String(id))
    },
    toggleMdBook(value) {
      const source = this.completeBookPicker.source || "complete"
      const key = String(value)
      const ids = [...this.getMdBookIdsArray(source)]
      const idx = ids.findIndex(x => String(x) === key)
      if (idx >= 0) ids.splice(idx, 1)
      else ids.push(key)
      this.setMdBookIds(source, ids)
    },
    allCompleteBookIds() {
      return this.completeBookOptions.map(opt => opt.value).filter(v => v !== null && v !== undefined && v !== "")
    },
    toggleMdBookSelectAll() {
      const source = this.completeBookPicker.source || "complete"
      const ids = this.allCompleteBookIds()
      if (!ids.length) return
      if (this.isActiveMdBookAllSelected) {
        const removeSet = new Set(ids.map(x => String(x)))
        this.setMdBookIds(
          source,
          this.getMdBookIdsArray(source).filter(id => !removeSet.has(String(id)))
        )
        return
      }
      const selected = new Set(this.getMdBookIdsArray(source).map(x => String(x)))
      const merged = [...this.getMdBookIdsArray(source)]
      ids.forEach(id => {
        if (!selected.has(String(id))) merged.push(String(id))
      })
      this.setMdBookIds(source, merged)
    },
    async loadCompleteBooks() {
      return this.loadMdBooks("complete")
    },
    async openCompleteBookPicker() {
      return this.openMdBookPicker("complete")
    },
    toggleCompleteBook(value) {
      this.toggleMdBook(value)
    },
    toggleCompleteBookSelectAll() {
      this.toggleMdBookSelectAll()
    },
    buildCompletePayload() {
      const id = this.completeDialog.id
      const amount = Number(this.completeDialog.amount)
      const courseId = this.completeDialog.courseId
      const completeTime = this.completeDialog.completeTime
      if (!id) {
        Toast.fail("缺少学员ID")
        return null
      }
      if (!Number.isFinite(amount) || amount <= 0) {
        Toast.fail("请输入正确的支付金额")
        return null
      }
      if (courseId === null || courseId === undefined || courseId === "") {
        Toast.fail("请选择课程")
        return null
      }
      if (!completeTime) {
        Toast.fail("请选择成单时间")
        return null
      }
      if (!this.completeOrderAmountReadonly && !this.ensurePaymentMethodSelected(this.completeDialog.paymentMethod)) {
        return null
      }
      const payload = {
        id,
        amount,
        courseId,
        completeTime,
        hostStaffId: this.completeDialog.hostStaffId || undefined
      }
      if (this.isCompleteMdCourse) {
        const bookIds = (Array.isArray(this.completeDialog.bookIds) ? this.completeDialog.bookIds : [])
          .map(x => String(x).trim())
          .filter(Boolean)
        if (!bookIds.length) {
          Toast.fail("请选择教材")
          return null
        }
        payload.bookIds = bookIds
      }
      if (!this.completeOrderAmountReadonly) {
        this.appendPaymentMethodPayload(payload, this.completeDialog.paymentMethod)
      }
      this.appendPerformanceAmountIfNeeded(payload, { performanceAmount: this.completeDialog.performanceAmount })
      this.appendHeadcountIfNeeded(payload, this.completeDialog)
      this.appendProjectIdIfNeeded(payload, this.completeDialog.projectId)
      return payload
    },
    onConfirmCompleteTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.completeTimePicker.value = dt
      this.completeDialog.completeTime = formatDateTime(dt)
      this.completeTimePicker.show = false
    },
    normalizeIdArray(value) {
      if (Array.isArray(value)) {
        return value.filter(x => x !== null && x !== undefined && x !== "").map(x => String(x))
      }
      if (value === null || value === undefined || value === "") return []
      if (typeof value === "string") {
        const s = value.trim()
        if (!s) return []
        if (s.startsWith("[") && s.endsWith("]")) {
          try {
            const parsed = JSON.parse(s)
            return Array.isArray(parsed)
              ? parsed.filter(x => x !== null && x !== undefined && x !== "").map(x => String(x))
              : []
          } catch (e) {
            // ignore
          }
        }
        return s
          .split(",")
          .map(x => x.trim())
          .filter(Boolean)
          .map(x => String(x))
      }
      return []
    },
    getStaffNameById(staffId) {
      const hit = this.staffOptions.find(x => String(x.value) === String(staffId))
      return hit ? hit.text : ""
    },
    applyConfirmClassToLocal(id, patch = {}) {
      const next = { isConfirmClass: true, ...patch }
      this.items = this.items.map(it => {
        if (String(it.id) !== String(id)) return it
        return { ...it, ...next }
      })
      if (String(this.detailItem?.id) === String(id)) {
        this.detailItem = { ...this.detailItem, ...next }
      }
    },
    applyCustomerRecordPatchToLocal(id, patch = {}) {
      if (id === null || id === undefined || id === "") return
      const apply = it => {
        if (String(it.id) !== String(id)) return it
        return { ...it, ...patch }
      }
      this.items = this.items.map(apply)
      if (this.detailDialog.show && String(this.detailItem?.id) === String(id)) {
        this.detailItem = apply(this.detailItem)
      }
    },
    resolveCourseStatusName(courseStatus) {
      const hit = CONFIRM_CLASS_COURSE_STATUS_OPTIONS.find(x => Number(x.value) === Number(courseStatus))
      return hit ? hit.text : ""
    },
    applyAssignTeacherToLocal(id, leadTeacherId, assistantTeacherIds) {
      const nextAssistantIds = (Array.isArray(assistantTeacherIds) ? assistantTeacherIds : [])
        .filter(x => x !== null && x !== undefined && x !== "")
      const nextLeadName = this.getStaffNameById(leadTeacherId)
      const nextAssistantNames = nextAssistantIds.map(x => this.getStaffNameById(x)).filter(Boolean)

      this.items = this.items.map(it => {
        if (String(it.id) !== String(id)) return it
        return {
          ...it,
          leadTeacherId,
          assistantTeacherIds: [...nextAssistantIds],
          leadTeacherName: nextLeadName || it.leadTeacherName,
          assistantTeacherNames: nextAssistantNames.length ? nextAssistantNames : it.assistantTeacherNames
        }
      })

      if (String(this.detailItem?.id) === String(id)) {
        this.detailItem = {
          ...this.detailItem,
          leadTeacherId,
          assistantTeacherIds: [...nextAssistantIds],
          leadTeacherName: nextLeadName || this.detailItem.leadTeacherName,
          assistantTeacherNames: nextAssistantNames.length ? nextAssistantNames : this.detailItem.assistantTeacherNames
        }
      }
    },
    async openAssignTeacher(it) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) {
        Toast.fail("暂无员工列表")
        return
      }
      this.assignDialog = {
        show: true,
        id: it.id,
        leadTeacherId: it.leadTeacherId ?? null,
        assistantTeacherIds: this.normalizeIdArray(it.assistantTeacherIds)
      }
    },
    async openAssignLeadTeacherPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.lead = ""
      this.assignLeadTeacherPicker.show = true
    },
    onConfirmAssignLeadTeacher(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredLeadStaffOptions)
      if (opt) this.assignDialog.leadTeacherId = opt.value
      this.assignLeadTeacherPicker.show = false
    },
    async openAssignAssistantTeacherPopup() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.assistant = ""
      this.assignAssistantTeacherPopup.show = true
    },
    toggleAssistant(staffId) {
      const ids = Array.isArray(this.assignDialog.assistantTeacherIds) ? this.assignDialog.assistantTeacherIds : []
      const idx = ids.findIndex(id => String(id) === String(staffId))
      if (idx >= 0) ids.splice(idx, 1)
      else ids.push(staffId)
      this.assignDialog.assistantTeacherIds = [...ids]
    },
    clearAssignAssistantTeachers() {
      this.assignDialog.assistantTeacherIds = []
    },
    async beforeCloseAssignTeacher(action, done) {
      if (action !== "confirm") {
        done()
        return
      }
      const id = this.assignDialog.id
      const leadTeacherId = this.assignDialog.leadTeacherId
      const assistantTeacherIds = (Array.isArray(this.assignDialog.assistantTeacherIds) ? this.assignDialog.assistantTeacherIds : [])
        .filter(x => x !== null && x !== undefined && x !== "")
      if (!id) return done(false)
      if (leadTeacherId === null || leadTeacherId === undefined || leadTeacherId === "") {
        Toast.fail("请选择主课老师")
        done(false)
        return
      }
      const payload = {
        id,
        leadTeacherId,
        assistantTeacherIds
      }
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await assignTeacher(payload)
        this.applyAssignTeacherToLocal(id, leadTeacherId, assistantTeacherIds)
        Toast.clear()
        Toast.success("分配成功")
        done()
        this.assignAssistantTeacherPopup.show = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
        done(false)
      }
    },
    async openComplete(it, options = {}) {
      const isExpansionFlow = options.parentCustomerId !== null && options.parentCustomerId !== undefined && options.parentCustomerId !== ""
      if (isExpansionFlow) {
        await this.ensureExpansionCourseOptions()
        if (!this.expansionCourseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      } else {
        await this.ensureCourseOptions()
        if (!this.courseOptions.length) {
          Toast.fail("暂无课程选项")
          return
        }
      }
      const now = new Date()
      this.completeDialog = {
        show: true,
        id: it.id,
        parentCustomerId: options.parentCustomerId ?? null,
        hostStaffId: it.hostStaffId ?? null,
        hostStaffName: (it.hostStaffName || "").trim(),
        amount: this.formatAmountInputValue(it.amount),
        courseId: it?.courseId ?? null,
        courseName: (it?.courseName || "").trim(),
        completeTime: formatDateTime(now),
        bookIds: [],
        isOrderIncomeConfirm: this.isOrderIncomeConfirmed(it),
        paymentMethod: it.paymentMethod ?? null,
        performanceAmount:
          it.performanceAmount === null || it.performanceAmount === undefined ? "" : String(it.performanceAmount),
        headcount: 1,
        projectId: null
      }
      this.completeBookOptions = []
      this.completeTimePicker.value = now
      if (this.isCompleteMdCourse) {
        await this.loadCompleteBooks()
      }
    },
    async openCompleteHostPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.completeHost = ""
      this.completeHostPicker.show = true
    },
    onConfirmCompleteHost(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCompleteHostOptions)
      if (opt) this.completeDialog.hostStaffId = opt.value
      this.completeHostPicker.show = false
    },
    async submitComplete() {
      if (this.completeSubmitting) return
      const payload = this.buildCompletePayload()
      if (!payload) return
      this.completeSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await completeCustomer(payload)
        Toast.clear()
        Toast.success("成单成功")
        this.completeDialog.show = false
        await this.refreshAfterFlowSubmit(this.completeDialog.parentCustomerId)
      } catch (e) {
        Toast.clear()
      } finally {
        this.completeSubmitting = false
      }
    },
    parseClassmateItemsFromRaw(raw) {
      if (raw === null || raw === undefined || raw === "") return []
      let list = raw
      if (typeof raw === "string") {
        const s = raw.trim()
        if (!s) return []
        if (s.startsWith("[") && s.endsWith("]")) {
          try {
            list = JSON.parse(s)
          } catch (e) {
            return []
          }
        } else {
          return s
            .split(",")
            .map(x => x.trim())
            .filter(Boolean)
            .map(id => ({ id: String(id), name: String(id) }))
        }
      }
      if (!Array.isArray(list) || !list.length) return []
      return list
        .map(item => {
          if (!item || typeof item !== "object") {
            if (item !== null && item !== undefined && item !== "") {
              return { id: String(item), name: String(item) }
            }
            return null
          }
          const id = item.id ?? item.studentId ?? item.classmateId
          const name = (item.name ?? item.stuName ?? item.studentName ?? "").trim()
          if (id === null || id === undefined || id === "") {
            return name ? { id: "", name } : null
          }
          const idStr = String(id)
          return { id: idStr, name: name || idStr }
        })
        .filter(x => x && (x.id || x.name))
    },
    parseClassmateList(row) {
      const fromIds = this.parseClassmateItemsFromRaw(row?.classmateIds)
      if (fromIds.length) return fromIds
      const raw = row?.classmateList ?? row?.classmates ?? row?.classmateVoList
      const fromList = this.parseClassmateItemsFromRaw(raw)
      if (fromList.length) return fromList
      const nameMap = row?.classmateNameMap
      const ids = this.normalizeIdArray(row?.classmateIds)
      if (nameMap && typeof nameMap === "object" && !Array.isArray(nameMap) && ids.length) {
        return ids.map(id => ({
          id: String(id),
          name: (nameMap[String(id)] || String(id)).trim()
        }))
      }
      const namesRaw = row?.classmateNames
      if (Array.isArray(namesRaw) && namesRaw.length) {
        return namesRaw
          .map((n, i) => {
            const name = String(n || "").trim()
            if (!name) return null
            return { id: ids[i] || "", name }
          })
          .filter(Boolean)
      }
      if (typeof namesRaw === "string" && namesRaw.trim()) {
        return namesRaw
          .split(/[,、]/)
          .map(n => ({ name: n.trim() }))
          .filter(x => x.name)
      }
      return []
    },
    classmateItemsToPayloadIds(items) {
      return (Array.isArray(items) ? items : [])
        .map(x => (x?.id != null && x.id !== "" ? String(x.id) : ""))
        .filter(Boolean)
    },
    formatClassmateNamesDisplay(row) {
      const list = this.parseClassmateList(row)
      if (!list.length) return "-"
      const names = list.map(x => (x.name || "").trim()).filter(Boolean)
      return names.length ? names.join("、") : "-"
    },
    buildConfirmClassFormFromRow(it, options = {}) {
      const today = formatDate(new Date())
      const classmateParsed = this.parseClassmateList(it)
      const classmateIds = this.classmateItemsToPayloadIds(classmateParsed)
      const classmateNameMap = {}
      classmateParsed.forEach(x => {
        if (x.id) classmateNameMap[String(x.id)] = x.name
      })
      classmateIds.forEach(id => {
        if (!classmateNameMap[String(id)]) classmateNameMap[String(id)] = String(id)
      })
      const courseStatus = it?.courseStatus
      const form = {
        id: it?.id ?? null,
        parentCustomerId: options.parentCustomerId ?? null,
        leadTeacherId: it?.leadTeacherId ?? null,
        leadTeacherName: (it?.leadTeacherName || "").trim(),
        assistantTeacherIds: this.normalizeIdArray(it?.assistantTeacherIds),
        classmateIds,
        classmateNameMap,
        confirmStartDate: (it?.confirmStartDate || "").trim() || today,
        firstClassDate: (it?.firstClassDate || "").trim() || today,
        courseStatus:
          courseStatus === null || courseStatus === undefined || courseStatus === "" ? 1 : Number(courseStatus),
        startUnit: (it?.startUnit || "").trim(),
        coursePackages: this.normalizeCoursePackagesForForm(it)
      }
      if (!form.leadTeacherName && form.leadTeacherId) {
        form.leadTeacherName = this.getStaffNameById(form.leadTeacherId)
      }
      return form
    },
    async openConfirmClass(it, options = {}) {
      const s = Number(it?.status)
      if (!Number.isFinite(s) || s < 4) return Toast.fail("请先完成成单")
      if (!it?.id) return Toast.fail("缺少订单ID")
      await this.ensureStaffOptions()
      this.confirmClassDialog.show = true
      this.confirmClassDialog.submitting = false
      this.confirmClassDialog.form = this.buildConfirmClassFormFromRow(it, options)
    },
    openConfirmClassDatePicker(field, title) {
      const raw = (this.confirmClassDialog.form[field] || "").trim()
      const base = parseDateSafe(raw) || new Date()
      this.confirmClassDatePicker.field = field
      this.confirmClassDatePicker.title = title
      this.confirmClassDatePicker.value = base
      this.confirmClassDatePicker.show = true
    },
    onConfirmConfirmClassDate(value) {
      const dt = value instanceof Date ? value : new Date(value)
      const field = this.confirmClassDatePicker.field
      if (field) this.confirmClassDialog.form[field] = formatDate(dt)
      this.confirmClassDatePicker.show = false
    },
    onConfirmConfirmClassCourseStatus(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, CONFIRM_CLASS_COURSE_STATUS_OPTIONS)
      if (opt) this.confirmClassDialog.form.courseStatus = opt.value
      this.confirmClassCourseStatusPicker.show = false
    },
    getConfirmClassStudentRowId(stu) {
      const id = stu?.studentId ?? stu?.id
      return id === null || id === undefined || id === "" ? "" : String(id)
    },
    buildConfirmClassClassmateLabel(stu) {
      return (stu?.stuName || "").trim() || "-"
    },
    openConfirmClassClassmatePicker() {
      this.confirmClassClassmatePicker.show = true
      if (!this.confirmClassClassmatePicker.list.length) this.searchConfirmClassClassmates()
    },
    isConfirmClassClassmateSelected(studentId) {
      const id = studentId === null || studentId === undefined || studentId === "" ? "" : String(studentId)
      if (!id) return false
      return this.normalizeIdArray(this.confirmClassDialog.form.classmateIds).includes(id)
    },
    toggleConfirmClassClassmate(stu) {
      const studentId = this.getConfirmClassStudentRowId(stu)
      if (!studentId) return
      const currentId = String(this.confirmClassDialog.form.id || "")
      if (studentId === currentId) return
      const ids = this.normalizeIdArray(this.confirmClassDialog.form.classmateIds)
      const map = { ...(this.confirmClassDialog.form.classmateNameMap || {}) }
      const idx = ids.findIndex(x => String(x) === studentId)
      if (idx >= 0) {
        ids.splice(idx, 1)
        delete map[studentId]
      } else {
        ids.push(studentId)
        map[studentId] = this.buildConfirmClassClassmateLabel(stu)
      }
      this.confirmClassDialog.form.classmateIds = ids
      this.confirmClassDialog.form.classmateNameMap = map
    },
    confirmConfirmClassClassmatePicker() {
      this.confirmClassClassmatePicker.show = false
    },
    onConfirmClassClassmateKeywordInput() {
      if (this.confirmClassClassmatePicker.keywordTimer) clearTimeout(this.confirmClassClassmatePicker.keywordTimer)
      this.confirmClassClassmatePicker.keywordTimer = setTimeout(() => this.searchConfirmClassClassmates(), 350)
    },
    async searchConfirmClassClassmates() {
      this.confirmClassClassmatePicker.loading = true
      try {
        const keyword = (this.confirmClassClassmatePicker.keyword || "").trim()
        const res = await fetchCustomerList({
          displayStart: 1,
          displayLength: 50,
          allName: keyword || undefined,
          statusList: CUSTOMER_STATUS_LIST_EXCLUDE_CANCELLED,
          topDepartmentId: this.topDepartmentId || undefined
        })
        const list = Array.isArray(res?.data) ? res.data : []
        const currentId = String(this.confirmClassDialog.form.id || "")
        this.confirmClassClassmatePicker.list = list.filter(x => String(x.id ?? x.studentId) !== currentId)
      } catch (e) {
        this.confirmClassClassmatePicker.list = []
      } finally {
        this.confirmClassClassmatePicker.loading = false
      }
    },
    clearConfirmClassClassmates() {
      this.confirmClassDialog.form.classmateIds = []
      this.confirmClassDialog.form.classmateNameMap = {}
    },
    buildConfirmClassPayload() {
      const form = this.confirmClassDialog.form
      const id = form.id
      const leadTeacherId = form.leadTeacherId
      const confirmStartDate = (form.confirmStartDate || "").trim()
      const firstClassDate = (form.firstClassDate || "").trim()
      const courseStatus = Number(form.courseStatus)
      const startUnit = (form.startUnit || "").trim()
      if (!id) {
        Toast.fail("缺少订单ID")
        return null
      }
      if (leadTeacherId === null || leadTeacherId === undefined || leadTeacherId === "") {
        Toast.fail("请选择主课老师")
        return null
      }
      if (!confirmStartDate) {
        Toast.fail("请选择确认开课日期")
        return null
      }
      if (!firstClassDate) {
        Toast.fail("请选择第一次上课日期")
        return null
      }
      if (!Number.isFinite(courseStatus) || courseStatus < 1 || courseStatus > 8) {
        Toast.fail("请选择开课状态")
        return null
      }
      const payload = {
        id,
        leadTeacherId,
        assistantTeacherIds: this.normalizeIdArray(form.assistantTeacherIds),
        classmateIds: this.normalizeIdArray(form.classmateIds),
        confirmStartDate,
        firstClassDate,
        courseStatus,
        startUnit: startUnit || undefined
      }
      if (!this.appendCoursePackagesPayload(payload, form.coursePackages)) return null
      return payload
    },
    openNotStudyingFromDetail() {
      if (!this.detailItem?.id) return Toast.fail("缺少学员信息")
      this.openNotStudyingDialog(this.detailItem)
    },
    openActivateFromDetail() {
      if (!this.detailItem?.id) return Toast.fail("缺少学员信息")
      this.openActivateDialog(this.detailItem)
    },
    openNotStudyingDialog(row) {
      const id = row?.id
      if (id === null || id === undefined || id === "") return Toast.fail("缺少ID")
      this.notStudyingDialog.recordId = id
      this.notStudyingDialog.studentName = (row.stuName || "").trim() || "-"
      this.notStudyingDialog.submitting = false
      this.notStudyingDialog.form = {
        courseStatus: null,
        statusDate: formatDate(new Date()),
        remark: ""
      }
      this.notStudyingDialog.show = true
    },
    onConfirmNotStudyingCourseStatus(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, NOT_STUDYING_COURSE_STATUS_OPTIONS)
      if (opt) this.notStudyingDialog.form.courseStatus = opt.value
      this.notStudyingCourseStatusPicker.show = false
    },
    openNotStudyingDatePicker() {
      const raw = (this.notStudyingDialog.form.statusDate || "").trim()
      this.notStudyingDatePicker.value = parseDateSafe(raw) || new Date()
      this.notStudyingDatePicker.show = true
    },
    onConfirmNotStudyingDate(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.notStudyingDialog.form.statusDate = formatDate(dt)
      this.notStudyingDatePicker.show = false
    },
    buildNotStudyingPayload() {
      const id = this.notStudyingDialog.recordId
      const courseStatus = Number(this.notStudyingDialog.form.courseStatus)
      const statusDate = (this.notStudyingDialog.form.statusDate || "").trim()
      const remark = (this.notStudyingDialog.form.remark || "").trim()
      if (id === null || id === undefined || id === "") {
        Toast.fail("缺少ID")
        return null
      }
      if (!Number.isFinite(courseStatus) || courseStatus < 2 || courseStatus > 5) {
        Toast.fail("请选择状态")
        return null
      }
      if (!statusDate) {
        Toast.fail("请选择生效日期")
        return null
      }
      return {
        id,
        courseStatus,
        statusDate,
        remark: remark || undefined
      }
    },
    async submitNotStudying() {
      if (this.notStudyingDialog.submitting) return
      const payload = this.buildNotStudyingPayload()
      if (!payload) return
      const recordId = payload.id
      this.notStudyingDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await submitCourseStatus(payload)
        Toast.clear()
        Toast.success("提交成功")
        this.notStudyingDialog.show = false
        const statusName = this.resolveCourseStatusName(payload.courseStatus)
        this.applyCustomerRecordPatchToLocal(recordId, {
          courseStatus: payload.courseStatus,
          courseStatusName: statusName || undefined,
          statusDate: payload.statusDate
        })
        await this.refreshCustomerDetail(recordId)
      } catch (e) {
        /* 错误提示由 request 拦截器展示，勿 clear 以免一闪而过 */
      } finally {
        this.notStudyingDialog.submitting = false
      }
    },
    async openActivateDialog(row) {
      const id = row?.id
      if (id === null || id === undefined || id === "") return Toast.fail("缺少ID")
      await this.ensureChannelOptions()
      const nextDayNine = getNextDayNineAM()
      this.activateDialog.recordId = id
      this.activateDialog.studentName = (row.stuName || "").trim() || "-"
      this.activateDialog.submitting = false
      this.activateDialog.form = {
        channelType: null,
        channelStaffId: null,
        bookingTime: formatDateTime(nextDayNine)
      }
      this.activateTimePicker.value = nextDayNine
      this.activateDialog.show = true
    },
    openActivateTimePicker() {
      const raw = (this.activateDialog.form.bookingTime || "").trim()
      const dt = raw ? new Date(String(raw).replace(/-/g, "/")) : new Date()
      this.activateTimePicker.value = Number.isNaN(dt.getTime()) ? new Date() : dt
      this.activateTimePicker.show = true
    },
    onConfirmActivateTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.activateDialog.form.bookingTime = formatDateTime(dt)
      this.activateTimePicker.show = false
    },
    async openActivateChannelPicker() {
      await this.ensureChannelOptions()
      if (!this.channelOptions.length) return Toast.fail("暂无渠道选项")
      this.activateChannelPicker.show = true
    },
    onConfirmActivateChannel(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.channelOptions)
      if (opt) this.activateDialog.form.channelType = opt.value
      this.activateChannelPicker.show = false
    },
    async openActivateChannelStaffPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.activateChannel = ""
      this.activateChannelStaffPicker.show = true
    },
    onConfirmActivateChannelStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredActivateChannelStaffOptions)
      if (opt) this.activateDialog.form.channelStaffId = opt.value
      this.activateChannelStaffPicker.show = false
    },
    clearActivateChannelStaff() {
      this.activateDialog.form.channelStaffId = null
    },
    buildActivatePayload() {
      const id = this.activateDialog.recordId
      const bookingTime = (this.activateDialog.form.bookingTime || "").trim()
      if (id === null || id === undefined || id === "") {
        Toast.fail("缺少ID")
        return null
      }
      if (!bookingTime) {
        Toast.fail("请选择预约时间")
        return null
      }
      const payload = { id, bookingTime }
      const channelType = this.activateDialog.form.channelType
      if (channelType !== null && channelType !== undefined && channelType !== "") {
        payload.channelType = channelType
      }
      const channelStaffId = this.activateDialog.form.channelStaffId
      if (channelStaffId !== null && channelStaffId !== undefined && channelStaffId !== "") {
        payload.channelStaffId = channelStaffId
      }
      return payload
    },
    async submitActivate() {
      if (this.activateDialog.submitting) return
      const payload = this.buildActivatePayload()
      if (!payload) return
      const recordId = payload.id
      this.activateDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await activateCustomer(payload)
        Toast.clear()
        Toast.success("激活成功")
        this.activateDialog.show = false
        this.applyCustomerRecordPatchToLocal(recordId, {
          courseStatus: 1,
          courseStatusName: this.resolveCourseStatusName(1) || "还在学",
          bookingTime: payload.bookingTime,
          status: 1
        })
        await this.refreshCustomerDetail(recordId)
      } catch (e) {
        /* 错误提示由 request 拦截器展示，勿 clear 以免一闪而过 */
      } finally {
        this.activateDialog.submitting = false
      }
    },
    async submitConfirmClass() {
      if (this.confirmClassDialog.submitting) return
      const payload = this.buildConfirmClassPayload()
      if (!payload) return
      const form = this.confirmClassDialog.form
      this.confirmClassDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await confirmClassCustomer(payload)
        Toast.clear()
        Toast.success("开课成功")
        this.confirmClassDialog.show = false
        const orderId = payload.id
        const parentCustomerId = form.parentCustomerId
        if (!parentCustomerId) {
          const classmateItems = payload.classmateIds.map(id => ({
            id: String(id),
            name: (form.classmateNameMap?.[String(id)] || "").trim() || String(id)
          }))
          this.applyConfirmClassToLocal(orderId, {
            leadTeacherId: payload.leadTeacherId,
            leadTeacherName: (form.leadTeacherName || "").trim(),
            assistantTeacherIds: [...payload.assistantTeacherIds],
            classmateIds: classmateItems,
            confirmStartDate: payload.confirmStartDate,
            firstClassDate: payload.firstClassDate,
            courseStatus: payload.courseStatus,
            startUnit: payload.startUnit
          })
        }
        await this.refreshAfterFlowSubmit(parentCustomerId)
        if (!parentCustomerId && this.detailDialog.show && String(this.detailItem?.id) === String(orderId)) {
          const hit = this.items.find(x => String(x.id) === String(orderId))
          if (hit) this.detailItem = { ...hit }
        }
      } catch (e) {
        Toast.clear()
      } finally {
        this.confirmClassDialog.submitting = false
      }
    },
    async beforeCloseComplete(action, done) {
      if (action !== "confirm") {
        done()
        return
      }
      const payload = this.buildCompletePayload()
      if (!payload) {
        done(false)
        return
      }
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await completeCustomer(payload)
        Toast.clear()
        Toast.success("成单成功")
        done()
        await this.refreshAfterFlowSubmit(this.completeDialog.parentCustomerId)
      } catch (e) {
        Toast.clear()
        done(false)
      }
    },
    async doCancel(it) {
      await Dialog.confirm({
        title: "确认作废？",
        message: `${it.name || "-"}（${it.mobile || "-"}）`
      })
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await cancelBooking(it.id)
        Toast.clear()
        Toast.success("已作废")
        this.onRefresh()
        return true
      } catch (e) {
        Toast.clear()
        return false
      }
    },
    async doCancelFromDetail() {
      const ok = await this.doCancel(this.detailItem)
      if (ok) this.detailDialog.show = false
    },
    normalizeDictionaryRows(raw) {
      let list = []
      if (Array.isArray(raw)) list = raw
      else if (raw && Array.isArray(raw.data)) list = raw.data
      else if (raw && Array.isArray(raw.list)) list = raw.list
      else if (raw && Array.isArray(raw.records)) list = raw.records
      return list
        .map(item => {
          // 渠道字典优先按 { code, value } 解析：展示 value，提交 code
          const text =
            item.value ?? item.name ?? item.label ?? item.dictLabel ?? item.text ?? item.title ?? ""
          const value = item.code ?? item.dictValue ?? item.id ?? item.key ?? item.value
          return { text: String(text), value }
        })
        .filter(
          x =>
            x.text !== "" &&
            x.value !== undefined &&
            x.value !== null &&
            x.value !== ""
        )
    },
    async ensureChannelOptions() {
      if (this.channelOptions.length || this.channelLoading) return
      this.channelLoading = true
      try {
        const res = await fetchDictionary(CHANNEL_DICT_TYPE_ID)
        this.channelOptions = this.normalizeDictionaryRows(res)
      } finally {
        this.channelLoading = false
      }
    },
    async openChannelPicker() {
      await this.ensureChannelOptions()
      if (!this.channelOptions.length) {
        Toast.fail("暂无渠道选项")
        return
      }
      this.channelPicker.show = true
    },
    onConfirmChannel(values, indexes) {
      let opt = null
      if (Number.isInteger(indexes) && this.channelOptions[indexes]) {
        opt = this.channelOptions[indexes]
      } else if (Array.isArray(indexes) && indexes.length && this.channelOptions[indexes[0]]) {
        opt = this.channelOptions[indexes[0]]
      } else if (Array.isArray(values) && values.length) {
        const v = values[0]
        if (v && typeof v === "object" && "value" in v) opt = v
        else opt = this.channelOptions.find(o => String(o.value) === String(v))
      } else if (values && typeof values === "object" && "value" in values) {
        opt = values
      } else if (values !== undefined && values !== null && values !== "") {
        opt = this.channelOptions.find(o => String(o.value) === String(values) || String(o.text) === String(values))
      }
      if (opt) this.bookingForm.channelType = opt.value
      this.channelPicker.show = false
    },
    openBooking() {
      this.bookingPopup = true
      this.bookingForm = {
        name: "",
        mobile: "",
        stuName: "",
        birthDate: "",
        age: "",
        gender: null,
        channelType: null,
        channelStaffId: null,
        remark: ""
      }
      this.ensureChannelOptions()
    },
    async submitBooking() {
      if (this.bookingSubmitting) return
      const birthDate = (this.bookingForm.birthDate || "").trim()
      const ageNum = calcAgeByBirthDate(birthDate)
      const parentName = (this.bookingForm.name || "").trim()
      const csId = this.bookingForm.channelStaffId
      const payload = {
        name: parentName || undefined,
        mobile: this.bookingForm.mobile,
        stuName: (this.bookingForm.stuName || "").trim(),
        birthDate: birthDate || undefined,
        channelType: this.bookingForm.channelType,
        remark: (this.bookingForm.remark || "").trim() || undefined,
        gender: this.bookingForm.gender || undefined
      }
      if (csId !== null && csId !== undefined && csId !== "") {
        payload.channelStaffId = csId
      }
      if (!payload.stuName) {
        Toast.fail("请输入学员名")
        return
      }
      const mobile = (payload.mobile || "").trim()
      if (!mobile) {
        Toast.fail("请输入手机号")
        return
      }
      let hasDuplicateMobile = false
      try {
        const validateRes = await validateCustomerMobile(mobile)
        hasDuplicateMobile =
          validateRes === true ||
          validateRes === "true" ||
          validateRes === 1 ||
          validateRes === "1" ||
          validateRes?.data === true ||
          validateRes?.result === true
      } catch (e) {
        return
      }
      if (hasDuplicateMobile) {
        try {
          await Dialog.confirm({
            title: "手机号已存在",
            message: "检测到存在相同手机号学员，是否仍要保存？",
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          })
        } catch (e) {
          return
        }
      }
      if (ageNum !== null) {
        payload.age = ageNum
      }
      this.bookingSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await createCustomerInput(payload)
        Toast.clear()
        Toast.success("新增成功")
        this.bookingPopup = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.bookingSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f7f8fa;
  --mg-orange: rgb(242, 124, 52);
  --mg-green: rgb(146, 186, 63);
  --mg-pink: rgb(214, 93, 140);
  --mg-cyan: rgb(74, 178, 194);
}

/* iOS聚焦输入框时，字号小于16会触发页面缩放，表现为“弹框变大” */
:deep(.van-field__control),
:deep(.van-cell__value),
:deep(.van-field__body input),
:deep(.van-field__body textarea) {
  font-size: 16px;
}

.top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.top :deep(.van-tabs__wrap) {
  position: relative;
  z-index: 1;
}

.date-filter {
  padding: 0 12px 4px;
  background: #fff;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 2px;
}

.date-label {
  font-size: 13px;
  color: #969799;
  flex: 0 0 auto;
}

.date-label-select {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #f27c34;
  border: 1px solid rgba(242, 124, 52, 0.45);
  border-radius: 999px;
  padding: 1px 8px;
  background: rgba(242, 124, 52, 0.08);
}

.date-label-select-icon {
  font-size: 11px;
}

.date-value {
  font-size: 13px;
  color: #323233;
  padding: 1px 5px;
  border-radius: 6px;
  background: #f7f8fa;
}

.date-sep {
  color: #969799;
  flex: 0 0 auto;
}

.date-clear {
  margin-left: 6px;
  font-size: 12px;
  color: rgb(242, 124, 52);
  flex: 0 0 auto;
}

.field-clear-btn {
  font-size: 12px;
  color: rgb(242, 124, 52);
  padding: 0 4px;
  flex: 0 0 auto;
}

.list-total-bar {
  position: absolute;
  right: 12px;
  bottom: 44px;
  z-index: 2;
  padding: 0;
  background: transparent;
  pointer-events: none;
}

.list-total-text {
  font-size: 13px;
  font-weight: 500;
  color: #323233;
  line-height: 1;
}

.list-total-num {
  font-size: 15px;
  font-weight: 700;
  color: rgb(242, 124, 52);
}

.list {
  padding-top: 180px; /* fixed top: search + 4 filter rows + tabs */
  padding-bottom: calc(150px + var(--app-safe-area-bottom, 0px)); /* action-bar + tabbar + safe-area */
}

.records-wrap {
  margin-top: 8px;
  padding: 0 12px;
}

.empty {
  padding: 44px 0;
  background: transparent;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--app-tabbar-offset, 50px);
  padding: 10px 12px;
  background: #fff;
  box-shadow: 0 -6px 16px rgba(0, 0, 0, 0.06);
  z-index: 1000;
}

:deep(.van-button--primary) {
  background: var(--mg-orange);
  border-color: var(--mg-orange);
}

:deep(.van-button--primary.van-button--plain) {
  color: var(--mg-orange);
  background: #fff;
}

:deep(.van-tab--active) {
  color: var(--mg-orange);
}

:deep(.van-tabs__line) {
  background: var(--mg-orange);
}

:deep(.van-tabs__wrap) {
  height: 34px;
}

.status-tag {
  border: 1px solid transparent;
  font-size: 12px;
  padding: 0 6px;
  line-height: 18px;
}

.status-booking {
  color: var(--mg-orange);
  background: rgba(242, 124, 52, 0.12);
  border-color: rgba(242, 124, 52, 0.35);
}

.status-pending {
  color: #6b7280;
  background: rgba(107, 114, 128, 0.12);
  border-color: rgba(107, 114, 128, 0.35);
}

.status-expired {
  color: #b76e00;
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.36);
}

.status-arrive {
  color: var(--mg-cyan);
  background: rgba(74, 178, 194, 0.12);
  border-color: rgba(74, 178, 194, 0.35);
}

.status-check-result {
  color: #6f7ff2;
  background: rgba(111, 127, 242, 0.12);
  border-color: rgba(111, 127, 242, 0.35);
}

.status-deal {
  color: var(--mg-green);
  background: rgba(146, 186, 63, 0.14);
  border-color: rgba(146, 186, 63, 0.38);
}

.status-confirm-class {
  color: #0d9488;
  background: rgba(13, 148, 136, 0.12);
  border-color: rgba(13, 148, 136, 0.35);
}

.status-cancel {
  color: var(--mg-pink);
  background: rgba(214, 93, 140, 0.12);
  border-color: rgba(214, 93, 140, 0.35);
}

.card {
  padding: 12px 14px 12px;
  margin: 0 0 10px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(74, 178, 194, 0.14);
  box-shadow: 0 4px 12px rgba(30, 35, 90, 0.05);
  cursor: pointer;
}

.student-swipe-cell {
  margin-bottom: 0;
}

.student-swipe-cell :deep(.van-swipe-cell__right) {
  display: flex;
  align-items: stretch;
}

.student-delete-swipe-btn {
  height: 100%;
  min-width: 72px;
  border: none;
}

.booking-card {
  --accent-color: rgba(150, 151, 153, 0.55);
  --accent-wash: rgba(150, 151, 153, 0.1);
  position: relative;
  overflow: hidden;
  padding-left: 24px;
}

.booking-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(90deg, var(--accent-wash) 0%, rgba(255, 255, 255, 0) 100%);
}

.booking-card::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 9px;
  bottom: 9px;
  width: 4px;
  border-radius: 999px;
  background: var(--accent-color);
}

.booking-card.status-booking {
  --accent-color: rgba(242, 124, 52, 0.72);
  --accent-wash: rgba(242, 124, 52, 0.12);
}

.booking-card.status-pending {
  --accent-color: rgba(107, 114, 128, 0.65);
  --accent-wash: rgba(107, 114, 128, 0.12);
}

.booking-card.status-expired {
  --accent-color: rgba(245, 158, 11, 0.72);
  --accent-wash: rgba(245, 158, 11, 0.12);
}

.booking-card.status-arrive {
  --accent-color: rgba(74, 178, 194, 0.72);
  --accent-wash: rgba(74, 178, 194, 0.12);
}

.booking-card.status-check-result {
  --accent-color: rgba(111, 127, 242, 0.72);
  --accent-wash: rgba(111, 127, 242, 0.12);
}

.booking-card.status-deal {
  --accent-color: rgba(146, 186, 63, 0.76);
  --accent-wash: rgba(146, 186, 63, 0.12);
}

.booking-card.status-cancel {
  --accent-color: rgba(214, 93, 140, 0.72);
  --accent-wash: rgba(214, 93, 140, 0.12);
}

.booking-card.status-confirm-class {
  --accent-color: rgba(13, 148, 136, 0.72);
  --accent-wash: rgba(13, 148, 136, 0.12);
}

.booking-card-top .status-tag.status-confirm-class {
  max-width: 46%;
  white-space: normal;
  line-height: 1.25;
  text-align: right;
}

.booking-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.booking-student {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.booking-student-name {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.booking-student-age {
  font-size: 13px;
  color: #969799;
  flex: 0 0 auto;
}

.booking-student-gender {
  font-size: 12px;
  color: #969799;
  flex: 0 0 auto;
}

.booking-student-channel {
  font-size: 12px;
  color: #969799;
  flex: 0 0 auto;
  margin-left: 8px;
}

.booking-parent {
  margin-top: 8px;
  font-size: 13px;
  color: #646566;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.booking-parent-label {
  color: #969799;
  flex: 0 0 auto;
}

.booking-parent-name {
  color: #323233;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.booking-parent-mobile {
  color: #323233;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.booking-remark {
  margin-top: 8px;
  font-size: 13px;
  color: #8c8f96;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
  font-size: 13px;
  color: #646566;
}

.label {
  color: #969799;
  margin-right: 12px;
  flex: 0 0 auto;
}

.value {
  text-align: right;
  flex: 1 1 auto;
}

.flow-actions {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f2f3f5;
  display: flex;
}

.flow-step {
  flex: 1 1 0;
  min-width: 0;
  height: 32px;
  font-size: 11px;
  border: none;
  color: #8c8f96;
  font-size: 12px;
  font-weight: 600;
  background: #e7e8ec;
  position: relative;
  cursor: pointer;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%);
}

.flow-step:first-child {
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%);
}

.flow-step:last-child {
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 12px 50%);
}

.flow-step.active {
  color: #fff;
  background: var(--mg-orange);
}

.flow-step:disabled {
  opacity: 1;
}

.list-expansion-block {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #ebedf0;
}

.list-expansion-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 2px;
}

.list-expansion-name {
  color: var(--mg-orange);
  font-weight: 600;
  flex: 1;
  min-width: 0;
}

.list-expansion-status {
  flex-shrink: 0;
}

.list-expansion-flow {
  margin-top: 8px;
  padding-top: 0;
  border-top: none;
}

.dialog-body {
  padding: 8px 0;
}

:deep(.detail-dialog-popup.van-popup) {
  height: 100%;
  max-height: 100%;
}

:deep(.detail-dialog-popup.van-popup--bottom) {
  height: 100vh;
  max-height: 100vh;
}

.detail-popup {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #f6f7fb;
  overflow: hidden;
}

.detail-popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 12px;
  background: #f6f7fb;
}

.detail-popup-title {
  font-size: 26px;
  font-weight: 700;
  color: #323233;
}

.detail-popup-close {
  font-size: 22px;
  color: #7d7f86;
}

.detail-popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 14px 20px;
}

.detail-main-card {
  position: relative;
  background: #f2f2ee;
  border-radius: 14px;
  padding: 16px 14px 12px;
}

.detail-main-status {
  position: absolute;
  right: 12px;
  top: 12px;
}

.detail-student {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.detail-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #6f9768;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-student-name {
  font-size: 24px;
  font-weight: 700;
  color: #323233;
  line-height: 1.1;
}

.detail-student-age {
  font-size: 14px;
  color: #7d7f86;
}

.detail-student-gender {
  margin-top: 2px;
  font-size: 14px;
  color: #7d7f86;
}

.detail-student-birth {
  font-size: 14px;
  color: #7d7f86;
}

.detail-student-age-birth {
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-kv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 16px;
}

.detail-kv-label {
  color: #7d7f86;
}

.detail-kv-value {
  color: #323233;
  font-weight: 600;
  text-align: right;
  margin-left: 10px;
}

.detail-section-title {
  margin: 16px 2px 10px;
  font-size: 16px;
  color: #323233;
  font-weight: 700;
}

.detail-info-list {
  background: #fff;
  border-radius: 10px;
  padding: 8px 12px;
}

.detail-info-list .detail-kv {
  margin-top: 0;
  padding: 6px 0;
}

.detail-remark-block {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  min-height: 68px;
  color: #595b62;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-all;
}

.detail-record-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-record-card {
  background: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid #ebedf0;
}

.detail-record-title {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #374151;
}

.detail-renew-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  background: #fff;
  border-radius: 10px;
  color: #969799;
  font-size: 14px;
}

.detail-renew-empty {
  color: #969799;
}

.detail-renew-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-renew-card {
  background: #fff;
  border-radius: 10px;
  padding: 10px 12px 8px;
  border: 1px solid rgba(74, 178, 194, 0.18);
}

.detail-renew-card--confirmed {
  border-color: rgba(7, 193, 96, 0.28);
  background: linear-gradient(180deg, rgba(7, 193, 96, 0.05) 0%, #fff 40px);
}

.detail-renew-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f1f3;
}

.detail-renew-card-head-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.detail-renew-status-tag {
  flex-shrink: 0;
  padding: 0 8px;
  font-size: 11px;
  line-height: 18px;
  border-radius: 4px;
}

.detail-renew-status-tag--confirmed {
  color: #07c160;
  background: rgba(7, 193, 96, 0.12);
  border: 1px solid rgba(7, 193, 96, 0.35);
}

.detail-renew-type {
  font-size: 15px;
  font-weight: 700;
  color: var(--mg-cyan);
}

.detail-renew-amount {
  font-size: 16px;
  font-weight: 700;
  color: var(--mg-orange);
}

.detail-renew-body .detail-kv {
  font-size: 14px;
  margin-top: 0;
  padding: 5px 0;
}

.detail-renew-body .detail-kv-remark .detail-kv-value {
  font-weight: 500;
  white-space: pre-wrap;
  word-break: break-all;
}

.detail-renew-card-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f0f1f3;
}

.detail-renew-card-actions .van-button {
  flex: 1;
  height: 34px;
  margin: 0;
}

.detail-renew-btn-edit {
  color: var(--mg-cyan);
  border-color: rgba(74, 178, 194, 0.55);
}

.detail-expansion-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-expansion-card {
  background: #fff;
  border-radius: 10px;
  padding: 10px 12px 8px;
  border: 1px solid rgba(244, 130, 36, 0.22);
}

.detail-expansion-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f1f3;
}

.detail-expansion-type {
  font-size: 15px;
  font-weight: 700;
  color: var(--mg-orange);
}

.detail-expansion-body .detail-kv {
  font-size: 14px;
  margin-top: 0;
  padding: 5px 0;
}

.detail-expansion-body .detail-kv-remark .detail-kv-value {
  font-weight: 500;
  white-space: pre-wrap;
  word-break: break-all;
}

.detail-actions-bar {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #ebedf0;
  background: #fff;
}

.detail-actions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.detail-grid-btn {
  height: 38px;
  margin: 0;
  font-size: 13px;
  padding: 0 4px;
  border-width: 1px;
}

.detail-actions-grid :deep(.detail-btn-again) {
  color: #fff;
  background: #1989fa;
  border-color: #1989fa;
}

.detail-actions-grid :deep(.detail-btn-expansion) {
  color: #fff;
  background: #f48224;
  border-color: #f48224;
}

.detail-actions-grid :deep(.detail-btn-biz) {
  color: #fff;
  background: #92ba3f;
  border-color: #92ba3f;
}

.detail-actions-grid :deep(.detail-btn-edit) {
  color: #fff;
  background: #7c5cfc;
  border-color: #7c5cfc;
}

.detail-actions-grid :deep(.detail-btn-activate) {
  color: #fff;
  background: #4ab2c2;
  border-color: #4ab2c2;
}

.detail-actions-grid :deep(.detail-btn-not-studying) {
  color: #fff;
  background: #969799;
  border-color: #969799;
}

.detail-actions-grid :deep(.detail-btn-void) {
  color: #fff;
  background: var(--mg-pink);
  border-color: var(--mg-pink);
}

.detail-actions-grid :deep(.detail-btn-assign) {
  color: #fff;
  background: var(--mg-orange);
  border-color: var(--mg-orange);
}

.popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ebedf0;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.popup-actions {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebedf0;
  box-sizing: border-box;
}

.booking-popup-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.booking-popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-bottom: 8px;
}

.booking-form {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.personal-performance-field :deep(.van-cell) {
  align-items: center;
}

.personal-performance-field :deep(.van-field__label) {
  display: flex;
  align-items: center;
  line-height: 1.4;
}

.personal-performance-field :deep(.van-field__value) {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.personal-performance-field :deep(.van-field__body) {
  justify-content: flex-start;
}

.update-popup-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.update-popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-bottom: 8px;
}

.update-popup-actions {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebedf0;
  margin-top: auto;
}

.assign-assistant-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.assign-assistant-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 0 8px;
  -webkit-overflow-scrolling: touch;
}

.assign-assistant-actions {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebedf0;
  box-sizing: border-box;
}

.complete-book-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.complete-book-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.complete-book-scroll :deep(.van-cell-group--inset) {
  margin: 0;
}

.complete-book-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 10px;
  background: #fff;
  border-bottom: 1px solid #ebedf0;
}

.complete-book-cell-selected {
  background: rgba(242, 124, 52, 0.12);
}

.complete-book-tip {
  font-size: 12px;
  color: #969799;
}

.complete-book-select-all {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: rgb(242, 124, 52);
}

.complete-book-select-icon {
  font-size: 16px;
  color: rgb(242, 124, 52);
}

.complete-book-actions {
  flex-shrink: 0;
  padding: 10px 16px calc(10px + var(--app-safe-area-bottom, 0px));
  border-top: 1px solid #ebedf0;
  background: #fff;
}

.purchased-books-block {
  margin-top: 8px;
  border: 1px solid #ebedf0;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}

.purchased-books-block--detail {
  margin-top: 4px;
}

.purchased-books-block--renew {
  margin-top: 4px;
}

.purchased-books-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  font-size: 13px;
  color: #646566;
  cursor: pointer;
}

.purchased-books-title {
  flex-shrink: 0;
  color: #323233;
}

.purchased-books-summary {
  flex: 1;
  text-align: right;
  color: #969799;
  font-size: 12px;
}

.purchased-books-arrow {
  flex-shrink: 0;
  font-size: 14px;
  color: #969799;
}

.purchased-books-body {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 10px 8px;
}

.record-book-chip {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 12px;
  font-size: 11px;
  color: rgb(242, 124, 52);
  background: rgba(242, 124, 52, 0.1);
  border: 1px solid rgba(242, 124, 52, 0.2);
}

.purchased-books-empty {
  font-size: 13px;
  color: #969799;
}

.panel-loading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.student-picker-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.student-list-wrap {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 16px;
}

.student-item {
  padding: 12px;
  margin-bottom: 8px;
  background: #f7f8fa;
  border-radius: 8px;
}

.student-item.active {
  background: rgba(242, 124, 52, 0.1);
  border: 1px solid rgba(242, 124, 52, 0.35);
}

.student-item-name {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
}

.student-item-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}

.student-picker-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #ebedf0;
  background: #fff;
  flex-shrink: 0;
}

.student-picker-tip {
  font-size: 14px;
  color: #646566;
  text-align: center;
}

.student-picker-confirm-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 600;
}

.course-packages-section {
  margin: 8px 0 4px;
  padding: 0 4px;
}

.course-packages-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px 8px;
}

.course-packages-title {
  font-size: 14px;
  font-weight: 600;
  color: #323233;
}

.course-packages-add {
  font-size: 13px;
  color: rgb(242, 124, 52);
}

.course-package-card {
  margin-bottom: 8px;
  border-radius: 10px;
  background: #f7f8fa;
  overflow: hidden;
}

.course-package-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
}

.course-package-card-index {
  font-size: 12px;
  font-weight: 600;
  color: #646566;
}

.course-package-remove-btn {
  height: 22px;
  line-height: 20px;
  padding: 0 10px;
  font-size: 12px;
  color: #d65d8c;
  border-color: rgba(214, 93, 140, 0.45);
  background: rgba(214, 93, 140, 0.08);
}

.detail-section-subtitle {
  font-size: 13px;
  font-weight: 600;
  color: #646566;
  margin-bottom: 6px;
}

.detail-course-packages-block {
  padding: 8px 0 4px;
}

.detail-course-packages-block--renew {
  padding: 4px 0 8px;
}

.detail-course-package-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  color: #323233;
  line-height: 1.6;
  padding: 2px 0;
}

.detail-course-package-text {
  flex: 1;
  min-width: 0;
}

.detail-course-package-edit {
  flex: 0 0 auto;
  font-size: 16px;
  color: rgb(242, 124, 52);
  padding: 4px;
}
</style>

